var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to2, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to2, key) && key !== except)
        __defProp(to2, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to2;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faCircleExclamation.js
var require_faCircleExclamation = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faCircleExclamation.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "circle-exclamation";
    var width = 512;
    var height = 512;
    var aliases = ["exclamation-circle"];
    var unicode = "f06a";
    var svgPathData = "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faCircleExclamation = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faFloppyDisk.js
var require_faFloppyDisk = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faFloppyDisk.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "floppy-disk";
    var width = 448;
    var height = 512;
    var aliases = [128190, 128426, "save"];
    var unicode = "f0c7";
    var svgPathData = "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faFloppyDisk = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faArrowsRotate.js
var require_faArrowsRotate = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faArrowsRotate.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "arrows-rotate";
    var width = 512;
    var height = 512;
    var aliases = [128472, "refresh", "sync"];
    var unicode = "f021";
    var svgPathData = "M496 200c0 13.3-10.7 24-24 24h0H360 328c-13.3 0-24-10.7-24-24s10.7-24 24-24h32 54.1l-52.1-52.1C333.8 95.8 295.7 80 256 80c-72.7 0-135.2 44.1-162 107.1c-5.2 12.2-19.3 17.9-31.5 12.7s-17.9-19.3-12.7-31.5C83.9 88.2 163.4 32 256 32c52.5 0 102.8 20.8 139.9 57.9L448 142.1V88l0-.4V56c0-13.3 10.7-24 24-24s24 10.7 24 24V200zM40 288H152c13.3 0 24 10.7 24 24s-10.7 24-24 24H97.9l52.1 52.1C178.2 416.2 216.3 432 256 432c72.6 0 135-43.9 161.9-106.8c5.2-12.2 19.3-17.8 31.5-12.6s17.8 19.3 12.6 31.5C427.8 424 348.5 480 256 480c-52.5 0-102.8-20.8-139.9-57.9L64 369.9V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-13.3 10.7-24 24-24z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faArrowsRotate = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faSun.js
var require_faSun = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faSun.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "sun";
    var width = 512;
    var height = 512;
    var aliases = [9728];
    var unicode = "f185";
    var svgPathData = "M361.5 1.2c5 2.1 8.6 6.6 9.6 11.9L391 121l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L446.9 256l62.3 90.3c3.1 4.5 3.7 10.2 1.6 15.2s-6.6 8.6-11.9 9.6L391 391 371.1 498.9c-1 5.3-4.6 9.8-9.6 11.9s-10.7 1.5-15.2-1.6L256 446.9l-90.3 62.3c-4.5 3.1-10.2 3.7-15.2 1.6s-8.6-6.6-9.6-11.9L121 391 13.1 371.1c-5.3-1-9.8-4.6-11.9-9.6s-1.5-10.7 1.6-15.2L65.1 256 2.8 165.7c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L121 121 140.9 13.1c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6L256 65.1 346.3 2.8c4.5-3.1 10.2-3.7 15.2-1.6zM160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faSun = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/free-solid-svg-icons/faMoon.js
var require_faMoon = __commonJS({
  "../../node_modules/@fortawesome/free-solid-svg-icons/faMoon.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "fas";
    var iconName = "moon";
    var width = 384;
    var height = 512;
    var aliases = [127769, 9214];
    var unicode = "f186";
    var svgPathData = "M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faMoon = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// ../../node_modules/@fortawesome/pro-regular-svg-icons/faSwatchbook.js
var require_faSwatchbook = __commonJS({
  "../../node_modules/@fortawesome/pro-regular-svg-icons/faSwatchbook.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var prefix = "far";
    var iconName = "swatchbook";
    var width = 512;
    var height = 512;
    var aliases = [];
    var unicode = "f5c3";
    var svgPathData = "M0 400c0 61.9 50.1 112 112 112H448c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H385.9l50.7-50.7c25-25 25-65.5 0-90.5L365.3 75.3c-25-25-65.5-25-90.5 0L224 126.1V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V400zm448 64H209.9l128-128H448c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16zM402.7 203.3L224 382.1V193.9l84.7-84.7c6.2-6.2 16.4-6.2 22.6 0l71.4 71.4c6.2 6.2 6.2 16.4 0 22.6zM112 464c-35.3 0-64-28.7-64-64V304H176v96c0 35.3-28.7 64-64 64zM48 256V176H176v80H48zm0-128V64c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16v64H48zm64 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48z";
    exports.definition = {
      prefix,
      iconName,
      icon: [
        width,
        height,
        aliases,
        unicode,
        svgPathData
      ]
    };
    exports.faSwatchbook = exports.definition;
    exports.prefix = prefix;
    exports.iconName = iconName;
    exports.width = width;
    exports.height = height;
    exports.ligatures = aliases;
    exports.unicode = unicode;
    exports.svgPathData = svgPathData;
    exports.aliases = aliases;
  }
});

// src/components/ThemeEditor/ThemeEditor.tsx
import { useEffect as useEffect4 } from "react";

// src/context/Context.tsx
import { createContext, useContext } from "react";
var Context = createContext(void 0);
var useThemeEditor = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error(
      "useThemeEditor must be used within an ThemeEditorProvider"
    );
  }
  return context;
};
var Context_default = Context;

// src/components/DonateComponentModal/DonateComponentModal.tsx
var import_faCircleExclamation = __toESM(require_faCircleExclamation());
var import_faFloppyDisk = __toESM(require_faFloppyDisk());
var import_faArrowsRotate = __toESM(require_faArrowsRotate());
import { useEffect as useEffect3, useState as useState3 } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalDescription,
  ModalFooter,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Button,
  Icon as Icon2,
  Alert,
  AlertDescription
} from "@appcues/sonar-builder";
import { get as get2 } from "object-path-immutable";
import camelCase from "lodash.camelcase";
import startCase from "lodash.startcase";

// src/components/PreviewPane/PreviewPane.tsx
var import_faSun = __toESM(require_faSun());
var import_faMoon = __toESM(require_faMoon());
import { useState as useState2 } from "react";
import {
  SegmentedControlGroup,
  SegmentedControlGroupItem,
  Icon
} from "@appcues/sonar-builder";

// src/lib/preview/style-from.ts
import { get } from "object-path-immutable";
var getTokenValueFromPath = (tokens, path) => get(tokens, path)?.$value;
var resolveTokenValue = (theme, reference, overrideId) => {
  const path = reference.replace(/[{}]/g, "");
  if (overrideId) {
    const overrideTokens = theme.content.overrides?.find(
      ({ id: id2 }) => id2 === overrideId
    )?.tokens;
    if (overrideTokens) {
      const value2 = getTokenValueFromPath(overrideTokens, path);
      if (value2) {
        if (value2.startsWith("{")) {
          return resolveTokenValue(theme, value2);
        }
        return value2;
      }
    }
  }
  const value = getTokenValueFromPath(theme.content.tokens, path);
  if (value) {
    if (value.startsWith("{")) {
      return resolveTokenValue(theme, value);
    }
    return value;
  }
  return reference;
};
var transformValue = (platform, value) => {
  if (platform === "web") {
    return value;
  }
  if (typeof value === "string" && value.endsWith("px")) {
    return Number.parseFloat(value);
  }
  if (value === "100%") {
    return -1;
  }
  return value;
};
var handleMobileFontFamily = (theme, styleObject, overrideId) => {
  const path = styleObject.fontFamily.replace(/[{}]/g, "");
  const tokenObj = get(theme.content.tokens, path);
  const fontExtensions = tokenObj?.$extensions?.["com.appcues.theme.font"];
  const fontWeight = resolveTokenValue(theme, styleObject.fontWeight, overrideId) || "regular";
  const mobileFontName = fontExtensions?.mobile?.[fontWeight];
  return mobileFontName;
};
var styleFrom = (theme, platform, path, overrideId) => {
  const componentStyle = get(theme.content.components, `${path}.$style`);
  const override = theme.content.overrides?.find(({ id: id2 }) => id2 === overrideId);
  const overrideStyle = override ? get(override.components, `${path}.$style`) : void 0;
  if (!componentStyle && !overrideStyle) return {};
  const mergedStyle = {
    ...componentStyle,
    ...overrideStyle
  };
  const resolveStyleTokens = (styleObject) => {
    if (typeof styleObject !== "object" || styleObject === null) {
      return styleObject;
    }
    return Object.entries(styleObject).reduce(
      (acc, [key, value]) => {
        if (platform === "mobile" && key === "fontFamily") {
          const val = handleMobileFontFamily(theme, styleObject, overrideId);
          acc.fontName = val;
          return acc;
        }
        if (typeof value === "string" && value.startsWith("{")) {
          acc[key] = transformValue(
            platform,
            resolveTokenValue(theme, value, overrideId)
          );
        } else if (typeof value === "object") {
          acc[key] = resolveStyleTokens(value);
        } else {
          acc[key] = transformValue(platform, value);
        }
        return acc;
      },
      {}
    );
  };
  return resolveStyleTokens(mergedStyle);
};

// src/lib/preview/make-mobile-experience.ts
var PLATFORM = "mobile";
var stackBlockWrapper = (content) => ({
  type: "stack",
  id: `${content.id}-stack`,
  orientation: "horizontal",
  distribution: "equal",
  items: [
    {
      type: "block",
      blockType: "image",
      id: `${content.id}-block`,
      content
    }
  ]
});
var makeImageRows = (theme) => Object.keys(theme.content.components?.image || {}).map(
  (imageKey) => stackBlockWrapper({
    type: "image",
    id: `image.${imageKey}-image`,
    imageUrl: "https://images.appcues.com/v1658371422/mobile-builder/default-image.jpg",
    style: styleFrom(theme, PLATFORM, `image.${imageKey}`)
  })
);
var makeTextRows = (theme) => Object.keys(theme.content.components?.text || {}).map(
  (textKey) => stackBlockWrapper({
    type: "text",
    id: `text.${textKey}-text`,
    text: `${textKey.charAt(0).toUpperCase() + textKey.slice(1)} text`,
    style: styleFrom(theme, PLATFORM, `text.${textKey}`)
  })
);
var makeButtonRows = (theme) => Object.keys(theme.content.components?.button || {}).map(
  (buttonKey) => stackBlockWrapper({
    type: "button",
    id: `${buttonKey}-button`,
    content: {
      type: "text",
      id: `${buttonKey}-text`,
      text: `${buttonKey.charAt(0).toUpperCase() + buttonKey.slice(1)} Button`,
      style: styleFrom(theme, PLATFORM, `button.${buttonKey}.text`)
    },
    style: styleFrom(theme, PLATFORM, `button.${buttonKey}`)
  })
);
var makeMobileExperience = (theme) => ({
  id: "exp-0",
  name: "POC Modal One",
  type: "mobile",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: [
        {
          type: "@appcues/modal",
          config: {
            presentationStyle: "dialog",
            style: styleFrom(theme, PLATFORM, "container.modal.default")
          }
        },
        {
          type: "@appcues/backdrop",
          config: styleFrom(
            theme,
            PLATFORM,
            "container.modal.default.backdrop"
          )
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              ...makeImageRows(theme),
              ...makeTextRows(theme),
              ...makeButtonRows(theme)
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});
var wrapMobileComponentPreview = ({
  traits,
  block
}) => ({
  id: "exp-0",
  name: "Component",
  type: "mobile_embed",
  tags: [],
  theme: "",
  actions: {},
  traits: [],
  steps: [
    {
      id: "step-group-0",
      type: "group",
      actions: {},
      traits: traits ?? [
        {
          type: "@appcues/embedded",
          config: {
            presentationStyle: "embed"
          }
        }
      ],
      children: [
        {
          id: "step-child-0",
          type: "modal",
          contentType: "application/json",
          content: {
            type: "stack",
            orientation: "vertical",
            id: "main-stack",
            style: {},
            items: [
              block ?? stackBlockWrapper({
                type: "text",
                id: "text-0",
                text: "",
                style: {
                  fontSize: 16,
                  marginTop: 48,
                  marginBottom: 48
                }
              })
            ]
          },
          traits: [],
          actions: {}
        }
      ]
    }
  ]
});

// src/lib/preview/make-web-experience.ts
var PLATFORM2 = "web";
var cellWrapper = (content) => ({
  nodeId: `${content.nodeId}-cell`,
  type: "block",
  version: 1,
  props: {
    blockType: "Cell",
    is: "div",
    style: {
      alignItems: "center",
      boxSizing: "border-box",
      display: "flex",
      flex: 1,
      height: "100%",
      justifyContent: "center",
      paddingBottom: 0,
      paddingInlineEnd: 0,
      paddingInlineStart: 0,
      paddingTop: 0,
      position: "relative",
      width: "100%"
    },
    children: [content]
  }
});
var HEADING_LEVELS = ["h1", "h2", "h3", "h4", "h5"];
var makeRichTextRow = (theme) => {
  const webComponents = theme.content.components?.web;
  const headingChildren = HEADING_LEVELS.flatMap(
    (headingTag) => Object.keys(webComponents?.[headingTag] || {}).map((variantKey) => ({
      nodeId: `${headingTag}.${variantKey}`,
      type: "primitive",
      props: {
        is: headingTag,
        style: styleFrom(theme, PLATFORM2, `web.${headingTag}.${variantKey}`),
        children: [
          variantKey !== "default" ? `${variantKey} (${headingTag.toUpperCase()})` : `Heading ${headingTag.toUpperCase()}`
        ]
      }
    }))
  );
  const paragraphChildren = Object.keys(webComponents?.p || {}).map(
    (variantKey) => ({
      nodeId: `p.${variantKey}`,
      type: "primitive",
      props: {
        is: "p",
        style: styleFrom(theme, PLATFORM2, `web.p.${variantKey}`),
        children: [
          variantKey !== "default" ? `${variantKey} (Paragraph)` : "Paragraph"
        ]
      }
    })
  );
  const children = [...headingChildren, ...paragraphChildren];
  if (children.length === 0) {
    return [];
  }
  return [
    cellWrapper({
      nodeId: "rich-text-styles",
      type: "block",
      version: 1,
      props: {
        blockType: "RichText",
        id: "rich-text-styles",
        is: "div",
        style: {
          margin: 0,
          minWidth: "200px"
        },
        children
      }
    })
  ];
};
var makeButtonRows2 = (theme) => Object.keys(
  theme.content.components?.web?.button || {}
).map(
  (buttonKey) => cellWrapper({
    nodeId: `${buttonKey}-button`,
    type: "block",
    version: 1,
    props: {
      blockType: "Button",
      id: `button-${buttonKey}-button`,
      is: "button",
      style: styleFrom(theme, PLATFORM2, `web.button.${buttonKey}`),
      children: [
        `${buttonKey.charAt(0).toUpperCase() + buttonKey.slice(1)} Button`
      ]
    }
  })
);
var makeWebExperience = (theme) => ({
  id: "exp-0",
  name: "POC Modal One",
  type: "flow",
  accountId: "103523",
  actions: {},
  traits: [
    {
      type: "@appcues/sequential"
    },
    {
      type: "@appcues/coreEvents"
    }
  ],
  steps: [
    {
      id: "step-0",
      type: "flow",
      actions: {},
      traits: [
        {
          config: {
            placementUnit: "pixel",
            strategy: "fixed",
            target: {
              selector: "flow-root"
            },
            unsetOppositeDirection: true,
            xOffset: 0,
            xPosition: "center",
            yOffset: 0,
            yPosition: "center"
          },
          type: "@appcues/floating"
        }
      ],
      content: {
        nodeId: "resizable-container",
        type: "block",
        version: 1,
        props: {
          behaviors: {
            position: "center-center"
          },
          blockType: "ResizableContainer",
          id: "flow-root",
          is: "div",
          style: {
            maxHeight: "80vh",
            maxWidth: "80vw",
            minHeight: "min-content",
            minWidth: "min-content",
            position: "relative",
            ...styleFrom(theme, PLATFORM2, "web.modal.default")
          },
          children: [
            {
              nodeId: "layout-builder",
              type: "block",
              version: 1,
              props: {
                behaviors: {
                  interaction: true
                },
                blockType: "LayoutBuilder",
                id: "layout-builder-53b4ddf0-e523-49d3-ac76-41755676dbd4",
                is: "div",
                root: false,
                style: {
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  height: "100%",
                  minHeight: "min-content",
                  minWidth: "min-content",
                  pointerEvents: "all",
                  width: "100%"
                },
                children: [...makeRichTextRow(theme), ...makeButtonRows2(theme)]
              }
            }
          ]
        }
      }
    }
  ]
});
var wrapWebComponentPreview = (block) => ({
  id: "exp-0",
  name: "Component",
  type: "flow",
  accountId: "103523",
  tags: [],
  theme: "",
  actions: {},
  traits: [
    {
      type: "@appcues/sequential"
    },
    {
      type: "@appcues/coreEvents"
    }
  ],
  steps: [
    {
      id: "step-0",
      type: "flow",
      actions: {},
      traits: [
        {
          config: {
            placementUnit: "pixel",
            strategy: "fixed",
            target: {
              selector: "flow-root"
            },
            unsetOppositeDirection: true,
            xOffset: 0,
            xPosition: "center",
            yOffset: 0,
            yPosition: "center"
          },
          type: "@appcues/floating"
        }
      ],
      content: {
        nodeId: "resizable-container",
        type: "block",
        version: 1,
        props: {
          behaviors: {
            position: "center-center"
          },
          blockType: "ResizableContainer",
          id: "flow-root",
          is: "div",
          style: {
            minHeight: "min-content",
            minWidth: "min-content",
            fontFamily: "Arial, sans-serif"
          },
          children: [block]
        }
      }
    }
  ]
});

// src/components/PreviewPane/MobilePreviewFrame.tsx
import { useEffect, useRef } from "react";

// src/components/PreviewPane/PreviewPane.styled.ts
import styled from "styled-components";
var Panel = styled.div`
  background-color: ${({ colorMode }) => colorMode === "dark" ? "#000" : "#fff"};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
var ControlBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 var(--spacing-regular);
  padding: var(--spacing-regular) 0;
  border-bottom: 1px solid var(--border-default);
`;
var PreviewWrapper = styled.div`
  position: relative;
  flex: 1;
`;
var PreviewTitle = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: var(--spacing-regular);
  font-weight: var(--bold);
  line-height: normal;
`;
var PreviewFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  pointer-events: none;
`;
var Preview = {
  Wrapper: PreviewWrapper,
  Title: PreviewTitle,
  Frame: PreviewFrame
};

// src/components/PreviewPane/MobilePreviewFrame.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var MobilePreviewFrame = ({
  title,
  mobileExperience,
  colorMode = "light"
}) => {
  const iframeRef = useRef(null);
  const srcUrl = `${window.location.origin}/image-service`;
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.addEventListener("load", () => {
        iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
          colorMode
        });
      });
    }
  });
  useEffect(() => {
    const iframe = iframeRef.current?.contentWindow;
    if (iframe) {
      iframe.apc_set_mobile_experience?.(mobileExperience, "step-child-0", {
        colorMode
      });
    }
  }, [mobileExperience, colorMode]);
  return /* @__PURE__ */ jsxs(Preview.Wrapper, { children: [
    /* @__PURE__ */ jsx(
      Preview.Frame,
      {
        ref: iframeRef,
        title,
        scrolling: "no",
        src: srcUrl
      }
    ),
    title && /* @__PURE__ */ jsx(Preview.Title, { children: title })
  ] });
};

// src/components/PreviewPane/WebPreviewFrame.tsx
import { useEffect as useEffect2, useCallback, useState } from "react";

// ../open-builder/build/open-builder.js
var M = function() {
  return M = Object.assign || function(e) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, M.apply(this, arguments);
};
function li(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(t); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[i]) && (n[r[i]] = t[r[i]]);
  return n;
}
function J(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function rt(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), i, o = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function gt(t, e, n) {
  if (arguments.length === 2) for (var r = 0, i = e.length, o; r < i; r++)
    (o || !(r in e)) && (o || (o = Array.prototype.slice.call(e, 0, r)), o[r] = e[r]);
  return t.concat(o || Array.prototype.slice.call(e));
}
var it;
(function(t) {
  t.Start = "xstate.start", t.Stop = "xstate.stop", t.Raise = "xstate.raise", t.Send = "xstate.send", t.Cancel = "xstate.cancel", t.NullEvent = "", t.Assign = "xstate.assign", t.After = "xstate.after", t.DoneState = "done.state", t.DoneInvoke = "done.invoke", t.Log = "xstate.log", t.Init = "xstate.init", t.Invoke = "xstate.invoke", t.ErrorExecution = "error.execution", t.ErrorCommunication = "error.communication", t.ErrorPlatform = "error.platform", t.ErrorCustom = "xstate.error", t.Update = "xstate.update", t.Pure = "xstate.pure", t.Choose = "xstate.choose";
})(it || (it = {}));
var Ve;
(function(t) {
  t.Parent = "#_parent", t.Internal = "#_internal";
})(Ve || (Ve = {}));
var Gr = it.Start;
var fi = it.Stop;
var yr = it.Raise;
var mr = it.Send;
var Ko = it.Cancel;
var pc = it.NullEvent;
var Kr = it.Assign;
it.After;
it.DoneState;
var Xo = it.Log;
var hc = it.Init;
var Xr = it.Invoke;
it.ErrorExecution;
var Bi = it.ErrorPlatform;
var vc = it.ErrorCustom;
var Yo = it.Update;
var gc = it.Choose;
var yc = it.Pure;
var Zo = ".";
var zi = {};
var Yr = "xstate.guard";
var mc = "";
var Mn;
function di(t, e, n) {
  n === void 0 && (n = Zo);
  var r = xn(t, n), i = xn(e, n);
  return tt(i) ? tt(r) ? i === r : false : tt(r) ? r in i : Object.keys(r).every(function(o) {
    return o in i ? di(r[o], i[o]) : false;
  });
}
function Jo(t) {
  try {
    return tt(t) || typeof t == "number" ? "".concat(t) : t.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function Zr(t, e) {
  try {
    return Qe(t) ? t : t.toString().split(e);
  } catch {
    throw new Error("'".concat(t, "' is not a valid state path."));
  }
}
function Ec(t) {
  return typeof t == "object" && "value" in t && "context" in t && "event" in t && "_event" in t;
}
function xn(t, e) {
  if (Ec(t))
    return t.value;
  if (Qe(t))
    return tr(t);
  if (typeof t != "string")
    return t;
  var n = Zr(t, e);
  return tr(n);
}
function tr(t) {
  if (t.length === 1)
    return t[0];
  for (var e = {}, n = e, r = 0; r < t.length - 1; r++)
    r === t.length - 2 ? n[t[r]] = t[r + 1] : (n[t[r]] = {}, n = n[t[r]]);
  return e;
}
function yn(t, e) {
  for (var n = {}, r = Object.keys(t), i = 0; i < r.length; i++) {
    var o = r[i];
    n[o] = e(t[o], o, t, i);
  }
  return n;
}
function qi(t, e, n) {
  var r, i, o = {};
  try {
    for (var s = J(Object.keys(t)), a = s.next(); !a.done; a = s.next()) {
      var c = a.value, u = t[c];
      n(u) && (o[c] = e(u, c, t));
    }
  } catch (v) {
    r = {
      error: v
    };
  } finally {
    try {
      a && !a.done && (i = s.return) && i.call(s);
    } finally {
      if (r) throw r.error;
    }
  }
  return o;
}
var Sc = function(t) {
  return function(e) {
    var n, r, i = e;
    try {
      for (var o = J(t), s = o.next(); !s.done; s = o.next()) {
        var a = s.value;
        i = i[a];
      }
    } catch (c) {
      n = {
        error: c
      };
    } finally {
      try {
        s && !s.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
    return i;
  };
};
function bc(t, e) {
  return function(n) {
    var r, i, o = n;
    try {
      for (var s = J(t), a = s.next(); !a.done; a = s.next()) {
        var c = a.value;
        o = o[e][c];
      }
    } catch (u) {
      r = {
        error: u
      };
    } finally {
      try {
        a && !a.done && (i = s.return) && i.call(s);
      } finally {
        if (r) throw r.error;
      }
    }
    return o;
  };
}
function Kn(t) {
  if (!t)
    return [[]];
  if (tt(t))
    return [[t]];
  var e = pt(Object.keys(t).map(function(n) {
    var r = t[n];
    return typeof r != "string" && (!r || !Object.keys(r).length) ? [[n]] : Kn(t[n]).map(function(i) {
      return [n].concat(i);
    });
  }));
  return e;
}
function pt(t) {
  var e;
  return (e = []).concat.apply(e, gt([], rt(t), false));
}
function Qo(t) {
  return Qe(t) ? t : [t];
}
function zt(t) {
  return t === void 0 ? [] : Qo(t);
}
function er(t, e, n) {
  var r, i;
  if (st(t))
    return t(e, n.data);
  var o = {};
  try {
    for (var s = J(Object.keys(t)), a = s.next(); !a.done; a = s.next()) {
      var c = a.value, u = t[c];
      st(u) ? o[c] = u(e, n.data) : o[c] = u;
    }
  } catch (v) {
    r = {
      error: v
    };
  } finally {
    try {
      a && !a.done && (i = s.return) && i.call(s);
    } finally {
      if (r) throw r.error;
    }
  }
  return o;
}
function wc(t) {
  return /^(done|error)\./.test(t);
}
function Wi(t) {
  return !!(t instanceof Promise || t !== null && (st(t) || typeof t == "object") && st(t.then));
}
function xc(t) {
  return t !== null && typeof t == "object" && "transition" in t && typeof t.transition == "function";
}
function ts(t, e) {
  var n, r, i = rt([[], []], 2), o = i[0], s = i[1];
  try {
    for (var a = J(t), c = a.next(); !c.done; c = a.next()) {
      var u = c.value;
      e(u) ? o.push(u) : s.push(u);
    }
  } catch (v) {
    n = {
      error: v
    };
  } finally {
    try {
      c && !c.done && (r = a.return) && r.call(a);
    } finally {
      if (n) throw n.error;
    }
  }
  return [o, s];
}
function es(t, e) {
  return yn(t.states, function(n, r) {
    if (n) {
      var i = (tt(e) ? void 0 : e[r]) || (n ? n.current : void 0);
      if (i)
        return {
          current: i,
          states: es(n, i)
        };
    }
  });
}
function _c(t, e) {
  return {
    current: e,
    states: es(t, e)
  };
}
function Vi(t, e, n, r) {
  var i = t && n.reduce(function(o, s) {
    var a, c, u = s.assignment, v = {
      state: r,
      action: s,
      _event: e
    }, l = {};
    if (st(u))
      l = u(o, e.data, v);
    else
      try {
        for (var f = J(Object.keys(u)), p = f.next(); !p.done; p = f.next()) {
          var h = p.value, y = u[h];
          l[h] = st(y) ? y(o, e.data, v) : y;
        }
      } catch (E) {
        a = {
          error: E
        };
      } finally {
        try {
          p && !p.done && (c = f.return) && c.call(f);
        } finally {
          if (a) throw a.error;
        }
      }
    return Object.assign({}, o, l);
  }, t);
  return i;
}
var Tc = function() {
};
function Qe(t) {
  return Array.isArray(t);
}
function st(t) {
  return typeof t == "function";
}
function tt(t) {
  return typeof t == "string";
}
function ns(t, e) {
  if (t)
    return tt(t) ? {
      type: Yr,
      name: t,
      predicate: e ? e[t] : void 0
    } : st(t) ? {
      type: Yr,
      name: t.name,
      predicate: t
    } : t;
}
function Rc(t) {
  try {
    return "subscribe" in t && st(t.subscribe);
  } catch {
    return false;
  }
}
var ye = /* @__PURE__ */ (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})();
Mn = {}, Mn[ye] = function() {
  return this;
}, Mn[Symbol.observable] = function() {
  return this;
};
function Ge(t) {
  return !!t && "__xstatenode" in t;
}
function Cc(t) {
  return !!t && typeof t.send == "function";
}
var Oc = /* @__PURE__ */ (function() {
  var t = 0;
  return function() {
    return t++, t.toString(16);
  };
})();
function pi(t, e) {
  return tt(t) || typeof t == "number" ? M({
    type: t
  }, e) : t;
}
function At(t, e) {
  if (!tt(t) && "$$type" in t && t.$$type === "scxml")
    return t;
  var n = pi(t);
  return M({
    name: n.type,
    data: n,
    $$type: "scxml",
    type: "external"
  }, e);
}
function Le(t, e) {
  var n = Qo(e).map(function(r) {
    return typeof r > "u" || typeof r == "string" || Ge(r) ? {
      target: r,
      event: t
    } : M(M({}, r), {
      event: t
    });
  });
  return n;
}
function Ac(t) {
  if (!(t === void 0 || t === mc))
    return zt(t);
}
function rs(t, e, n, r, i) {
  var o = t.options.guards, s = {
    state: i,
    cond: e,
    _event: r
  };
  if (e.type === Yr)
    return (o?.[e.name] || e.predicate)(n, r.data, s);
  var a = o?.[e.type];
  if (!a)
    throw new Error("Guard '".concat(e.type, "' is not implemented on machine '").concat(t.id, "'."));
  return a(n, r.data, s);
}
function is(t) {
  return typeof t == "string" ? {
    type: t
  } : t;
}
function Jr(t, e, n) {
  if (typeof t == "object")
    return t;
  var r = function() {
  };
  return {
    next: t,
    error: e || r,
    complete: n || r
  };
}
function Hn(t, e) {
  return "".concat(t, ":invocation[").concat(e, "]");
}
var nr = /* @__PURE__ */ At({
  type: hc
});
function Qr(t, e) {
  return e && e[t] || void 0;
}
function Rn(t, e) {
  var n;
  if (tt(t) || typeof t == "number") {
    var r = Qr(t, e);
    st(r) ? n = {
      type: t,
      exec: r
    } : r ? n = r : n = {
      type: t,
      exec: void 0
    };
  } else if (st(t))
    n = {
      // Convert action to string if unnamed
      type: t.name || t.toString(),
      exec: t
    };
  else {
    var r = Qr(t.type, e);
    if (st(r))
      n = M(M({}, t), {
        exec: r
      });
    else if (r) {
      var i = r.type || t.type;
      n = M(M(M({}, r), t), {
        type: i
      });
    } else
      n = t;
  }
  return n;
}
var rr = function(t, e) {
  if (!t)
    return [];
  var n = Qe(t) ? t : [t];
  return n.map(function(r) {
    return Rn(r, e);
  });
};
function hi(t) {
  var e = Rn(t);
  return M(M({
    id: tt(t) ? t : e.id
  }, e), {
    type: e.type
  });
}
function os(t) {
  return tt(t) ? {
    type: yr,
    event: t
  } : An(t, {
    to: Ve.Internal
  });
}
function Nc(t) {
  return {
    type: yr,
    _event: At(t.event)
  };
}
function An(t, e) {
  return {
    to: e ? e.to : void 0,
    type: mr,
    event: st(t) ? t : pi(t),
    delay: e ? e.delay : void 0,
    id: e && e.id !== void 0 ? e.id : st(t) ? t.name : Jo(t)
  };
}
function Pc(t, e, n, r) {
  var i = {
    _event: n
  }, o = At(st(t.event) ? t.event(e, n.data, i) : t.event), s;
  if (tt(t.delay)) {
    var a = r && r[t.delay];
    s = st(a) ? a(e, n.data, i) : a;
  } else
    s = st(t.delay) ? t.delay(e, n.data, i) : t.delay;
  var c = st(t.to) ? t.to(e, n.data, i) : t.to;
  return M(M({}, t), {
    to: c,
    _event: o,
    event: o.data,
    delay: s
  });
}
function Ic(t, e) {
  return An(t, M(M({}, e), {
    to: Ve.Parent
  }));
}
var Dc = function(t, e, n) {
  return M(M({}, t), {
    value: tt(t.expr) ? t.expr : t.expr(e, n.data, {
      _event: n
    })
  });
};
var Lc = function(t) {
  return {
    type: Ko,
    sendId: t
  };
};
function kc(t) {
  var e = hi(t);
  return {
    type: it.Start,
    activity: e,
    exec: void 0
  };
}
function $c(t) {
  var e = st(t) ? t : hi(t);
  return {
    type: it.Stop,
    activity: e,
    exec: void 0
  };
}
function Mc(t, e, n) {
  var r = st(t.activity) ? t.activity(e, n.data) : t.activity, i = typeof r == "string" ? {
    id: r
  } : r, o = {
    type: it.Stop,
    activity: i
  };
  return o;
}
var Hc = function(t) {
  return {
    type: Kr,
    assignment: t
  };
};
function jc(t, e) {
  var n = e ? "#".concat(e) : "";
  return "".concat(it.After, "(").concat(t, ")").concat(n);
}
function jn(t, e) {
  var n = "".concat(it.DoneState, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function Xn(t, e) {
  var n = "".concat(it.DoneInvoke, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function mn(t, e) {
  var n = "".concat(it.ErrorPlatform, ".").concat(t), r = {
    type: n,
    data: e
  };
  return r.toString = function() {
    return n;
  }, r;
}
function Fc(t) {
  return {
    type: it.Pure,
    get: t
  };
}
function Uc(t, e) {
  return An(function(n, r) {
    return r;
  }, M(M({}, e), {
    to: t
  }));
}
function ss(t) {
  return {
    type: it.Choose,
    conds: t
  };
}
function ti(t, e, n, r, i, o) {
  o === void 0 && (o = false);
  var s = rt(o ? [[], i] : ts(i, function(f) {
    return f.type === Kr;
  }), 2), a = s[0], c = s[1], u = a.length ? Vi(n, r, a, e) : n, v = o ? [n] : void 0, l = pt(c.map(function(f) {
    var p;
    switch (f.type) {
      case yr:
        return Nc(f);
      case mr:
        var h = Pc(f, u, r, t.options.delays);
        return h;
      case Xo:
        return Dc(f, u, r);
      case gc: {
        var y = f, E = (p = y.conds.find(function(L) {
          var j = ns(L.cond, t.options.guards);
          return !j || rs(t, j, u, r, e);
        })) === null || p === void 0 ? void 0 : p.actions;
        if (!E)
          return [];
        var S = rt(ti(t, e, u, r, rr(zt(E), t.options.actions), o), 2), g = S[0], b = S[1];
        return u = b, v?.push(u), g;
      }
      case yc: {
        var E = f.get(u, r.data);
        if (!E)
          return [];
        var _ = rt(ti(t, e, u, r, rr(zt(E), t.options.actions), o), 2), x = _[0], N = _[1];
        return u = N, v?.push(u), x;
      }
      case fi:
        return Mc(f, u, r);
      case Kr: {
        u = Vi(u, r, [f], e), v?.push(u);
        break;
      }
      default:
        var A = Rn(f, t.options.actions), C = A.exec;
        if (C && v) {
          var I = v.length - 1;
          A = M(M({}, A), {
            exec: function(L) {
              for (var j = [], k = 1; k < arguments.length; k++)
                j[k - 1] = arguments[k];
              C.apply(void 0, gt([v[I]], rt(j), false));
            }
          });
        }
        return A;
    }
  }).filter(function(f) {
    return !!f;
  }));
  return [l, u];
}
var ir = [];
var En = function(t, e) {
  ir.push(t);
  var n = e(t);
  return ir.pop(), n;
};
var Bc = function(t) {
  return t(ir[ir.length - 1]);
};
function as(t) {
  var e;
  return e = {
    id: t,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: t
      };
    }
  }, e[ye] = function() {
    return this;
  }, e;
}
function zc(t, e, n, r) {
  var i, o = is(t.src), s = (i = e?.options.services) === null || i === void 0 ? void 0 : i[o.type], a = t.data ? er(t.data, n, r) : void 0, c = s ? cs(s, t.id, a) : as(t.id);
  return c.meta = t, c;
}
function cs(t, e, n) {
  var r = as(e);
  if (r.deferred = true, Ge(t)) {
    var i = r.state = En(void 0, function() {
      return (n ? t.withContext(n) : t).initialState;
    });
    r.getSnapshot = function() {
      return i;
    };
  }
  return r;
}
function qc(t) {
  try {
    return typeof t.send == "function";
  } catch {
    return false;
  }
}
function Wc(t) {
  return qc(t) && "id" in t;
}
function Vc(t) {
  var e;
  return M((e = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, e[ye] = function() {
    return this;
  }, e), t);
}
var or = function(t) {
  return t.type === "atomic" || t.type === "final";
};
function Ke(t) {
  return Object.keys(t.states).map(function(e) {
    return t.states[e];
  }).filter(function(e) {
    return e.type !== "history";
  });
}
function us(t) {
  var e = [t];
  return or(t) ? e : e.concat(pt(Ke(t).map(us)));
}
function je(t, e) {
  var n, r, i, o, s, a, c, u, v = new Set(t), l = ei(v), f = new Set(e);
  try {
    for (var p = J(f), h = p.next(); !h.done; h = p.next())
      for (var y = h.value, E = y.parent; E && !f.has(E); )
        f.add(E), E = E.parent;
  } catch (I) {
    n = {
      error: I
    };
  } finally {
    try {
      h && !h.done && (r = p.return) && r.call(p);
    } finally {
      if (n) throw n.error;
    }
  }
  var S = ei(f);
  try {
    for (var g = J(f), b = g.next(); !b.done; b = g.next()) {
      var y = b.value;
      if (y.type === "compound" && (!S.get(y) || !S.get(y).length))
        l.get(y) ? l.get(y).forEach(function(L) {
          return f.add(L);
        }) : y.initialStateNodes.forEach(function(L) {
          return f.add(L);
        });
      else if (y.type === "parallel")
        try {
          for (var _ = (s = void 0, J(Ke(y))), x = _.next(); !x.done; x = _.next()) {
            var N = x.value;
            f.has(N) || (f.add(N), l.get(N) ? l.get(N).forEach(function(L) {
              return f.add(L);
            }) : N.initialStateNodes.forEach(function(L) {
              return f.add(L);
            }));
          }
        } catch (L) {
          s = {
            error: L
          };
        } finally {
          try {
            x && !x.done && (a = _.return) && a.call(_);
          } finally {
            if (s) throw s.error;
          }
        }
    }
  } catch (I) {
    i = {
      error: I
    };
  } finally {
    try {
      b && !b.done && (o = g.return) && o.call(g);
    } finally {
      if (i) throw i.error;
    }
  }
  try {
    for (var A = J(f), C = A.next(); !C.done; C = A.next())
      for (var y = C.value, E = y.parent; E && !f.has(E); )
        f.add(E), E = E.parent;
  } catch (I) {
    c = {
      error: I
    };
  } finally {
    try {
      C && !C.done && (u = A.return) && u.call(A);
    } finally {
      if (c) throw c.error;
    }
  }
  return f;
}
function ls(t, e) {
  var n = e.get(t);
  if (!n)
    return {};
  if (t.type === "compound") {
    var r = n[0];
    if (r) {
      if (or(r))
        return r.key;
    } else
      return {};
  }
  var i = {};
  return n.forEach(function(o) {
    i[o.key] = ls(o, e);
  }), i;
}
function ei(t) {
  var e, n, r = /* @__PURE__ */ new Map();
  try {
    for (var i = J(t), o = i.next(); !o.done; o = i.next()) {
      var s = o.value;
      r.has(s) || r.set(s, []), s.parent && (r.has(s.parent) || r.set(s.parent, []), r.get(s.parent).push(s));
    }
  } catch (a) {
    e = {
      error: a
    };
  } finally {
    try {
      o && !o.done && (n = i.return) && n.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return r;
}
function Gc(t, e) {
  var n = je([t], e);
  return ls(t, ei(n));
}
function Yn(t, e) {
  return Array.isArray(t) ? t.some(function(n) {
    return n === e;
  }) : t instanceof Set ? t.has(e) : false;
}
function Kc(t) {
  return gt([], rt(new Set(pt(gt([], rt(t.map(function(e) {
    return e.ownEvents;
  })), false)))), false);
}
function _n(t, e) {
  return e.type === "compound" ? Ke(e).some(function(n) {
    return n.type === "final" && Yn(t, n);
  }) : e.type === "parallel" ? Ke(e).every(function(n) {
    return _n(t, n);
  }) : false;
}
function Xc(t) {
  return t === void 0 && (t = []), t.reduce(function(e, n) {
    return n.meta !== void 0 && (e[n.id] = n.meta), e;
  }, {});
}
function Gi(t) {
  return new Set(pt(t.map(function(e) {
    return e.tags;
  })));
}
function fs(t, e) {
  if (t === e)
    return true;
  if (t === void 0 || e === void 0)
    return false;
  if (tt(t) || tt(e))
    return t === e;
  var n = Object.keys(t), r = Object.keys(e);
  return n.length === r.length && n.every(function(i) {
    return fs(t[i], e[i]);
  });
}
function Yc(t) {
  return typeof t != "object" || t === null ? false : "value" in t && "_event" in t;
}
function Zc(t, e) {
  var n = t.exec, r = M(M({}, t), {
    exec: n !== void 0 ? function() {
      return n(e.context, e.event, {
        action: t,
        state: e,
        _event: e._event
      });
    } : void 0
  });
  return r;
}
var ne = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      var n = this, r;
      this.actions = [], this.activities = zi, this.meta = {}, this.events = [], this.value = e.value, this.context = e.context, this._event = e._event, this._sessionid = e._sessionid, this.event = this._event.data, this.historyValue = e.historyValue, this.history = e.history, this.actions = e.actions || [], this.activities = e.activities || zi, this.meta = Xc(e.configuration), this.events = e.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = e.configuration, this.transitions = e.transitions, this.children = e.children, this.done = !!e.done, this.tags = (r = Array.isArray(e.tags) ? new Set(e.tags) : e.tags) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set(), this.machine = e.machine, Object.defineProperty(this, "nextEvents", {
        get: function() {
          return Kc(n.configuration);
        }
      });
    }
    return t.from = function(e, n) {
      if (e instanceof t)
        return e.context !== n ? new t({
          value: e.value,
          context: n,
          _event: e._event,
          _sessionid: null,
          historyValue: e.historyValue,
          history: e.history,
          actions: [],
          activities: e.activities,
          events: [],
          configuration: [],
          transitions: [],
          children: {}
        }) : e;
      var r = nr;
      return new t({
        value: e,
        context: n,
        _event: r,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, t.create = function(e) {
      return new t(e);
    }, t.inert = function(e, n) {
      if (e instanceof t) {
        if (!e.actions.length)
          return e;
        var r = nr;
        return new t({
          value: e.value,
          context: n,
          _event: r,
          _sessionid: null,
          historyValue: e.historyValue,
          history: e.history,
          activities: e.activities,
          configuration: e.configuration,
          transitions: [],
          children: {}
        });
      }
      return t.from(e, n);
    }, t.prototype.toStrings = function(e, n) {
      var r = this;
      if (e === void 0 && (e = this.value), n === void 0 && (n = "."), tt(e))
        return [e];
      var i = Object.keys(e);
      return i.concat.apply(i, gt([], rt(i.map(function(o) {
        return r.toStrings(e[o], n).map(function(s) {
          return o + n + s;
        });
      })), false));
    }, t.prototype.toJSON = function() {
      var e = this;
      e.configuration, e.transitions;
      var n = e.tags;
      e.machine;
      var r = li(e, ["configuration", "transitions", "tags", "machine"]);
      return M(M({}, r), {
        tags: Array.from(n)
      });
    }, t.prototype.matches = function(e) {
      return di(e, this.value);
    }, t.prototype.hasTag = function(e) {
      return this.tags.has(e);
    }, t.prototype.can = function(e) {
      var n;
      Tc(!!this.machine);
      var r = (n = this.machine) === null || n === void 0 ? void 0 : n.getTransitionData(this, e);
      return !!r?.transitions.length && // Check that at least one transition is not forbidden
      r.transitions.some(function(i) {
        return i.target !== void 0 || i.actions.length;
      });
    }, t;
  })()
);
var Jc = {
  deferEvents: false
};
var Ki = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e) {
      this.processingEvent = false, this.queue = [], this.initialized = false, this.options = M(M({}, Jc), e);
    }
    return t.prototype.initialize = function(e) {
      if (this.initialized = true, e) {
        if (!this.options.deferEvents) {
          this.schedule(e);
          return;
        }
        this.process(e);
      }
      this.flushEvents();
    }, t.prototype.schedule = function(e) {
      if (!this.initialized || this.processingEvent) {
        this.queue.push(e);
        return;
      }
      if (this.queue.length !== 0)
        throw new Error("Event queue should be empty when it is not processing events");
      this.process(e), this.flushEvents();
    }, t.prototype.clear = function() {
      this.queue = [];
    }, t.prototype.flushEvents = function() {
      for (var e = this.queue.shift(); e; )
        this.process(e), e = this.queue.shift();
    }, t.prototype.process = function(e) {
      this.processingEvent = true;
      try {
        e();
      } catch (n) {
        throw this.clear(), n;
      } finally {
        this.processingEvent = false;
      }
    }, t;
  })()
);
var Pr = /* @__PURE__ */ new Map();
var Qc = 0;
var Fn = {
  bookId: function() {
    return "x:".concat(Qc++);
  },
  register: function(t, e) {
    return Pr.set(t, e), t;
  },
  get: function(t) {
    return Pr.get(t);
  },
  free: function(t) {
    Pr.delete(t);
  }
};
function vi() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
}
function tu() {
  var t = vi();
  if (t && "__xstate__" in t)
    return t.__xstate__;
}
function eu(t) {
  if (vi()) {
    var e = tu();
    e && e.register(t);
  }
}
function nu(t, e) {
  e === void 0 && (e = {});
  var n = t.initialState, r = /* @__PURE__ */ new Set(), i = [], o = false, s = function() {
    if (!o) {
      for (o = true; i.length > 0; ) {
        var u = i.shift();
        n = t.transition(n, u, c), r.forEach(function(v) {
          return v.next(n);
        });
      }
      o = false;
    }
  }, a = Vc({
    id: e.id,
    send: function(u) {
      i.push(u), s();
    },
    getSnapshot: function() {
      return n;
    },
    subscribe: function(u, v, l) {
      var f = Jr(u, v, l);
      return r.add(f), f.next(n), {
        unsubscribe: function() {
          r.delete(f);
        }
      };
    }
  }), c = {
    parent: e.parent,
    self: a,
    id: e.id || "anonymous",
    observers: r
  };
  return n = t.start ? t.start(c) : n, a;
}
var ni = {
  sync: false,
  autoForward: false
};
var Nt;
(function(t) {
  t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped";
})(Nt || (Nt = {}));
var ru = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, n) {
      var r = this;
      n === void 0 && (n = t.defaultOptions), this.machine = e, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = false, this.status = Nt.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this.init = this.start, this.send = function(v, l) {
        if (Qe(v))
          return r.batch(v), r.state;
        var f = At(pi(v, l));
        if (r.status === Nt.Stopped)
          return r.state;
        if (r.status !== Nt.Running && !r.options.deferEvents)
          throw new Error('Event "'.concat(f.name, '" was sent to uninitialized service "').concat(
            r.machine.id,
            `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
          ).concat(JSON.stringify(f.data)));
        return r.scheduler.schedule(function() {
          r.forward(f);
          var p = r.nextState(f);
          r.update(p, f);
        }), r._state;
      }, this.sendTo = function(v, l) {
        var f = r.parent && (l === Ve.Parent || r.parent.id === l), p = f ? r.parent : tt(l) ? r.children.get(l) || Fn.get(l) : Cc(l) ? l : void 0;
        if (!p) {
          if (!f)
            throw new Error("Unable to send event to child '".concat(l, "' from service '").concat(r.id, "'."));
          return;
        }
        "machine" in p ? p.send(M(M({}, v), {
          name: v.name === vc ? "".concat(mn(r.id)) : v.name,
          origin: r.sessionId
        })) : p.send(v.data);
      };
      var i = M(M({}, t.defaultOptions), n), o = i.clock, s = i.logger, a = i.parent, c = i.id, u = c !== void 0 ? c : e.id;
      this.id = u, this.logger = s, this.clock = o, this.parent = a, this.options = i, this.scheduler = new Ki({
        deferEvents: this.options.deferEvents
      }), this.sessionId = Fn.bookId();
    }
    return Object.defineProperty(t.prototype, "initialState", {
      get: function() {
        var e = this;
        return this._initialState ? this._initialState : En(this, function() {
          return e._initialState = e.machine.initialState, e._initialState;
        });
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "state", {
      get: function() {
        return this._state;
      },
      enumerable: false,
      configurable: true
    }), t.prototype.execute = function(e, n) {
      var r, i;
      try {
        for (var o = J(e.actions), s = o.next(); !s.done; s = o.next()) {
          var a = s.value;
          this.exec(a, e, n);
        }
      } catch (c) {
        r = {
          error: c
        };
      } finally {
        try {
          s && !s.done && (i = o.return) && i.call(o);
        } finally {
          if (r) throw r.error;
        }
      }
    }, t.prototype.update = function(e, n) {
      var r, i, o, s, a, c, u, v, l = this;
      if (e._sessionid = this.sessionId, this._state = e, this.options.execute && this.execute(this.state), this.children.forEach(function(I) {
        l.state.children[I.id] = I;
      }), this.devTools && this.devTools.send(n.data, e), e.event)
        try {
          for (var f = J(this.eventListeners), p = f.next(); !p.done; p = f.next()) {
            var h = p.value;
            h(e.event);
          }
        } catch (I) {
          r = {
            error: I
          };
        } finally {
          try {
            p && !p.done && (i = f.return) && i.call(f);
          } finally {
            if (r) throw r.error;
          }
        }
      try {
        for (var y = J(this.listeners), E = y.next(); !E.done; E = y.next()) {
          var h = E.value;
          h(e, e.event);
        }
      } catch (I) {
        o = {
          error: I
        };
      } finally {
        try {
          E && !E.done && (s = y.return) && s.call(y);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var S = J(this.contextListeners), g = S.next(); !g.done; g = S.next()) {
          var b = g.value;
          b(this.state.context, this.state.history ? this.state.history.context : void 0);
        }
      } catch (I) {
        a = {
          error: I
        };
      } finally {
        try {
          g && !g.done && (c = S.return) && c.call(S);
        } finally {
          if (a) throw a.error;
        }
      }
      var _ = _n(e.configuration || [], this.machine);
      if (this.state.configuration && _) {
        var x = e.configuration.find(function(I) {
          return I.type === "final" && I.parent === l.machine;
        }), N = x && x.doneData ? er(x.doneData, e.context, n) : void 0;
        try {
          for (var A = J(this.doneListeners), C = A.next(); !C.done; C = A.next()) {
            var h = C.value;
            h(Xn(this.id, N));
          }
        } catch (I) {
          u = {
            error: I
          };
        } finally {
          try {
            C && !C.done && (v = A.return) && v.call(A);
          } finally {
            if (u) throw u.error;
          }
        }
        this.stop();
      }
    }, t.prototype.onTransition = function(e) {
      return this.listeners.add(e), this.status === Nt.Running && e(this.state, this.state.event), this;
    }, t.prototype.subscribe = function(e, n, r) {
      var i = this;
      if (!e)
        return {
          unsubscribe: function() {
          }
        };
      var o, s = r;
      return typeof e == "function" ? o = e : (o = e.next.bind(e), s = e.complete.bind(e)), this.listeners.add(o), this.status !== Nt.NotStarted && o(this.state), s && (this.status === Nt.Stopped ? s() : this.onDone(s)), {
        unsubscribe: function() {
          o && i.listeners.delete(o), s && i.doneListeners.delete(s);
        }
      };
    }, t.prototype.onEvent = function(e) {
      return this.eventListeners.add(e), this;
    }, t.prototype.onSend = function(e) {
      return this.sendListeners.add(e), this;
    }, t.prototype.onChange = function(e) {
      return this.contextListeners.add(e), this;
    }, t.prototype.onStop = function(e) {
      return this.stopListeners.add(e), this;
    }, t.prototype.onDone = function(e) {
      return this.doneListeners.add(e), this;
    }, t.prototype.off = function(e) {
      return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
    }, t.prototype.start = function(e) {
      var n = this;
      if (this.status === Nt.Running)
        return this;
      this.machine._init(), Fn.register(this.sessionId, this), this.initialized = true, this.status = Nt.Running;
      var r = e === void 0 ? this.initialState : En(this, function() {
        return Yc(e) ? n.machine.resolveState(e) : n.machine.resolveState(ne.from(e, n.machine.context));
      });
      return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
        n.update(r, nr);
      }), this;
    }, t.prototype.stop = function() {
      var e, n, r, i, o, s, a, c, u, v, l = this;
      try {
        for (var f = J(this.listeners), p = f.next(); !p.done; p = f.next()) {
          var h = p.value;
          this.listeners.delete(h);
        }
      } catch (C) {
        e = {
          error: C
        };
      } finally {
        try {
          p && !p.done && (n = f.return) && n.call(f);
        } finally {
          if (e) throw e.error;
        }
      }
      try {
        for (var y = J(this.stopListeners), E = y.next(); !E.done; E = y.next()) {
          var h = E.value;
          h(), this.stopListeners.delete(h);
        }
      } catch (C) {
        r = {
          error: C
        };
      } finally {
        try {
          E && !E.done && (i = y.return) && i.call(y);
        } finally {
          if (r) throw r.error;
        }
      }
      try {
        for (var S = J(this.contextListeners), g = S.next(); !g.done; g = S.next()) {
          var h = g.value;
          this.contextListeners.delete(h);
        }
      } catch (C) {
        o = {
          error: C
        };
      } finally {
        try {
          g && !g.done && (s = S.return) && s.call(S);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var b = J(this.doneListeners), _ = b.next(); !_.done; _ = b.next()) {
          var h = _.value;
          this.doneListeners.delete(h);
        }
      } catch (C) {
        a = {
          error: C
        };
      } finally {
        try {
          _ && !_.done && (c = b.return) && c.call(b);
        } finally {
          if (a) throw a.error;
        }
      }
      if (!this.initialized)
        return this;
      gt([], rt(this.state.configuration), false).sort(function(C, I) {
        return I.order - C.order;
      }).forEach(function(C) {
        var I, L;
        try {
          for (var j = J(C.definition.exit), k = j.next(); !k.done; k = j.next()) {
            var q = k.value;
            l.exec(q, l.state);
          }
        } catch (K) {
          I = {
            error: K
          };
        } finally {
          try {
            k && !k.done && (L = j.return) && L.call(j);
          } finally {
            if (I) throw I.error;
          }
        }
      }), this.children.forEach(function(C) {
        st(C.stop) && C.stop();
      }), this.children.clear();
      try {
        for (var x = J(Object.keys(this.delayedEventsMap)), N = x.next(); !N.done; N = x.next()) {
          var A = N.value;
          this.clock.clearTimeout(this.delayedEventsMap[A]);
        }
      } catch (C) {
        u = {
          error: C
        };
      } finally {
        try {
          N && !N.done && (v = x.return) && v.call(x);
        } finally {
          if (u) throw u.error;
        }
      }
      return this.scheduler.clear(), this.scheduler = new Ki({
        deferEvents: this.options.deferEvents
      }), this.initialized = false, this.status = Nt.Stopped, this._initialState = void 0, Fn.free(this.sessionId), this;
    }, t.prototype.batch = function(e) {
      var n = this;
      if (!(this.status === Nt.NotStarted && this.options.deferEvents)) {
        if (this.status !== Nt.Running)
          throw new Error(
            // tslint:disable-next-line:max-line-length
            "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
          );
      }
      this.scheduler.schedule(function() {
        var r, i, o = n.state, s = false, a = [], c = function(f) {
          var p = At(f);
          n.forward(p), o = En(n, function() {
            return n.machine.transition(o, p);
          }), a.push.apply(a, gt([], rt(o.actions.map(function(h) {
            return Zc(h, o);
          })), false)), s = s || !!o.changed;
        };
        try {
          for (var u = J(e), v = u.next(); !v.done; v = u.next()) {
            var l = v.value;
            c(l);
          }
        } catch (f) {
          r = {
            error: f
          };
        } finally {
          try {
            v && !v.done && (i = u.return) && i.call(u);
          } finally {
            if (r) throw r.error;
          }
        }
        o.changed = s, o.actions = a, n.update(o, At(e[e.length - 1]));
      });
    }, t.prototype.sender = function(e) {
      return this.send.bind(this, e);
    }, t.prototype.nextState = function(e) {
      var n = this, r = At(e);
      if (r.name.indexOf(Bi) === 0 && !this.state.nextEvents.some(function(o) {
        return o.indexOf(Bi) === 0;
      }))
        throw r.data.data;
      var i = En(this, function() {
        return n.machine.transition(n.state, r);
      });
      return i;
    }, t.prototype.forward = function(e) {
      var n, r;
      try {
        for (var i = J(this.forwardTo), o = i.next(); !o.done; o = i.next()) {
          var s = o.value, a = this.children.get(s);
          if (!a)
            throw new Error("Unable to forward event '".concat(e, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(s, "'."));
          a.send(e);
        }
      } catch (c) {
        n = {
          error: c
        };
      } finally {
        try {
          o && !o.done && (r = i.return) && r.call(i);
        } finally {
          if (n) throw n.error;
        }
      }
    }, t.prototype.defer = function(e) {
      var n = this;
      this.delayedEventsMap[e.id] = this.clock.setTimeout(function() {
        e.to ? n.sendTo(e._event, e.to) : n.send(e._event);
      }, e.delay);
    }, t.prototype.cancel = function(e) {
      this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
    }, t.prototype.exec = function(e, n, r) {
      r === void 0 && (r = this.machine.options.actions);
      var i = n.context, o = n._event, s = e.exec || Qr(e.type, r), a = st(s) ? s : s ? s.exec : e.exec;
      if (a)
        try {
          return a(i, o.data, {
            action: e,
            state: this.state,
            _event: o
          });
        } catch (_) {
          throw this.parent && this.parent.send({
            type: "xstate.error",
            data: _
          }), _;
        }
      switch (e.type) {
        case mr:
          var c = e;
          if (typeof c.delay == "number") {
            this.defer(c);
            return;
          } else
            c.to ? this.sendTo(c._event, c.to) : this.send(c._event);
          break;
        case Ko:
          this.cancel(e.sendId);
          break;
        case Gr: {
          if (this.status !== Nt.Running)
            return;
          var u = e.activity;
          if (!this.state.activities[u.id || u.type])
            break;
          if (u.type === it.Invoke) {
            var v = is(u.src), l = this.machine.options.services ? this.machine.options.services[v.type] : void 0, f = u.id, p = u.data, h = "autoForward" in u ? u.autoForward : !!u.forward;
            if (!l)
              return;
            var y = p ? er(p, i, o) : void 0;
            if (typeof l == "string")
              return;
            var E = st(l) ? l(i, o.data, {
              data: y,
              src: v,
              meta: u.meta
            }) : l;
            if (!E)
              return;
            var S = void 0;
            Ge(E) && (E = y ? E.withContext(y) : E, S = {
              autoForward: h
            }), this.spawn(E, f, S);
          } else
            this.spawnActivity(u);
          break;
        }
        case fi: {
          this.stopChild(e.activity.id);
          break;
        }
        case Xo:
          var g = e.label, b = e.value;
          g ? this.logger(g, b) : this.logger(b);
          break;
      }
    }, t.prototype.removeChild = function(e) {
      var n;
      this.children.delete(e), this.forwardTo.delete(e), (n = this.state) === null || n === void 0 || delete n.children[e];
    }, t.prototype.stopChild = function(e) {
      var n = this.children.get(e);
      n && (this.removeChild(e), st(n.stop) && n.stop());
    }, t.prototype.spawn = function(e, n, r) {
      if (Wi(e))
        return this.spawnPromise(Promise.resolve(e), n);
      if (st(e))
        return this.spawnCallback(e, n);
      if (Wc(e))
        return this.spawnActor(e, n);
      if (Rc(e))
        return this.spawnObservable(e, n);
      if (Ge(e))
        return this.spawnMachine(e, M(M({}, r), {
          id: n
        }));
      if (xc(e))
        return this.spawnBehavior(e, n);
      throw new Error('Unable to spawn entity "'.concat(n, '" of type "').concat(typeof e, '".'));
    }, t.prototype.spawnMachine = function(e, n) {
      var r = this;
      n === void 0 && (n = {});
      var i = new t(e, M(M({}, this.options), {
        parent: this,
        id: n.id || e.id
      })), o = M(M({}, ni), n);
      o.sync && i.onTransition(function(a) {
        r.send(Yo, {
          state: a,
          id: i.id
        });
      });
      var s = i;
      return this.children.set(i.id, s), o.autoForward && this.forwardTo.add(i.id), i.onDone(function(a) {
        r.removeChild(i.id), r.send(At(a, {
          origin: i.id
        }));
      }).start(), s;
    }, t.prototype.spawnBehavior = function(e, n) {
      var r = nu(e, {
        id: n,
        parent: this
      });
      return this.children.set(n, r), r;
    }, t.prototype.spawnPromise = function(e, n) {
      var r, i = this, o = false, s;
      e.then(function(c) {
        o || (s = c, i.removeChild(n), i.send(At(Xn(n, c), {
          origin: n
        })));
      }, function(c) {
        if (!o) {
          i.removeChild(n);
          var u = mn(n, c);
          try {
            i.send(At(u, {
              origin: n
            }));
          } catch {
            i.devTools && i.devTools.send(u, i.state), i.machine.strict && i.stop();
          }
        }
      });
      var a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, u, v) {
          var l = Jr(c, u, v), f = false;
          return e.then(function(p) {
            f || (l.next(p), !f && l.complete());
          }, function(p) {
            f || l.error(p);
          }), {
            unsubscribe: function() {
              return f = true;
            }
          };
        },
        stop: function() {
          o = true;
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return s;
        }
      }, r[ye] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, t.prototype.spawnCallback = function(e, n) {
      var r, i = this, o = false, s = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set(), c, u = function(f) {
        c = f, a.forEach(function(p) {
          return p(f);
        }), !o && i.send(At(f, {
          origin: n
        }));
      }, v;
      try {
        v = e(u, function(f) {
          s.add(f);
        });
      } catch (f) {
        this.send(mn(n, f));
      }
      if (Wi(v))
        return this.spawnPromise(v, n);
      var l = (r = {
        id: n,
        send: function(f) {
          return s.forEach(function(p) {
            return p(f);
          });
        },
        subscribe: function(f) {
          var p = Jr(f);
          return a.add(p.next), {
            unsubscribe: function() {
              a.delete(p.next);
            }
          };
        },
        stop: function() {
          o = true, st(v) && v();
        },
        toJSON: function() {
          return {
            id: n
          };
        },
        getSnapshot: function() {
          return c;
        }
      }, r[ye] = function() {
        return this;
      }, r);
      return this.children.set(n, l), l;
    }, t.prototype.spawnObservable = function(e, n) {
      var r, i = this, o, s = e.subscribe(function(c) {
        o = c, i.send(At(c, {
          origin: n
        }));
      }, function(c) {
        i.removeChild(n), i.send(At(mn(n, c), {
          origin: n
        }));
      }, function() {
        i.removeChild(n), i.send(At(Xn(n), {
          origin: n
        }));
      }), a = (r = {
        id: n,
        send: function() {
        },
        subscribe: function(c, u, v) {
          return e.subscribe(c, u, v);
        },
        stop: function() {
          return s.unsubscribe();
        },
        getSnapshot: function() {
          return o;
        },
        toJSON: function() {
          return {
            id: n
          };
        }
      }, r[ye] = function() {
        return this;
      }, r);
      return this.children.set(n, a), a;
    }, t.prototype.spawnActor = function(e, n) {
      return this.children.set(n, e), e;
    }, t.prototype.spawnActivity = function(e) {
      var n = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
      if (n) {
        var r = n(this.state.context, e);
        this.spawnEffect(e.id, r);
      }
    }, t.prototype.spawnEffect = function(e, n) {
      var r;
      this.children.set(e, (r = {
        id: e,
        send: function() {
        },
        subscribe: function() {
          return {
            unsubscribe: function() {
            }
          };
        },
        stop: n || void 0,
        getSnapshot: function() {
        },
        toJSON: function() {
          return {
            id: e
          };
        }
      }, r[ye] = function() {
        return this;
      }, r));
    }, t.prototype.attachDev = function() {
      var e = vi();
      if (this.options.devTools && e) {
        if (e.__REDUX_DEVTOOLS_EXTENSION__) {
          var n = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
          this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(M(M({
            name: this.id,
            autoPause: true,
            stateSanitizer: function(r) {
              return {
                value: r.value,
                context: r.context,
                actions: r.actions
              };
            }
          }, n), {
            features: M({
              jump: false,
              skip: false
            }, n ? n.features : void 0)
          }), this.machine), this.devTools.init(this.state);
        }
        eu(this);
      }
    }, t.prototype.toJSON = function() {
      return {
        id: this.id
      };
    }, t.prototype[ye] = function() {
      return this;
    }, t.prototype.getSnapshot = function() {
      return this.status === Nt.NotStarted ? this.initialState : this._state;
    }, t.defaultOptions = {
      execute: true,
      deferEvents: true,
      clock: {
        setTimeout: function(e, n) {
          return setTimeout(e, n);
        },
        clearTimeout: function(e) {
          return clearTimeout(e);
        }
      },
      logger: /* @__PURE__ */ (() => {
      }).bind(console),
      devTools: false
    }, t.interpret = ps, t;
  })()
);
var iu = function(t) {
  return tt(t) ? M(M({}, ni), {
    name: t
  }) : M(M(M({}, ni), {
    name: Oc()
  }), t);
};
function ds(t, e) {
  var n = iu(e);
  return Bc(function(r) {
    return r ? r.spawn(t, n.name, n) : cs(t, n.name);
  });
}
function ps(t, e) {
  var n = new ru(t, e);
  return n;
}
function ou(t) {
  if (typeof t == "string") {
    var e = {
      type: t
    };
    return e.toString = function() {
      return t;
    }, e;
  }
  return t;
}
function Un(t) {
  return M(M({
    type: Xr
  }, t), {
    toJSON: function() {
      t.onDone, t.onError;
      var e = li(t, ["onDone", "onError"]);
      return M(M({}, e), {
        type: Xr,
        src: ou(t.src)
      });
    }
  });
}
var Bn = "";
var ri = "#";
var Ir = "*";
var ke = {};
var $e = function(t) {
  return t[0] === ri;
};
var su = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
};
var au = (
  /** @class */
  /* @__PURE__ */ (function() {
    function t(e, n, r, i) {
      var o = this;
      r === void 0 && (r = "context" in e ? e.context : void 0);
      var s;
      this.config = e, this._context = r, this.order = -1, this.__xstatenode = true, this.__cache = {
        events: void 0,
        relativeValue: /* @__PURE__ */ new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign(su(), n), this.parent = i?.parent, this.key = this.config.key || i?.key || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : Zo), this.id = this.config.id || gt([this.machine.key], rt(this.path), false).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (s = this.config.schema) !== null && s !== void 0 ? s : {}, this.description = this.config.description, this.initial = this.config.initial, this.states = this.config.states ? yn(this.config.states, function(u, v) {
        var l, f = new t(u, {}, void 0, {
          parent: o,
          key: v
        });
        return Object.assign(o.idMap, M((l = {}, l[f.id] = f, l), f.idMap)), f;
      }) : ke;
      var a = 0;
      function c(u) {
        var v, l;
        u.order = a++;
        try {
          for (var f = J(Ke(u)), p = f.next(); !p.done; p = f.next()) {
            var h = p.value;
            c(h);
          }
        } catch (y) {
          v = {
            error: y
          };
        } finally {
          try {
            p && !p.done && (l = f.return) && l.call(f);
          } finally {
            if (v) throw v.error;
          }
        }
      }
      c(this), this.history = this.config.history === true ? "shallow" : this.config.history || false, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(u) {
        var v = u.event;
        return v === Bn;
      }) : Bn in this.config.on : false), this.strict = !!this.config.strict, this.onEntry = zt(this.config.entry || this.config.onEntry).map(function(u) {
        return Rn(u);
      }), this.onExit = zt(this.config.exit || this.config.onExit).map(function(u) {
        return Rn(u);
      }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = zt(this.config.invoke).map(function(u, v) {
        var l, f;
        if (Ge(u)) {
          var p = Hn(o.id, v);
          return o.machine.options.services = M((l = {}, l[p] = u, l), o.machine.options.services), Un({
            src: p,
            id: p
          });
        } else if (tt(u.src)) {
          var p = u.id || Hn(o.id, v);
          return Un(M(M({}, u), {
            id: p,
            src: u.src
          }));
        } else if (Ge(u.src) || st(u.src)) {
          var p = u.id || Hn(o.id, v);
          return o.machine.options.services = M((f = {}, f[p] = u.src, f), o.machine.options.services), Un(M(M({
            id: p
          }, u), {
            src: p
          }));
        } else {
          var h = u.src;
          return Un(M(M({
            id: Hn(o.id, v)
          }, u), {
            src: h
          }));
        }
      }), this.activities = zt(this.config.activities).concat(this.invoke).map(function(u) {
        return hi(u);
      }), this.transition = this.transition.bind(this), this.tags = zt(this.config.tags);
    }
    return t.prototype._init = function() {
      this.__cache.transitions || us(this).forEach(function(e) {
        return e.on;
      });
    }, t.prototype.withConfig = function(e, n) {
      var r = this.options, i = r.actions, o = r.activities, s = r.guards, a = r.services, c = r.delays;
      return new t(this.config, {
        actions: M(M({}, i), e.actions),
        activities: M(M({}, o), e.activities),
        guards: M(M({}, s), e.guards),
        services: M(M({}, a), e.services),
        delays: M(M({}, c), e.delays)
      }, n ?? this.context);
    }, t.prototype.withContext = function(e) {
      return new t(this.config, this.options, e);
    }, Object.defineProperty(t.prototype, "context", {
      get: function() {
        return st(this._context) ? this._context() : this._context;
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "definition", {
      /**
       * The well-structured state node definition.
       */
      get: function() {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: yn(this.states, function(e) {
            return e.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: false,
      configurable: true
    }), t.prototype.toJSON = function() {
      return this.definition;
    }, Object.defineProperty(t.prototype, "on", {
      /**
       * The mapping of events to transitions.
       */
      get: function() {
        if (this.__cache.on)
          return this.__cache.on;
        var e = this.transitions;
        return this.__cache.on = e.reduce(function(n, r) {
          return n[r.eventType] = n[r.eventType] || [], n[r.eventType].push(r), n;
        }, {});
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "after", {
      get: function() {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "transitions", {
      /**
       * All the transitions that can be taken from this state node.
       */
      get: function() {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getCandidates = function(e) {
      if (this.__cache.candidates[e])
        return this.__cache.candidates[e];
      var n = e === Bn, r = this.transitions.filter(function(i) {
        var o = i.eventType === e;
        return n ? o : o || i.eventType === Ir;
      });
      return this.__cache.candidates[e] = r, r;
    }, t.prototype.getDelayedTransitions = function() {
      var e = this, n = this.config.after;
      if (!n)
        return [];
      var r = function(o, s) {
        var a = st(o) ? "".concat(e.id, ":delay[").concat(s, "]") : o, c = jc(a, e.id);
        return e.onEntry.push(An(c, {
          delay: o
        })), e.onExit.push(Lc(c)), c;
      }, i = Qe(n) ? n.map(function(o, s) {
        var a = r(o.delay, s);
        return M(M({}, o), {
          event: a
        });
      }) : pt(Object.keys(n).map(function(o, s) {
        var a = n[o], c = tt(a) ? {
          target: a
        } : a, u = isNaN(+o) ? o : +o, v = r(u, s);
        return zt(c).map(function(l) {
          return M(M({}, l), {
            event: v,
            delay: u
          });
        });
      }));
      return i.map(function(o) {
        var s = o.delay;
        return M(M({}, e.formatTransition(o)), {
          delay: s
        });
      });
    }, t.prototype.getStateNodes = function(e) {
      var n, r = this;
      if (!e)
        return [];
      var i = e instanceof ne ? e.value : xn(e, this.delimiter);
      if (tt(i)) {
        var o = this.getStateNode(i).initial;
        return o !== void 0 ? this.getStateNodes((n = {}, n[i] = o, n)) : [this, this.states[i]];
      }
      var s = Object.keys(i), a = [this];
      return a.push.apply(a, gt([], rt(pt(s.map(function(c) {
        return r.getStateNode(c).getStateNodes(i[c]);
      }))), false)), a;
    }, t.prototype.handles = function(e) {
      var n = Jo(e);
      return this.events.includes(n);
    }, t.prototype.resolveState = function(e) {
      var n = e instanceof ne ? e : ne.create(e), r = Array.from(je([], this.getStateNodes(n.value)));
      return new ne(M(M({}, n), {
        value: this.resolve(n.value),
        configuration: r,
        done: _n(r, this),
        tags: Gi(r),
        machine: this.machine
      }));
    }, t.prototype.transitionLeafNode = function(e, n, r) {
      var i = this.getStateNode(e), o = i.next(n, r);
      return !o || !o.transitions.length ? this.next(n, r) : o;
    }, t.prototype.transitionCompoundNode = function(e, n, r) {
      var i = Object.keys(e), o = this.getStateNode(i[0]), s = o._transition(e[i[0]], n, r);
      return !s || !s.transitions.length ? this.next(n, r) : s;
    }, t.prototype.transitionParallelNode = function(e, n, r) {
      var i, o, s = {};
      try {
        for (var a = J(Object.keys(e)), c = a.next(); !c.done; c = a.next()) {
          var u = c.value, v = e[u];
          if (v) {
            var l = this.getStateNode(u), f = l._transition(v, n, r);
            f && (s[u] = f);
          }
        }
      } catch (g) {
        i = {
          error: g
        };
      } finally {
        try {
          c && !c.done && (o = a.return) && o.call(a);
        } finally {
          if (i) throw i.error;
        }
      }
      var p = Object.keys(s).map(function(g) {
        return s[g];
      }), h = pt(p.map(function(g) {
        return g.transitions;
      })), y = p.some(function(g) {
        return g.transitions.length > 0;
      });
      if (!y)
        return this.next(n, r);
      var E = pt(p.map(function(g) {
        return g.entrySet;
      })), S = pt(Object.keys(s).map(function(g) {
        return s[g].configuration;
      }));
      return {
        transitions: h,
        entrySet: E,
        exitSet: pt(p.map(function(g) {
          return g.exitSet;
        })),
        configuration: S,
        source: n,
        actions: pt(Object.keys(s).map(function(g) {
          return s[g].actions;
        }))
      };
    }, t.prototype._transition = function(e, n, r) {
      return tt(e) ? this.transitionLeafNode(e, n, r) : Object.keys(e).length === 1 ? this.transitionCompoundNode(e, n, r) : this.transitionParallelNode(e, n, r);
    }, t.prototype.getTransitionData = function(e, n) {
      return this._transition(e.value, e, At(n));
    }, t.prototype.next = function(e, n) {
      var r, i, o = this, s = n.name, a = [], c = [], u;
      try {
        for (var v = J(this.getCandidates(s)), l = v.next(); !l.done; l = v.next()) {
          var f = l.value, p = f.cond, h = f.in, y = e.context, E = h ? tt(h) && $e(h) ? (
            // Check if in state by ID
            e.matches(xn(this.getStateNodeById(h).path, this.delimiter))
          ) : (
            // Check if in state by relative grandparent
            di(xn(h, this.delimiter), Sc(this.path.slice(0, -2))(e.value))
          ) : true, S = false;
          try {
            S = !p || rs(this.machine, p, y, n, e);
          } catch (x) {
            throw new Error("Unable to evaluate guard '".concat(p.name || p.type, "' in transition for event '").concat(s, "' in state node '").concat(this.id, `':
`).concat(x.message));
          }
          if (S && E) {
            f.target !== void 0 && (c = f.target), a.push.apply(a, gt([], rt(f.actions), false)), u = f;
            break;
          }
        }
      } catch (x) {
        r = {
          error: x
        };
      } finally {
        try {
          l && !l.done && (i = v.return) && i.call(v);
        } finally {
          if (r) throw r.error;
        }
      }
      if (u) {
        if (!c.length)
          return {
            transitions: [u],
            entrySet: [],
            exitSet: [],
            configuration: e.value ? [this] : [],
            source: e,
            actions: a
          };
        var g = pt(c.map(function(x) {
          return o.getRelativeStateNodes(x, e.historyValue);
        })), b = !!u.internal, _ = b ? [] : pt(g.map(function(x) {
          return o.nodesFromChild(x);
        }));
        return {
          transitions: [u],
          entrySet: _,
          exitSet: b ? [] : [this],
          configuration: g,
          source: e,
          actions: a
        };
      }
    }, t.prototype.nodesFromChild = function(e) {
      if (e.escapes(this))
        return [];
      for (var n = [], r = e; r && r !== this; )
        n.push(r), r = r.parent;
      return n.push(this), n;
    }, t.prototype.escapes = function(e) {
      if (this === e)
        return false;
      for (var n = this.parent; n; ) {
        if (n === e)
          return false;
        n = n.parent;
      }
      return true;
    }, t.prototype.getActions = function(e, n, r, i) {
      var o, s, a, c, u = je([], i ? this.getStateNodes(i.value) : [this]), v = e.configuration.length ? je(u, e.configuration) : u;
      try {
        for (var l = J(v), f = l.next(); !f.done; f = l.next()) {
          var p = f.value;
          Yn(u, p) || e.entrySet.push(p);
        }
      } catch (A) {
        o = {
          error: A
        };
      } finally {
        try {
          f && !f.done && (s = l.return) && s.call(l);
        } finally {
          if (o) throw o.error;
        }
      }
      try {
        for (var h = J(u), y = h.next(); !y.done; y = h.next()) {
          var p = y.value;
          (!Yn(v, p) || Yn(e.exitSet, p.parent)) && e.exitSet.push(p);
        }
      } catch (A) {
        a = {
          error: A
        };
      } finally {
        try {
          y && !y.done && (c = h.return) && c.call(h);
        } finally {
          if (a) throw a.error;
        }
      }
      var E = pt(e.entrySet.map(function(A) {
        var C = [];
        if (A.type !== "final")
          return C;
        var I = A.parent;
        if (!I.parent)
          return C;
        C.push(
          jn(A.id, A.doneData),
          // TODO: deprecate - final states should not emit done events for their own state.
          jn(I.id, A.doneData ? er(A.doneData, n, r) : void 0)
        );
        var L = I.parent;
        return L.type === "parallel" && Ke(L).every(function(j) {
          return _n(e.configuration, j);
        }) && C.push(jn(L.id)), C;
      }));
      e.exitSet.sort(function(A, C) {
        return C.order - A.order;
      }), e.entrySet.sort(function(A, C) {
        return A.order - C.order;
      });
      var S = new Set(e.entrySet), g = new Set(e.exitSet), b = rt([pt(Array.from(S).map(function(A) {
        return gt(gt([], rt(A.activities.map(function(C) {
          return kc(C);
        })), false), rt(A.onEntry), false);
      })).concat(E.map(os)), pt(Array.from(g).map(function(A) {
        return gt(gt([], rt(A.onExit), false), rt(A.activities.map(function(C) {
          return $c(C);
        })), false);
      }))], 2), _ = b[0], x = b[1], N = rr(x.concat(e.actions).concat(_), this.machine.options.actions);
      return N;
    }, t.prototype.transition = function(e, n, r) {
      e === void 0 && (e = this.initialState);
      var i = At(n), o;
      if (e instanceof ne)
        o = r === void 0 ? e : this.resolveState(ne.from(e, r));
      else {
        var s = tt(e) ? this.resolve(tr(this.getResolvedPath(e))) : this.resolve(e), a = r ?? this.machine.context;
        o = this.resolveState(ne.from(s, a));
      }
      if (this.strict && !this.events.includes(i.name) && !wc(i.name))
        throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(i.name, "'"));
      var c = this._transition(o.value, o, i) || {
        transitions: [],
        configuration: [],
        entrySet: [],
        exitSet: [],
        source: o,
        actions: []
      }, u = je([], this.getStateNodes(o.value)), v = c.configuration.length ? je(u, c.configuration) : u;
      return c.configuration = gt([], rt(v), false), this.resolveTransition(c, o, o.context, i);
    }, t.prototype.resolveRaisedTransition = function(e, n, r) {
      var i, o = e.actions;
      return e = this.transition(e, n), e._event = r, e.event = r.data, (i = e.actions).unshift.apply(i, gt([], rt(o), false)), e;
    }, t.prototype.resolveTransition = function(e, n, r, i) {
      var o, s, a = this;
      i === void 0 && (i = nr);
      var c = e.configuration, u = !n || e.transitions.length > 0, v = u ? Gc(this.machine, c) : void 0, l = n ? n.historyValue ? n.historyValue : e.source ? this.machine.historyValue(n.value) : void 0 : void 0, f = this.getActions(e, r, i, n), p = n ? M({}, n.activities) : {};
      try {
        for (var h = J(f), y = h.next(); !y.done; y = h.next()) {
          var E = y.value;
          E.type === Gr ? p[E.activity.id || E.activity.type] = E : E.type === fi && (p[E.activity.id || E.activity.type] = false);
        }
      } catch (Q) {
        o = {
          error: Q
        };
      } finally {
        try {
          y && !y.done && (s = h.return) && s.call(h);
        } finally {
          if (o) throw o.error;
        }
      }
      var S = rt(ti(this, n, r, i, f, this.machine.config.preserveActionOrder), 2), g = S[0], b = S[1], _ = rt(ts(g, function(Q) {
        return Q.type === yr || Q.type === mr && Q.to === Ve.Internal;
      }), 2), x = _[0], N = _[1], A = g.filter(function(Q) {
        var mt;
        return Q.type === Gr && ((mt = Q.activity) === null || mt === void 0 ? void 0 : mt.type) === Xr;
      }), C = A.reduce(function(Q, mt) {
        return Q[mt.activity.id] = zc(mt.activity, a.machine, b, i), Q;
      }, n ? M({}, n.children) : {}), I = u ? e.configuration : n ? n.configuration : [], L = _n(I, this), j = new ne({
        value: v || n.value,
        context: b,
        _event: i,
        // Persist _sessionid between states
        _sessionid: n ? n._sessionid : null,
        historyValue: v ? l ? _c(l, v) : void 0 : n ? n.historyValue : void 0,
        history: !v || e.source ? n : void 0,
        actions: v ? N : [],
        activities: v ? p : n ? n.activities : {},
        events: [],
        configuration: I,
        transitions: e.transitions,
        children: C,
        done: L,
        tags: Gi(I),
        machine: this
      }), k = r !== b;
      j.changed = i.name === Yo || k;
      var q = j.history;
      q && delete q.history;
      var K = !L && (this._transient || c.some(function(Q) {
        return Q._transient;
      }));
      if (!u && (!K || i.name === Bn))
        return j;
      var W = j;
      if (!L)
        for (K && (W = this.resolveRaisedTransition(W, {
          type: pc
        }, i)); x.length; ) {
          var ot = x.shift();
          W = this.resolveRaisedTransition(W, ot._event, i);
        }
      var ut = W.changed || (q ? !!W.actions.length || k || typeof q.value != typeof W.value || !fs(W.value, q.value) : void 0);
      return W.changed = ut, W.history = q, W;
    }, t.prototype.getStateNode = function(e) {
      if ($e(e))
        return this.machine.getStateNodeById(e);
      if (!this.states)
        throw new Error("Unable to retrieve child state '".concat(e, "' from '").concat(this.id, "'; no child states exist."));
      var n = this.states[e];
      if (!n)
        throw new Error("Child state '".concat(e, "' does not exist on '").concat(this.id, "'"));
      return n;
    }, t.prototype.getStateNodeById = function(e) {
      var n = $e(e) ? e.slice(ri.length) : e;
      if (n === this.id)
        return this;
      var r = this.machine.idMap[n];
      if (!r)
        throw new Error("Child state node '#".concat(n, "' does not exist on machine '").concat(this.id, "'"));
      return r;
    }, t.prototype.getStateNodeByPath = function(e) {
      if (typeof e == "string" && $e(e))
        try {
          return this.getStateNodeById(e.slice(1));
        } catch {
        }
      for (var n = Zr(e, this.delimiter).slice(), r = this; n.length; ) {
        var i = n.shift();
        if (!i.length)
          break;
        r = r.getStateNode(i);
      }
      return r;
    }, t.prototype.resolve = function(e) {
      var n, r = this;
      if (!e)
        return this.initialStateValue || ke;
      switch (this.type) {
        case "parallel":
          return yn(this.initialStateValue, function(o, s) {
            return o ? r.getStateNode(s).resolve(e[s] || o) : ke;
          });
        case "compound":
          if (tt(e)) {
            var i = this.getStateNode(e);
            return i.type === "parallel" || i.type === "compound" ? (n = {}, n[e] = i.initialStateValue, n) : e;
          }
          return Object.keys(e).length ? yn(e, function(o, s) {
            return o ? r.getStateNode(s).resolve(o) : ke;
          }) : this.initialStateValue || {};
        default:
          return e || ke;
      }
    }, t.prototype.getResolvedPath = function(e) {
      if ($e(e)) {
        var n = this.machine.idMap[e.slice(ri.length)];
        if (!n)
          throw new Error("Unable to find state node '".concat(e, "'"));
        return n.path;
      }
      return Zr(e, this.delimiter);
    }, Object.defineProperty(t.prototype, "initialStateValue", {
      get: function() {
        var e;
        if (this.__cache.initialStateValue)
          return this.__cache.initialStateValue;
        var n;
        if (this.type === "parallel")
          n = qi(this.states, function(r) {
            return r.initialStateValue || ke;
          }, function(r) {
            return r.type !== "history";
          });
        else if (this.initial !== void 0) {
          if (!this.states[this.initial])
            throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          n = or(this.states[this.initial]) ? this.initial : (e = {}, e[this.initial] = this.states[this.initial].initialStateValue, e);
        } else
          n = {};
        return this.__cache.initialStateValue = n, this.__cache.initialStateValue;
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getInitialState = function(e, n) {
      this._init();
      var r = this.getStateNodes(e);
      return this.resolveTransition({
        configuration: r,
        entrySet: r,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, n ?? this.machine.context, void 0);
    }, Object.defineProperty(t.prototype, "initialState", {
      /**
       * The initial State instance, which includes all actions to be executed from
       * entering the initial state.
       */
      get: function() {
        var e = this.initialStateValue;
        if (!e)
          throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(e);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "target", {
      /**
       * The target state value of the history state node, if it exists. This represents the
       * default state value to transition to if no history value exists yet.
       */
      get: function() {
        var e;
        if (this.type === "history") {
          var n = this.config;
          tt(n.target) ? e = $e(n.target) ? tr(this.machine.getStateNodeById(n.target).path.slice(this.path.length - 1)) : n.target : e = n.target;
        }
        return e;
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getRelativeStateNodes = function(e, n, r) {
      return r === void 0 && (r = true), r ? e.type === "history" ? e.resolveHistory(n) : e.initialStateNodes : [e];
    }, Object.defineProperty(t.prototype, "initialStateNodes", {
      get: function() {
        var e = this;
        if (or(this))
          return [this];
        if (this.type === "compound" && !this.initial)
          return [this];
        var n = Kn(this.initialStateValue);
        return pt(n.map(function(r) {
          return e.getFromRelativePath(r);
        }));
      },
      enumerable: false,
      configurable: true
    }), t.prototype.getFromRelativePath = function(e) {
      if (!e.length)
        return [this];
      var n = rt(e), r = n[0], i = n.slice(1);
      if (!this.states)
        throw new Error("Cannot retrieve subPath '".concat(r, "' from node with no states"));
      var o = this.getStateNode(r);
      if (o.type === "history")
        return o.resolveHistory();
      if (!this.states[r])
        throw new Error("Child state '".concat(r, "' does not exist on '").concat(this.id, "'"));
      return this.states[r].getFromRelativePath(i);
    }, t.prototype.historyValue = function(e) {
      if (Object.keys(this.states).length)
        return {
          current: e || this.initialStateValue,
          states: qi(this.states, function(n, r) {
            if (!e)
              return n.historyValue();
            var i = tt(e) ? void 0 : e[r];
            return n.historyValue(i || n.initialStateValue);
          }, function(n) {
            return !n.history;
          })
        };
    }, t.prototype.resolveHistory = function(e) {
      var n = this;
      if (this.type !== "history")
        return [this];
      var r = this.parent;
      if (!e) {
        var i = this.target;
        return i ? pt(Kn(i).map(function(s) {
          return r.getFromRelativePath(s);
        })) : r.initialStateNodes;
      }
      var o = bc(r.path, "states")(e).current;
      return tt(o) ? [r.getStateNode(o)] : pt(Kn(o).map(function(s) {
        return n.history === "deep" ? r.getFromRelativePath(s) : [r.states[s[0]]];
      }));
    }, Object.defineProperty(t.prototype, "stateIds", {
      /**
       * All the state node IDs of this state node and its descendant state nodes.
       */
      get: function() {
        var e = this, n = pt(Object.keys(this.states).map(function(r) {
          return e.states[r].stateIds;
        }));
        return [this.id].concat(n);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "events", {
      /**
       * All the event types accepted by this state node and its descendants.
       */
      get: function() {
        var e, n, r, i;
        if (this.__cache.events)
          return this.__cache.events;
        var o = this.states, s = new Set(this.ownEvents);
        if (o)
          try {
            for (var a = J(Object.keys(o)), c = a.next(); !c.done; c = a.next()) {
              var u = c.value, v = o[u];
              if (v.states)
                try {
                  for (var l = (r = void 0, J(v.events)), f = l.next(); !f.done; f = l.next()) {
                    var p = f.value;
                    s.add("".concat(p));
                  }
                } catch (h) {
                  r = {
                    error: h
                  };
                } finally {
                  try {
                    f && !f.done && (i = l.return) && i.call(l);
                  } finally {
                    if (r) throw r.error;
                  }
                }
            }
          } catch (h) {
            e = {
              error: h
            };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (e) throw e.error;
            }
          }
        return this.__cache.events = Array.from(s);
      },
      enumerable: false,
      configurable: true
    }), Object.defineProperty(t.prototype, "ownEvents", {
      /**
       * All the events that have transitions directly from this state node.
       *
       * Excludes any inert events.
       */
      get: function() {
        var e = new Set(this.transitions.filter(function(n) {
          return !(!n.target && !n.actions.length && n.internal);
        }).map(function(n) {
          return n.eventType;
        }));
        return Array.from(e);
      },
      enumerable: false,
      configurable: true
    }), t.prototype.resolveTarget = function(e) {
      var n = this;
      if (e !== void 0)
        return e.map(function(r) {
          if (!tt(r))
            return r;
          var i = r[0] === n.delimiter;
          if (i && !n.parent)
            return n.getStateNodeByPath(r.slice(1));
          var o = i ? n.key + r : r;
          if (n.parent)
            try {
              var s = n.parent.getStateNodeByPath(o);
              return s;
            } catch (a) {
              throw new Error("Invalid transition definition for state node '".concat(n.id, `':
`).concat(a.message));
            }
          else
            return n.getStateNodeByPath(o);
        });
    }, t.prototype.formatTransition = function(e) {
      var n = this, r = Ac(e.target), i = "internal" in e ? e.internal : r ? r.some(function(c) {
        return tt(c) && c[0] === n.delimiter;
      }) : true, o = this.machine.options.guards, s = this.resolveTarget(r), a = M(M({}, e), {
        actions: rr(zt(e.actions)),
        cond: ns(e.cond, o),
        target: s,
        source: this,
        internal: i,
        eventType: e.event,
        toJSON: function() {
          return M(M({}, a), {
            target: a.target ? a.target.map(function(c) {
              return "#".concat(c.id);
            }) : void 0,
            source: "#".concat(n.id)
          });
        }
      });
      return a;
    }, t.prototype.formatTransitions = function() {
      var e, n, r = this, i;
      if (!this.config.on)
        i = [];
      else if (Array.isArray(this.config.on))
        i = this.config.on;
      else {
        var o = this.config.on, s = Ir, a = o[s], c = a === void 0 ? [] : a, u = li(o, [typeof s == "symbol" ? s : s + ""]);
        i = pt(Object.keys(u).map(function(g) {
          var b = Le(g, u[g]);
          return b;
        }).concat(Le(Ir, c)));
      }
      var v = this.config.always ? Le("", this.config.always) : [], l = this.config.onDone ? Le(String(jn(this.id)), this.config.onDone) : [], f = pt(this.invoke.map(function(g) {
        var b = [];
        return g.onDone && b.push.apply(b, gt([], rt(Le(String(Xn(g.id)), g.onDone)), false)), g.onError && b.push.apply(b, gt([], rt(Le(String(mn(g.id)), g.onError)), false)), b;
      })), p = this.after, h = pt(gt(gt(gt(gt([], rt(l), false), rt(f), false), rt(i), false), rt(v), false).map(function(g) {
        return zt(g).map(function(b) {
          return r.formatTransition(b);
        });
      }));
      try {
        for (var y = J(p), E = y.next(); !E.done; E = y.next()) {
          var S = E.value;
          h.push(S);
        }
      } catch (g) {
        e = {
          error: g
        };
      } finally {
        try {
          E && !E.done && (n = y.return) && n.call(y);
        } finally {
          if (e) throw e.error;
        }
      }
      return h;
    }, t;
  })()
);
function Er(t, e) {
  return new au(t, e);
}
var yt = Hc;
var gi = An;
var qt = Ic;
var Me = Uc;
function Xi(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function Yi(t) {
  var e, n;
  return Xi(t) === false ? false : (e = t.constructor, e === void 0 ? true : (n = e.prototype, !(Xi(n) === false || n.hasOwnProperty("isPrototypeOf") === false)));
}
var Ft = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ae(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function cu(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      var i = false;
      try {
        i = this instanceof r;
      } catch {
      }
      return i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: true }), Object.keys(t).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: true,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
var Zn = { exports: {} };
var uu = Zn.exports;
var Zi;
function lu() {
  return Zi || (Zi = 1, (function(t) {
    (function(e, n) {
      t.exports = n();
    })(uu, function() {
      var e = Object.prototype.toString;
      function n(l, f) {
        return l == null ? false : Object.prototype.hasOwnProperty.call(l, f);
      }
      function r(l) {
        if (!l || s(l) && l.length === 0)
          return true;
        if (typeof l != "string") {
          for (var f in l)
            if (n(l, f))
              return false;
          return true;
        }
        return false;
      }
      function i(l) {
        return e.call(l);
      }
      function o(l) {
        return typeof l == "object" && i(l) === "[object Object]";
      }
      var s = Array.isArray || function(l) {
        return e.call(l) === "[object Array]";
      };
      function a(l) {
        return typeof l == "boolean" || i(l) === "[object Boolean]";
      }
      function c(l) {
        var f = parseInt(l);
        return f.toString() === l ? f : l;
      }
      function u(l) {
        l = l || {};
        var f = function(S) {
          return Object.keys(f).reduce(function(g, b) {
            return b === "create" || typeof f[b] == "function" && (g[b] = f[b].bind(f, S)), g;
          }, {});
        }, p;
        l.includeInheritedProps ? p = function() {
          return true;
        } : p = function(S, g) {
          return typeof g == "number" && Array.isArray(S) || n(S, g);
        };
        function h(S, g) {
          if (p(S, g))
            return S[g];
        }
        var y;
        l.includeInheritedProps ? y = function(S, g) {
          typeof g != "string" && typeof g != "number" && (g = String(g));
          var b = h(S, g);
          if (g === "__proto__" || g === "prototype" || g === "constructor" && typeof b == "function")
            throw new Error("For security reasons, object's magic properties cannot be set");
          return b;
        } : y = function(S, g) {
          return h(S, g);
        };
        function E(S, g, b, _) {
          if (typeof g == "number" && (g = [g]), !g || g.length === 0)
            return S;
          if (typeof g == "string")
            return E(S, g.split(".").map(c), b, _);
          var x = g[0], N = y(S, x);
          return g.length === 1 ? ((N === void 0 || !_) && (S[x] = b), N) : (N === void 0 && (typeof g[1] == "number" ? S[x] = [] : S[x] = {}), E(S[x], g.slice(1), b, _));
        }
        return f.has = function(S, g) {
          if (typeof g == "number" ? g = [g] : typeof g == "string" && (g = g.split(".")), !g || g.length === 0)
            return !!S;
          for (var b = 0; b < g.length; b++) {
            var _ = c(g[b]);
            if (typeof _ == "number" && s(S) && _ < S.length || (l.includeInheritedProps ? _ in Object(S) : n(S, _)))
              S = S[_];
            else
              return false;
          }
          return true;
        }, f.ensureExists = function(S, g, b) {
          return E(S, g, b, true);
        }, f.set = function(S, g, b, _) {
          return E(S, g, b, _);
        }, f.insert = function(S, g, b, _) {
          var x = f.get(S, g);
          _ = ~~_, s(x) || (x = [], f.set(S, g, x)), x.splice(_, 0, b);
        }, f.empty = function(S, g) {
          if (!r(g) && S != null) {
            var b, _;
            if (b = f.get(S, g)) {
              if (typeof b == "string")
                return f.set(S, g, "");
              if (a(b))
                return f.set(S, g, false);
              if (typeof b == "number")
                return f.set(S, g, 0);
              if (s(b))
                b.length = 0;
              else if (o(b))
                for (_ in b)
                  p(b, _) && delete b[_];
              else
                return f.set(S, g, null);
            }
          }
        }, f.push = function(S, g) {
          var b = f.get(S, g);
          s(b) || (b = [], f.set(S, g, b)), b.push.apply(b, Array.prototype.slice.call(arguments, 2));
        }, f.coalesce = function(S, g, b) {
          for (var _, x = 0, N = g.length; x < N; x++)
            if ((_ = f.get(S, g[x])) !== void 0)
              return _;
          return b;
        }, f.get = function(S, g, b) {
          if (typeof g == "number" && (g = [g]), !g || g.length === 0)
            return S;
          if (S == null)
            return b;
          if (typeof g == "string")
            return f.get(S, g.split("."), b);
          var _ = c(g[0]), x = y(S, _);
          return x === void 0 ? b : g.length === 1 ? x : f.get(S[_], g.slice(1), b);
        }, f.del = function(g, b) {
          if (typeof b == "number" && (b = [b]), g == null || r(b))
            return g;
          if (typeof b == "string")
            return f.del(g, b.split("."));
          var _ = c(b[0]);
          if (y(g, _), !p(g, _))
            return g;
          if (b.length === 1)
            s(g) ? g.splice(_, 1) : delete g[_];
          else
            return f.del(g[_], b.slice(1));
          return g;
        }, f;
      }
      var v = u();
      return v.create = u, v.withInheritedProps = u({ includeInheritedProps: true }), v;
    });
  })(Zn)), Zn.exports;
}
var fu = lu();
var du = /* @__PURE__ */ Ae(fu);
var Ue = Object.prototype.hasOwnProperty;
function Xt(t) {
  if (ii(t))
    return false;
  if (!t || Xe(t) && t.length === 0)
    return true;
  if (!hs(t)) {
    for (var e in t)
      if (Ue.call(t, e))
        return false;
    return true;
  }
  return false;
}
function ii(t) {
  return typeof t == "number";
}
function hs(t) {
  return typeof t == "string";
}
function Xe(t) {
  return Array.isArray(t);
}
function oi(t, e) {
  for (var n in e)
    Ue.call(e, n) && (t[n] = e[n]);
  return t;
}
function pu(t) {
  var e = parseInt(t);
  return e.toString() === t ? e : t;
}
function sr(t, e, n) {
  return t == null ? e ? n ? [] : {} : t : Xe(t) ? t.slice() : oi({}, t);
}
function ar(t, e) {
  if (t !== e && Yi(t) && Yi(e)) {
    var n = {};
    for (var r in t)
      Ue.call(t, r) && (Ue.call(e, r) ? n[r] = ar(t[r], e[r]) : n[r] = t[r]);
    for (r in e)
      Ue.call(e, r) && (n[r] = ar(t[r], e[r]));
    return n;
  }
  return e;
}
function oe(t, e, n, r) {
  if (ii(n) && (n = [n]), Xt(n))
    return e;
  if (hs(n))
    return oe(t, e, n.split(".").map(pu), r);
  var i = n[0];
  return (!t || t === e) && (t = sr(e, true, ii(i))), n.length === 1 ? r(t, i) : (e != null && (e = e[i]), t[i] = oe(t[i], e, n.slice(1), r), t);
}
var kt = {};
kt.set = function(e, n, r, i) {
  return Xt(r) ? i : oe(e, n, r, function(o, s) {
    return o[s] = i, o;
  });
};
kt.update = function(e, n, r, i) {
  return Xt(r) ? i(sr(n)) : oe(e, n, r, function(o, s) {
    return o[s] = i(o[s]), o;
  });
};
kt.push = function(e, n, r) {
  var i = Array.prototype.slice.call(arguments, 3);
  return Xt(r) ? Xe(n) ? n.concat(i) : i : oe(e, n, r, function(o, s) {
    return Xe(o[s]) ? o[s] = o[s].concat(i) : o[s] = i, o;
  });
};
kt.insert = function(e, n, r, i, o) {
  if (o = ~~o, Xt(r)) {
    if (!Xe(n))
      return [i];
    var s = n.slice(0, o);
    return s.push(i), s.concat(n.slice(o));
  }
  return oe(e, n, r, function(a, c) {
    var u = a[c];
    if (!Xe(u)) {
      if (u != null && typeof u < "u")
        throw new Error("Expected " + r + "to be an array. Instead got " + typeof r);
      u = [];
    }
    var v = u.slice(0, o);
    return v.push(i), a[c] = v.concat(u.slice(o)), a;
  });
};
kt.del = function(e, n, r) {
  if (!Xt(r))
    return oe(e, n, r, function(i, o) {
      return Array.isArray(i) ? i[o] !== void 0 && i.splice(o, 1) : Ue.call(i, o) && delete i[o], i;
    });
};
kt.assign = function(e, n, r, i) {
  return Xt(r) ? Xt(i) ? n : oi(sr(n), i) : oe(e, n, r, function(o, s) {
    i = Object(i);
    var a = sr(o[s], true);
    return oi(a, i), o[s] = a, o;
  });
};
kt.merge = function(e, n, r, i) {
  return Xt(r) ? Xt(i) ? n : ar(n, i) : oe(e, n, r, function(o, s) {
    return i = Object(i), o[s] = ar(o[s], i), o;
  });
};
var hu = kt.set.bind(null, null);
var Jn = kt.update.bind(null, null);
kt.push.bind(null, null);
kt.insert.bind(null, null);
kt.del.bind(null, null);
kt.assign.bind(null, null);
kt.merge.bind(null, null);
var vu = du.get;
var zn;
var gu = new Uint8Array(16);
function yu() {
  if (!zn && (zn = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !zn))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return zn(gu);
}
var mu = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Eu(t) {
  return typeof t == "string" && mu.test(t);
}
var Ct = [];
for (Dr = 0; Dr < 256; ++Dr)
  Ct.push((Dr + 256).toString(16).substr(1));
var Dr;
function Su(t) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (Ct[t[e + 0]] + Ct[t[e + 1]] + Ct[t[e + 2]] + Ct[t[e + 3]] + "-" + Ct[t[e + 4]] + Ct[t[e + 5]] + "-" + Ct[t[e + 6]] + Ct[t[e + 7]] + "-" + Ct[t[e + 8]] + Ct[t[e + 9]] + "-" + Ct[t[e + 10]] + Ct[t[e + 11]] + Ct[t[e + 12]] + Ct[t[e + 13]] + Ct[t[e + 14]] + Ct[t[e + 15]]).toLowerCase();
  if (!Eu(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function bu(t, e, n) {
  t = t || {};
  var r = t.random || (t.rng || yu)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, Su(r);
}
var Sn = { exports: {} };
Sn.exports;
var Ji;
function wu() {
  return Ji || (Ji = 1, (function(t, e) {
    var n = 200, r = "__lodash_hash_undefined__", i = 1, o = 2, s = 9007199254740991, a = "[object Arguments]", c = "[object Array]", u = "[object AsyncFunction]", v = "[object Boolean]", l = "[object Date]", f = "[object Error]", p = "[object Function]", h = "[object GeneratorFunction]", y = "[object Map]", E = "[object Number]", S = "[object Null]", g = "[object Object]", b = "[object Promise]", _ = "[object Proxy]", x = "[object RegExp]", N = "[object Set]", A = "[object String]", C = "[object Symbol]", I = "[object Undefined]", L = "[object WeakMap]", j = "[object ArrayBuffer]", k = "[object DataView]", q = "[object Float32Array]", K = "[object Float64Array]", W = "[object Int8Array]", ot = "[object Int16Array]", ut = "[object Int32Array]", Q = "[object Uint8Array]", mt = "[object Uint8ClampedArray]", et = "[object Uint16Array]", at = "[object Uint32Array]", lt = /[\\^$.*+?()[\]{}|]/g, wt = /^\[object .+?Constructor\]$/, X = /^(?:0|[1-9]\d*)$/, B = {};
    B[q] = B[K] = B[W] = B[ot] = B[ut] = B[Q] = B[mt] = B[et] = B[at] = true, B[a] = B[c] = B[j] = B[v] = B[k] = B[l] = B[f] = B[p] = B[y] = B[E] = B[g] = B[x] = B[N] = B[A] = B[L] = false;
    var xt = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, Z = typeof self == "object" && self && self.Object === Object && self, ft = xt || Z || Function("return this")(), _t = e && !e.nodeType && e, It = _t && true && t && !t.nodeType && t, Zt = It && It.exports === _t, Dt = Zt && xt.process, Lt = (function() {
      try {
        return Dt && Dt.binding && Dt.binding("util");
      } catch {
      }
    })(), Jt = Lt && Lt.isTypedArray;
    function Pe(m, T) {
      for (var D = -1, U = m == null ? 0 : m.length, dt = 0, G = []; ++D < U; ) {
        var vt = m[D];
        T(vt, D, m) && (G[dt++] = vt);
      }
      return G;
    }
    function ue(m, T) {
      for (var D = -1, U = T.length, dt = m.length; ++D < U; )
        m[dt + D] = T[D];
      return m;
    }
    function on(m, T) {
      for (var D = -1, U = m == null ? 0 : m.length; ++D < U; )
        if (T(m[D], D, m))
          return true;
      return false;
    }
    function sn(m, T) {
      for (var D = -1, U = Array(m); ++D < m; )
        U[D] = T(D);
      return U;
    }
    function an(m) {
      return function(T) {
        return m(T);
      };
    }
    function le(m, T) {
      return m.has(T);
    }
    function fe(m, T) {
      return m?.[T];
    }
    function cn(m) {
      var T = -1, D = Array(m.size);
      return m.forEach(function(U, dt) {
        D[++T] = [dt, U];
      }), D;
    }
    function un(m, T) {
      return function(D) {
        return m(T(D));
      };
    }
    function ln(m) {
      var T = -1, D = Array(m.size);
      return m.forEach(function(U) {
        D[++T] = U;
      }), D;
    }
    var fn = Array.prototype, Ie = Function.prototype, de = Object.prototype, Qt = ft["__core-js_shared__"], Se = Ie.toString, R = de.hasOwnProperty, H = (function() {
      var m = /[^.]+$/.exec(Qt && Qt.keys && Qt.keys.IE_PROTO || "");
      return m ? "Symbol(src)_1." + m : "";
    })(), d = de.toString, w = RegExp(
      "^" + Se.call(R).replace(lt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), P = Zt ? ft.Buffer : void 0, O = ft.Symbol, $ = ft.Uint8Array, F = de.propertyIsEnumerable, z = fn.splice, V = O ? O.toStringTag : void 0, Y = Object.getOwnPropertySymbols, nt = P ? P.isBuffer : void 0, ct = un(Object.keys, Object), Et = De(ft, "DataView"), Tt = De(ft, "Map"), Gt = De(ft, "Promise"), dn = De(ft, "Set"), Or = De(ft, "WeakMap"), pn = De(Object, "create"), Ea = xe(Et), Sa = xe(Tt), ba = xe(Gt), wa = xe(dn), xa = xe(Or), Pi = O ? O.prototype : void 0, Ar = Pi ? Pi.valueOf : void 0;
    function be(m) {
      var T = -1, D = m == null ? 0 : m.length;
      for (this.clear(); ++T < D; ) {
        var U = m[T];
        this.set(U[0], U[1]);
      }
    }
    function _a() {
      this.__data__ = pn ? pn(null) : {}, this.size = 0;
    }
    function Ta(m) {
      var T = this.has(m) && delete this.__data__[m];
      return this.size -= T ? 1 : 0, T;
    }
    function Ra(m) {
      var T = this.__data__;
      if (pn) {
        var D = T[m];
        return D === r ? void 0 : D;
      }
      return R.call(T, m) ? T[m] : void 0;
    }
    function Ca(m) {
      var T = this.__data__;
      return pn ? T[m] !== void 0 : R.call(T, m);
    }
    function Oa(m, T) {
      var D = this.__data__;
      return this.size += this.has(m) ? 0 : 1, D[m] = pn && T === void 0 ? r : T, this;
    }
    be.prototype.clear = _a, be.prototype.delete = Ta, be.prototype.get = Ra, be.prototype.has = Ca, be.prototype.set = Oa;
    function te(m) {
      var T = -1, D = m == null ? 0 : m.length;
      for (this.clear(); ++T < D; ) {
        var U = m[T];
        this.set(U[0], U[1]);
      }
    }
    function Aa() {
      this.__data__ = [], this.size = 0;
    }
    function Na(m) {
      var T = this.__data__, D = In(T, m);
      if (D < 0)
        return false;
      var U = T.length - 1;
      return D == U ? T.pop() : z.call(T, D, 1), --this.size, true;
    }
    function Pa(m) {
      var T = this.__data__, D = In(T, m);
      return D < 0 ? void 0 : T[D][1];
    }
    function Ia(m) {
      return In(this.__data__, m) > -1;
    }
    function Da(m, T) {
      var D = this.__data__, U = In(D, m);
      return U < 0 ? (++this.size, D.push([m, T])) : D[U][1] = T, this;
    }
    te.prototype.clear = Aa, te.prototype.delete = Na, te.prototype.get = Pa, te.prototype.has = Ia, te.prototype.set = Da;
    function we(m) {
      var T = -1, D = m == null ? 0 : m.length;
      for (this.clear(); ++T < D; ) {
        var U = m[T];
        this.set(U[0], U[1]);
      }
    }
    function La() {
      this.size = 0, this.__data__ = {
        hash: new be(),
        map: new (Tt || te)(),
        string: new be()
      };
    }
    function ka(m) {
      var T = Dn(this, m).delete(m);
      return this.size -= T ? 1 : 0, T;
    }
    function $a(m) {
      return Dn(this, m).get(m);
    }
    function Ma(m) {
      return Dn(this, m).has(m);
    }
    function Ha(m, T) {
      var D = Dn(this, m), U = D.size;
      return D.set(m, T), this.size += D.size == U ? 0 : 1, this;
    }
    we.prototype.clear = La, we.prototype.delete = ka, we.prototype.get = $a, we.prototype.has = Ma, we.prototype.set = Ha;
    function Pn(m) {
      var T = -1, D = m == null ? 0 : m.length;
      for (this.__data__ = new we(); ++T < D; )
        this.add(m[T]);
    }
    function ja(m) {
      return this.__data__.set(m, r), this;
    }
    function Fa(m) {
      return this.__data__.has(m);
    }
    Pn.prototype.add = Pn.prototype.push = ja, Pn.prototype.has = Fa;
    function pe(m) {
      var T = this.__data__ = new te(m);
      this.size = T.size;
    }
    function Ua() {
      this.__data__ = new te(), this.size = 0;
    }
    function Ba(m) {
      var T = this.__data__, D = T.delete(m);
      return this.size = T.size, D;
    }
    function za(m) {
      return this.__data__.get(m);
    }
    function qa(m) {
      return this.__data__.has(m);
    }
    function Wa(m, T) {
      var D = this.__data__;
      if (D instanceof te) {
        var U = D.__data__;
        if (!Tt || U.length < n - 1)
          return U.push([m, T]), this.size = ++D.size, this;
        D = this.__data__ = new we(U);
      }
      return D.set(m, T), this.size = D.size, this;
    }
    pe.prototype.clear = Ua, pe.prototype.delete = Ba, pe.prototype.get = za, pe.prototype.has = qa, pe.prototype.set = Wa;
    function Va(m, T) {
      var D = Ln(m), U = !D && ac(m), dt = !D && !U && Nr(m), G = !D && !U && !dt && Fi(m), vt = D || U || dt || G, St = vt ? sn(m.length, String) : [], Rt = St.length;
      for (var ht in m)
        R.call(m, ht) && !(vt && // Safari 9 has enumerable `arguments.length` in strict mode.
        (ht == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        dt && (ht == "offset" || ht == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        G && (ht == "buffer" || ht == "byteLength" || ht == "byteOffset") || // Skip index properties.
        nc(ht, Rt))) && St.push(ht);
      return St;
    }
    function In(m, T) {
      for (var D = m.length; D--; )
        if ($i(m[D][0], T))
          return D;
      return -1;
    }
    function Ga(m, T, D) {
      var U = T(m);
      return Ln(m) ? U : ue(U, D(m));
    }
    function hn(m) {
      return m == null ? m === void 0 ? I : S : V && V in Object(m) ? tc(m) : sc(m);
    }
    function Ii(m) {
      return vn(m) && hn(m) == a;
    }
    function Di(m, T, D, U, dt) {
      return m === T ? true : m == null || T == null || !vn(m) && !vn(T) ? m !== m && T !== T : Ka(m, T, D, U, Di, dt);
    }
    function Ka(m, T, D, U, dt, G) {
      var vt = Ln(m), St = Ln(T), Rt = vt ? c : he(m), ht = St ? c : he(T);
      Rt = Rt == a ? g : Rt, ht = ht == a ? g : ht;
      var $t = Rt == g, Ut = ht == g, Ot = Rt == ht;
      if (Ot && Nr(m)) {
        if (!Nr(T))
          return false;
        vt = true, $t = false;
      }
      if (Ot && !$t)
        return G || (G = new pe()), vt || Fi(m) ? Li(m, T, D, U, dt, G) : Ja(m, T, Rt, D, U, dt, G);
      if (!(D & i)) {
        var Ht = $t && R.call(m, "__wrapped__"), jt = Ut && R.call(T, "__wrapped__");
        if (Ht || jt) {
          var ve = Ht ? m.value() : m, ee = jt ? T.value() : T;
          return G || (G = new pe()), dt(ve, ee, D, U, G);
        }
      }
      return Ot ? (G || (G = new pe()), Qa(m, T, D, U, dt, G)) : false;
    }
    function Xa(m) {
      if (!ji(m) || ic(m))
        return false;
      var T = Mi(m) ? w : wt;
      return T.test(xe(m));
    }
    function Ya(m) {
      return vn(m) && Hi(m.length) && !!B[hn(m)];
    }
    function Za(m) {
      if (!oc(m))
        return ct(m);
      var T = [];
      for (var D in Object(m))
        R.call(m, D) && D != "constructor" && T.push(D);
      return T;
    }
    function Li(m, T, D, U, dt, G) {
      var vt = D & i, St = m.length, Rt = T.length;
      if (St != Rt && !(vt && Rt > St))
        return false;
      var ht = G.get(m);
      if (ht && G.get(T))
        return ht == T;
      var $t = -1, Ut = true, Ot = D & o ? new Pn() : void 0;
      for (G.set(m, T), G.set(T, m); ++$t < St; ) {
        var Ht = m[$t], jt = T[$t];
        if (U)
          var ve = vt ? U(jt, Ht, $t, T, m, G) : U(Ht, jt, $t, m, T, G);
        if (ve !== void 0) {
          if (ve)
            continue;
          Ut = false;
          break;
        }
        if (Ot) {
          if (!on(T, function(ee, _e) {
            if (!le(Ot, _e) && (Ht === ee || dt(Ht, ee, D, U, G)))
              return Ot.push(_e);
          })) {
            Ut = false;
            break;
          }
        } else if (!(Ht === jt || dt(Ht, jt, D, U, G))) {
          Ut = false;
          break;
        }
      }
      return G.delete(m), G.delete(T), Ut;
    }
    function Ja(m, T, D, U, dt, G, vt) {
      switch (D) {
        case k:
          if (m.byteLength != T.byteLength || m.byteOffset != T.byteOffset)
            return false;
          m = m.buffer, T = T.buffer;
        case j:
          return !(m.byteLength != T.byteLength || !G(new $(m), new $(T)));
        case v:
        case l:
        case E:
          return $i(+m, +T);
        case f:
          return m.name == T.name && m.message == T.message;
        case x:
        case A:
          return m == T + "";
        case y:
          var St = cn;
        case N:
          var Rt = U & i;
          if (St || (St = ln), m.size != T.size && !Rt)
            return false;
          var ht = vt.get(m);
          if (ht)
            return ht == T;
          U |= o, vt.set(m, T);
          var $t = Li(St(m), St(T), U, dt, G, vt);
          return vt.delete(m), $t;
        case C:
          if (Ar)
            return Ar.call(m) == Ar.call(T);
      }
      return false;
    }
    function Qa(m, T, D, U, dt, G) {
      var vt = D & i, St = ki(m), Rt = St.length, ht = ki(T), $t = ht.length;
      if (Rt != $t && !vt)
        return false;
      for (var Ut = Rt; Ut--; ) {
        var Ot = St[Ut];
        if (!(vt ? Ot in T : R.call(T, Ot)))
          return false;
      }
      var Ht = G.get(m);
      if (Ht && G.get(T))
        return Ht == T;
      var jt = true;
      G.set(m, T), G.set(T, m);
      for (var ve = vt; ++Ut < Rt; ) {
        Ot = St[Ut];
        var ee = m[Ot], _e = T[Ot];
        if (U)
          var Ui = vt ? U(_e, ee, Ot, T, m, G) : U(ee, _e, Ot, m, T, G);
        if (!(Ui === void 0 ? ee === _e || dt(ee, _e, D, U, G) : Ui)) {
          jt = false;
          break;
        }
        ve || (ve = Ot == "constructor");
      }
      if (jt && !ve) {
        var kn = m.constructor, $n = T.constructor;
        kn != $n && "constructor" in m && "constructor" in T && !(typeof kn == "function" && kn instanceof kn && typeof $n == "function" && $n instanceof $n) && (jt = false);
      }
      return G.delete(m), G.delete(T), jt;
    }
    function ki(m) {
      return Ga(m, lc, ec);
    }
    function Dn(m, T) {
      var D = m.__data__;
      return rc(T) ? D[typeof T == "string" ? "string" : "hash"] : D.map;
    }
    function De(m, T) {
      var D = fe(m, T);
      return Xa(D) ? D : void 0;
    }
    function tc(m) {
      var T = R.call(m, V), D = m[V];
      try {
        m[V] = void 0;
        var U = true;
      } catch {
      }
      var dt = d.call(m);
      return U && (T ? m[V] = D : delete m[V]), dt;
    }
    var ec = Y ? function(m) {
      return m == null ? [] : (m = Object(m), Pe(Y(m), function(T) {
        return F.call(m, T);
      }));
    } : fc, he = hn;
    (Et && he(new Et(new ArrayBuffer(1))) != k || Tt && he(new Tt()) != y || Gt && he(Gt.resolve()) != b || dn && he(new dn()) != N || Or && he(new Or()) != L) && (he = function(m) {
      var T = hn(m), D = T == g ? m.constructor : void 0, U = D ? xe(D) : "";
      if (U)
        switch (U) {
          case Ea:
            return k;
          case Sa:
            return y;
          case ba:
            return b;
          case wa:
            return N;
          case xa:
            return L;
        }
      return T;
    });
    function nc(m, T) {
      return T = T ?? s, !!T && (typeof m == "number" || X.test(m)) && m > -1 && m % 1 == 0 && m < T;
    }
    function rc(m) {
      var T = typeof m;
      return T == "string" || T == "number" || T == "symbol" || T == "boolean" ? m !== "__proto__" : m === null;
    }
    function ic(m) {
      return !!H && H in m;
    }
    function oc(m) {
      var T = m && m.constructor, D = typeof T == "function" && T.prototype || de;
      return m === D;
    }
    function sc(m) {
      return d.call(m);
    }
    function xe(m) {
      if (m != null) {
        try {
          return Se.call(m);
        } catch {
        }
        try {
          return m + "";
        } catch {
        }
      }
      return "";
    }
    function $i(m, T) {
      return m === T || m !== m && T !== T;
    }
    var ac = Ii(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? Ii : function(m) {
      return vn(m) && R.call(m, "callee") && !F.call(m, "callee");
    }, Ln = Array.isArray;
    function cc(m) {
      return m != null && Hi(m.length) && !Mi(m);
    }
    var Nr = nt || dc;
    function uc(m, T) {
      return Di(m, T);
    }
    function Mi(m) {
      if (!ji(m))
        return false;
      var T = hn(m);
      return T == p || T == h || T == u || T == _;
    }
    function Hi(m) {
      return typeof m == "number" && m > -1 && m % 1 == 0 && m <= s;
    }
    function ji(m) {
      var T = typeof m;
      return m != null && (T == "object" || T == "function");
    }
    function vn(m) {
      return m != null && typeof m == "object";
    }
    var Fi = Jt ? an(Jt) : Ya;
    function lc(m) {
      return cc(m) ? Va(m) : Za(m);
    }
    function fc() {
      return [];
    }
    function dc() {
      return false;
    }
    t.exports = uc;
  })(Sn, Sn.exports)), Sn.exports;
}
var xu = wu();
var bn = /* @__PURE__ */ Ae(xu);
var _u = "EXPERIENCE_STARTED";
var Qi = "SHOW";
var Be = "STOP_EXPERIENCE";
var Oe = {
  NAVIGATION: "navigation",
  DISMISSED: "dismissed"
};
var Tu = "EXTENDED_EVENT";
var vs = "START_STEP";
var yi = "STOP_STEP";
var gs = "UPDATE_STEP";
var ys = "SET_STEP_CONTAINER_TARGET";
var ms = "UPDATE_STEP_CONTENT";
var Ru = "RECOVER_STEP";
var Cu = "AUTO_RECOVER_STEP";
var Ou = "PARENT_RECOVER_STEP";
var Au = "ERROR";
var Nu = "STEP_INTERACTION";
var Pu = "STEP_SEEN";
var Es = "UPDATE_ROOT_STYLE";
var Iu = "RELOAD";
var Ss = "STEP_STOPPED";
var Du = "EXPERIENCE_DISMISSED";
var Lu = "EXPERIENCE_SNOOZED";
var ku = "FORWARD_TO_PARENT";
var $u = "ACTIONS_STARTED";
var Mu = "ACTIONS_FINISHED";
var Hu = "experience.begin";
var ju = "experience.end";
var mi = "step.begin";
var bs = "step.prerender";
var ws = "step.postrender";
var cr = "step.end";
var xs = "step.error";
var _s = "step.container_change";
var Ts = "RUN_HOOKS";
var Fu = "RUN_HOOKS_DONE";
var Ei = "START_THEME_REMOVAL_LISTENER";
var Rs = "STOP_THEME_REMOVAL_LISTENER";
var Uu = "GLOBAL_CONTAINER_REMOVED";
var Si = "STEP_CONTAINER_REMOVED";
var Tn = "appcues-experience-container";
var Sr = "APPCUES-EXPERIENCE-CONTAINER";
var br = "APPCUES-EXPERIENCE-CONTAINER-BUILDER";
var Cs = "data-appcues-container-id";
var bi = "RUN_TRAITS_DONE";
var Os = "RUN_TRAITS_ERROR";
var Bu = "BIND_ACTIONS_ERROR";
var zu = () => {
  const t = /* @__PURE__ */ new Map(), e = (i) => {
    const { observerInstance: o } = t.get(i);
    if (o) return;
    const s = { childList: true, subtree: true }, a = (...v) => {
      const { callbacks: l } = t.get(i);
      l.forEach((f) => f(...v));
    }, c = new MutationObserver(a);
    c.observe(i, s);
    const { callbacks: u } = t.get(i);
    t.set(i, {
      callbacks: u,
      observerInstance: c
    });
  }, n = (i, o) => {
    const s = t.get(i);
    if (s) {
      const { callbacks: a, observerInstance: c } = s, u = a.filter((v) => v !== o);
      if (u.length > 0) {
        t.set(i, {
          callbacks: u,
          observerInstance: c
        });
        return;
      }
      c.disconnect(), t.delete(i);
    }
  };
  return (i, o) => {
    const { callbacks: s = [], observerInstance: a = null } = t.get(i) ?? {};
    return t.set(i, {
      observerInstance: a,
      callbacks: [...s, o]
    }), e(i), () => n(i, o);
  };
};
var Fe = zu();
var qu = (t, ...e) => {
  e.forEach(
    (n) => t.addEventListener(n, (r) => {
      r.stopPropagation();
    })
  );
};
var to = "|shadow-root|";
var eo = "|iframe|";
var Ye = (t, e) => t.includes(to) || t.includes(eo) ? t.split(to).flatMap((n) => n.split(eo)).reduce((n, r) => n === null ? [...e.querySelectorAll(r)] : n.flatMap((i) => i.shadowRoot ? [...i.shadowRoot.querySelectorAll(r)] : i.tagName === "IFRAME" ? [...i.contentDocument.querySelectorAll(r)] : []), null) ?? [] : e.querySelectorAll(t);
var Wu = (t, e) => {
  const n = Ye(t, e);
  return n.length > 0 ? n[0] : null;
};
var Ne = (t) => `appcues-container-${t}`;
var no = (t, e, n) => {
  try {
    if (t.contentDocument && t.contentDocument.body && t.contentDocument.body.children.length > 0) {
      if (n()) return;
      e(t.contentDocument.body);
    } else {
      const r = () => {
        try {
          const i = t.contentDocument;
          if (!i || !i.body || n()) return;
          e(i.body);
        } catch {
        }
      };
      t.addEventListener("load", r, { once: true });
    }
  } catch {
  }
};
var Vu = (t, e) => {
  t.forEach((n) => {
    n.type === "childList" && n.addedNodes.forEach((r) => {
      r.nodeType === 1 && r.tagName === "IFRAME" && e(r);
    });
  });
};
var Gu = ({
  getTarget: t,
  onInserted: e,
  getWindowReference: n
}) => {
  const r = n().document;
  let i = [];
  const o = () => {
    i.forEach((p) => p()), i = [];
  }, s = () => {
    const p = t();
    return p.length === 1 ? (e(p[0]), o(), true) : false;
  };
  if (s())
    return () => {
    };
  const c = (p) => {
    p.some((h) => h.addedNodes.length > 0) && (Vu(p, (h) => {
      no(
        h,
        (y) => i.push(Fe(y, c)),
        s
      );
    }), s());
  };
  i.push(Fe(r.body, c));
  let u;
  const v = r.createNodeIterator(
    r.body,
    NodeFilter.SHOW_ELEMENT,
    (p) => p.shadowRoot && p.nodeName !== Sr && p.nodeName !== br ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
  );
  for (; (u = v.nextNode()) !== null; )
    i.push(Fe(u.shadowRoot, c));
  let l;
  const f = r.createNodeIterator(
    r.body,
    NodeFilter.SHOW_ELEMENT,
    (p) => p.tagName === "IFRAME" ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
  );
  for (; (l = f.nextNode()) !== null; )
    no(
      l,
      // eslint-disable-next-line no-loop-func
      (p) => i.push(Fe(p, c)),
      s
    );
  return () => o();
};
var wi = ({
  getTarget: t,
  onRemoved: e,
  getWindowReference: n
}) => {
  const r = n().document;
  let [i] = t(), o;
  const s = (a) => {
    if (!a.some((v) => v.removedNodes.length > 0))
      return;
    const c = t(), u = i ? c[0] !== i : false;
    [i] = c, (c.length === 0 || u || !i.isConnected) && (e(), o());
  };
  return o = i && i.getRootNode().nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Fe(i.getRootNode(), s) : Fe(r.body, s), () => o();
};
var Ku = (t) => {
  let e = 0;
  for (let n = 0; n < t.length && !(t[n].nodeName !== Sr || t[n].nodeName !== br); n++)
    e = n;
  return t.slice(e + 1);
};
var Xu = (t, e = document) => {
  try {
    const n = /^((body\s(>?\s?))?)(?<tagName>[\da-z]+):nth-child\((?<index>\d+)\)(?<remainingSelector>.*)/i, r = t.match(n), i = e.body.firstChild?.nodeName === Sr || e.body.firstChild?.nodeName === br;
    if (!r || !i) return [];
    const { tagName: o, index: s, remainingSelector: a } = r.groups, c = Number.parseInt(s, 10) - 1, u = Ku([
      ...e.body.children
    ]), v = u[c]?.nodeName === o.toUpperCase() ? u[c] : null;
    return a ? (
      // adding * here to the string because
      // the remaining selector can be something like
      // > p:nth-of-type(1).
      // But selectors starting with > without a parent sentence first or *
      // would fail, because it is not a valid css selector.
      // * means the parentElement, which is the element
      // we are applying the querySelectorAll.
      v ? Ye(`* ${a}`, v) : []
    ) : [v];
  } catch {
    return [];
  }
};
var As = (t, { step: e, stepContainer: n, checkOutsideContainer: r, getWindowReference: i }) => {
  const o = Ne(e.id);
  let s = [];
  if (r) {
    const c = i().document, u = Xu(t, c), v = u.length > 0 ? u : Ye(t, c.documentElement);
    v.length > 0 && (s = [...s, ...v]);
  }
  if (!n)
    return s;
  let a = Wu(
    `[${Cs}=${o}]`,
    n
  );
  return a && (a = Ye(t, a)), a = a ?? [], a.length > 0 && (s = [...s, ...a]), s;
};
var Ns = ({
  accountId: t,
  id: e,
  theme: n,
  getWindowReference: r
}) => {
  const o = r().document.createElement(Tn);
  return n && o.setAttribute("themeId", n), o.setAttribute("accountId", t), o.setAttribute("id", Ne(e)), qu(o, "keypress", "keydown", "keyup"), o;
};
var Yu = (t) => ({ experience: e }) => {
  const { theme: n, themeSystem: r, accountId: i, id: o } = e;
  if (!i) return;
  const s = t("getWindowReference"), a = s().document, c = Ns({
    accountId: i,
    id: o,
    // a defined themeSystem value means the theme is an open-builder theme and so we don't need to load it via the legacy theme system
    ...!r && { theme: n },
    getWindowReference: s
  });
  a.body.append(c);
};
var Zu = (t) => ({ experience: e }) => {
  const r = t("getWindowReference")().document, i = Ne(e.id);
  Ye(
    `#${i}`,
    r.documentElement
  ).forEach((s) => r.body.removeChild(s));
};
var Ju = ({ getRoot: t }) => {
  const e = t();
  e.parentElement && e.parentElement.removeChild(e);
};
var Qu = ({ getRoot: t }) => ss([
  {
    cond: "hasCustomContainer",
    actions: [
      () => {
        Ju({ getRoot: t });
      }
    ]
  }
]);
var tl = (t) => ({ experience: e }) => (n, r) => {
  r(({ type: i }) => {
    if (i !== Ei) return;
    const o = t("getWindowReference"), s = o().document, a = Ne(e.id);
    wi({
      getTarget: () => Ye(
        `#${a}`,
        s.documentElement
      ),
      onRemoved: () => {
        n(Uu);
      },
      getWindowReference: o
    });
  });
};
var el = ({ getRoot: t, getWindowReference: e }) => () => (
  // eslint-disable-next-line unicorn/consistent-function-scoping
  ((n, r) => {
    let i;
    r(({ type: o }) => {
      if (o === Rs && i) {
        i();
        return;
      }
      o === Ei && (i && i(), i = wi({
        getTarget: () => [t()],
        onRemoved: () => {
          n(Si);
        },
        getWindowReference: e
      }));
    });
  })
);
var Ps = gi(Ei, {
  to: "themeRemovalService"
});
var nl = gi(Rs, {
  to: "themeRemovalService"
});
var Lr = { exports: {} };
var ro;
function rl() {
  return ro || (ro = 1, (function(t) {
    (function() {
      function e(d, w, P) {
        return d.call.apply(d.bind, arguments);
      }
      function n(d, w, P) {
        if (!d) throw Error();
        if (2 < arguments.length) {
          var O = Array.prototype.slice.call(arguments, 2);
          return function() {
            var $ = Array.prototype.slice.call(arguments);
            return Array.prototype.unshift.apply($, O), d.apply(w, $);
          };
        }
        return function() {
          return d.apply(w, arguments);
        };
      }
      function r(d, w, P) {
        return r = Function.prototype.bind && Function.prototype.bind.toString().indexOf("native code") != -1 ? e : n, r.apply(null, arguments);
      }
      var i = Date.now || function() {
        return +/* @__PURE__ */ new Date();
      };
      function o(d, w) {
        this.a = d, this.o = w || d, this.c = this.o.document;
      }
      var s = !!window.FontFace;
      function a(d, w, P, O) {
        if (w = d.c.createElement(w), P) for (var $ in P) P.hasOwnProperty($) && ($ == "style" ? w.style.cssText = P[$] : w.setAttribute($, P[$]));
        return O && w.appendChild(d.c.createTextNode(O)), w;
      }
      function c(d, w, P) {
        d = d.c.getElementsByTagName(w)[0], d || (d = document.documentElement), d.insertBefore(P, d.lastChild);
      }
      function u(d) {
        d.parentNode && d.parentNode.removeChild(d);
      }
      function v(d, w, P) {
        w = w || [], P = P || [];
        for (var O = d.className.split(/\s+/), $ = 0; $ < w.length; $ += 1) {
          for (var F = false, z = 0; z < O.length; z += 1) if (w[$] === O[z]) {
            F = true;
            break;
          }
          F || O.push(w[$]);
        }
        for (w = [], $ = 0; $ < O.length; $ += 1) {
          for (F = false, z = 0; z < P.length; z += 1) if (O[$] === P[z]) {
            F = true;
            break;
          }
          F || w.push(O[$]);
        }
        d.className = w.join(" ").replace(/\s+/g, " ").replace(/^\s+|\s+$/, "");
      }
      function l(d, w) {
        for (var P = d.className.split(/\s+/), O = 0, $ = P.length; O < $; O++) if (P[O] == w) return true;
        return false;
      }
      function f(d) {
        return d.o.location.hostname || d.a.location.hostname;
      }
      function p(d, w, P) {
        function O() {
          V && $ && F && (V(z), V = null);
        }
        w = a(d, "link", { rel: "stylesheet", href: w, media: "all" });
        var $ = false, F = true, z = null, V = P || null;
        s ? (w.onload = function() {
          $ = true, O();
        }, w.onerror = function() {
          $ = true, z = Error("Stylesheet failed to load"), O();
        }) : setTimeout(function() {
          $ = true, O();
        }, 0), c(d, "head", w);
      }
      function h(d, w, P, O) {
        var $ = d.c.getElementsByTagName("head")[0];
        if ($) {
          var F = a(d, "script", { src: w }), z = false;
          return F.onload = F.onreadystatechange = function() {
            z || this.readyState && this.readyState != "loaded" && this.readyState != "complete" || (z = true, P && P(null), F.onload = F.onreadystatechange = null, F.parentNode.tagName == "HEAD" && $.removeChild(F));
          }, $.appendChild(F), setTimeout(function() {
            z || (z = true, P && P(Error("Script load timeout")));
          }, O || 5e3), F;
        }
        return null;
      }
      function y() {
        this.a = 0, this.c = null;
      }
      function E(d) {
        return d.a++, function() {
          d.a--, g(d);
        };
      }
      function S(d, w) {
        d.c = w, g(d);
      }
      function g(d) {
        d.a == 0 && d.c && (d.c(), d.c = null);
      }
      function b(d) {
        this.a = d || "-";
      }
      b.prototype.c = function(d) {
        for (var w = [], P = 0; P < arguments.length; P++) w.push(arguments[P].replace(/[\W_]+/g, "").toLowerCase());
        return w.join(this.a);
      };
      function _(d, w) {
        this.c = d, this.f = 4, this.a = "n";
        var P = (w || "n4").match(/^([nio])([1-9])$/i);
        P && (this.a = P[1], this.f = parseInt(P[2], 10));
      }
      function x(d) {
        return C(d) + " " + (d.f + "00") + " 300px " + N(d.c);
      }
      function N(d) {
        var w = [];
        d = d.split(/,\s*/);
        for (var P = 0; P < d.length; P++) {
          var O = d[P].replace(/['"]/g, "");
          O.indexOf(" ") != -1 || /^\d/.test(O) ? w.push("'" + O + "'") : w.push(O);
        }
        return w.join(",");
      }
      function A(d) {
        return d.a + d.f;
      }
      function C(d) {
        var w = "normal";
        return d.a === "o" ? w = "oblique" : d.a === "i" && (w = "italic"), w;
      }
      function I(d) {
        var w = 4, P = "n", O = null;
        return d && ((O = d.match(/(normal|oblique|italic)/i)) && O[1] && (P = O[1].substr(0, 1).toLowerCase()), (O = d.match(/([1-9]00|normal|bold)/i)) && O[1] && (/bold/i.test(O[1]) ? w = 7 : /[1-9]00/.test(O[1]) && (w = parseInt(O[1].substr(0, 1), 10)))), P + w;
      }
      function L(d, w) {
        this.c = d, this.f = d.o.document.documentElement, this.h = w, this.a = new b("-"), this.j = w.events !== false, this.g = w.classes !== false;
      }
      function j(d) {
        d.g && v(d.f, [d.a.c("wf", "loading")]), q(d, "loading");
      }
      function k(d) {
        if (d.g) {
          var w = l(d.f, d.a.c("wf", "active")), P = [], O = [d.a.c("wf", "loading")];
          w || P.push(d.a.c("wf", "inactive")), v(d.f, P, O);
        }
        q(d, "inactive");
      }
      function q(d, w, P) {
        d.j && d.h[w] && (P ? d.h[w](P.c, A(P)) : d.h[w]());
      }
      function K() {
        this.c = {};
      }
      function W(d, w, P) {
        var O = [], $;
        for ($ in w) if (w.hasOwnProperty($)) {
          var F = d.c[$];
          F && O.push(F(w[$], P));
        }
        return O;
      }
      function ot(d, w) {
        this.c = d, this.f = w, this.a = a(this.c, "span", { "aria-hidden": "true" }, this.f);
      }
      function ut(d) {
        c(d.c, "body", d.a);
      }
      function Q(d) {
        return "display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:" + N(d.c) + ";" + ("font-style:" + C(d) + ";font-weight:" + (d.f + "00") + ";");
      }
      function mt(d, w, P, O, $, F) {
        this.g = d, this.j = w, this.a = O, this.c = P, this.f = $ || 3e3, this.h = F || void 0;
      }
      mt.prototype.start = function() {
        var d = this.c.o.document, w = this, P = i(), O = new Promise(function(z, V) {
          function Y() {
            i() - P >= w.f ? V() : d.fonts.load(x(w.a), w.h).then(function(nt) {
              1 <= nt.length ? z() : setTimeout(Y, 25);
            }, function() {
              V();
            });
          }
          Y();
        }), $ = null, F = new Promise(function(z, V) {
          $ = setTimeout(V, w.f);
        });
        Promise.race([F, O]).then(function() {
          $ && (clearTimeout($), $ = null), w.g(w.a);
        }, function() {
          w.j(w.a);
        });
      };
      function et(d, w, P, O, $, F, z) {
        this.v = d, this.B = w, this.c = P, this.a = O, this.s = z || "BESbswy", this.f = {}, this.w = $ || 3e3, this.u = F || null, this.m = this.j = this.h = this.g = null, this.g = new ot(this.c, this.s), this.h = new ot(this.c, this.s), this.j = new ot(this.c, this.s), this.m = new ot(this.c, this.s), d = new _(this.a.c + ",serif", A(this.a)), d = Q(d), this.g.a.style.cssText = d, d = new _(this.a.c + ",sans-serif", A(this.a)), d = Q(d), this.h.a.style.cssText = d, d = new _("serif", A(this.a)), d = Q(d), this.j.a.style.cssText = d, d = new _("sans-serif", A(this.a)), d = Q(d), this.m.a.style.cssText = d, ut(this.g), ut(this.h), ut(this.j), ut(this.m);
      }
      var at = { D: "serif", C: "sans-serif" }, lt = null;
      function wt() {
        if (lt === null) {
          var d = /AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);
          lt = !!d && (536 > parseInt(d[1], 10) || parseInt(d[1], 10) === 536 && 11 >= parseInt(d[2], 10));
        }
        return lt;
      }
      et.prototype.start = function() {
        this.f.serif = this.j.a.offsetWidth, this.f["sans-serif"] = this.m.a.offsetWidth, this.A = i(), B(this);
      };
      function X(d, w, P) {
        for (var O in at) if (at.hasOwnProperty(O) && w === d.f[at[O]] && P === d.f[at[O]]) return true;
        return false;
      }
      function B(d) {
        var w = d.g.a.offsetWidth, P = d.h.a.offsetWidth, O;
        (O = w === d.f.serif && P === d.f["sans-serif"]) || (O = wt() && X(d, w, P)), O ? i() - d.A >= d.w ? wt() && X(d, w, P) && (d.u === null || d.u.hasOwnProperty(d.a.c)) ? Z(d, d.v) : Z(d, d.B) : xt(d) : Z(d, d.v);
      }
      function xt(d) {
        setTimeout(r(function() {
          B(this);
        }, d), 50);
      }
      function Z(d, w) {
        setTimeout(r(function() {
          u(this.g.a), u(this.h.a), u(this.j.a), u(this.m.a), w(this.a);
        }, d), 0);
      }
      function ft(d, w, P) {
        this.c = d, this.a = w, this.f = 0, this.m = this.j = false, this.s = P;
      }
      var _t = null;
      ft.prototype.g = function(d) {
        var w = this.a;
        w.g && v(w.f, [w.a.c("wf", d.c, A(d).toString(), "active")], [w.a.c("wf", d.c, A(d).toString(), "loading"), w.a.c("wf", d.c, A(d).toString(), "inactive")]), q(w, "fontactive", d), this.m = true, It(this);
      }, ft.prototype.h = function(d) {
        var w = this.a;
        if (w.g) {
          var P = l(w.f, w.a.c("wf", d.c, A(d).toString(), "active")), O = [], $ = [w.a.c("wf", d.c, A(d).toString(), "loading")];
          P || O.push(w.a.c("wf", d.c, A(d).toString(), "inactive")), v(w.f, O, $);
        }
        q(w, "fontinactive", d), It(this);
      };
      function It(d) {
        --d.f == 0 && d.j && (d.m ? (d = d.a, d.g && v(d.f, [d.a.c("wf", "active")], [d.a.c("wf", "loading"), d.a.c("wf", "inactive")]), q(d, "active")) : k(d.a));
      }
      function Zt(d) {
        this.j = d, this.a = new K(), this.h = 0, this.f = this.g = true;
      }
      Zt.prototype.load = function(d) {
        this.c = new o(this.j, d.context || this.j), this.g = d.events !== false, this.f = d.classes !== false, Lt(this, new L(this.c, d), d);
      };
      function Dt(d, w, P, O, $) {
        var F = --d.h == 0;
        (d.f || d.g) && setTimeout(function() {
          var z = $ || null, V = O || null || {};
          if (P.length === 0 && F) k(w.a);
          else {
            w.f += P.length, F && (w.j = F);
            var Y, nt = [];
            for (Y = 0; Y < P.length; Y++) {
              var ct = P[Y], Et = V[ct.c], Tt = w.a, Gt = ct;
              if (Tt.g && v(Tt.f, [Tt.a.c("wf", Gt.c, A(Gt).toString(), "loading")]), q(Tt, "fontloading", Gt), Tt = null, _t === null) if (window.FontFace) {
                var Gt = /Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent), dn = /OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent) && /Apple/.exec(window.navigator.vendor);
                _t = Gt ? 42 < parseInt(Gt[1], 10) : !dn;
              } else _t = false;
              _t ? Tt = new mt(r(w.g, w), r(w.h, w), w.c, ct, w.s, Et) : Tt = new et(r(w.g, w), r(w.h, w), w.c, ct, w.s, z, Et), nt.push(Tt);
            }
            for (Y = 0; Y < nt.length; Y++) nt[Y].start();
          }
        }, 0);
      }
      function Lt(d, w, P) {
        var $ = [], O = P.timeout;
        j(w);
        var $ = W(d.a, P, d.c), F = new ft(d.c, w, O);
        for (d.h = $.length, w = 0, P = $.length; w < P; w++) $[w].load(function(z, V, Y) {
          Dt(d, F, z, V, Y);
        });
      }
      function Jt(d, w) {
        this.c = d, this.a = w;
      }
      Jt.prototype.load = function(d) {
        function w() {
          if (F["__mti_fntLst" + O]) {
            var z = F["__mti_fntLst" + O](), V = [], Y;
            if (z) for (var nt = 0; nt < z.length; nt++) {
              var ct = z[nt].fontfamily;
              z[nt].fontStyle != null && z[nt].fontWeight != null ? (Y = z[nt].fontStyle + z[nt].fontWeight, V.push(new _(ct, Y))) : V.push(new _(ct));
            }
            d(V);
          } else setTimeout(function() {
            w();
          }, 50);
        }
        var P = this, O = P.a.projectId, $ = P.a.version;
        if (O) {
          var F = P.c.o;
          h(this.c, (P.a.api || "https://fast.fonts.net/jsapi") + "/" + O + ".js" + ($ ? "?v=" + $ : ""), function(z) {
            z ? d([]) : (F["__MonotypeConfiguration__" + O] = function() {
              return P.a;
            }, w());
          }).id = "__MonotypeAPIScript__" + O;
        } else d([]);
      };
      function Pe(d, w) {
        this.c = d, this.a = w;
      }
      Pe.prototype.load = function(d) {
        var w, P, O = this.a.urls || [], $ = this.a.families || [], F = this.a.testStrings || {}, z = new y();
        for (w = 0, P = O.length; w < P; w++) p(this.c, O[w], E(z));
        var V = [];
        for (w = 0, P = $.length; w < P; w++) if (O = $[w].split(":"), O[1]) for (var Y = O[1].split(","), nt = 0; nt < Y.length; nt += 1) V.push(new _(O[0], Y[nt]));
        else V.push(new _(O[0]));
        S(z, function() {
          d(V, F);
        });
      };
      function ue(d, w) {
        d ? this.c = d : this.c = on, this.a = [], this.f = [], this.g = w || "";
      }
      var on = "https://fonts.googleapis.com/css";
      function sn(d, w) {
        for (var P = w.length, O = 0; O < P; O++) {
          var $ = w[O].split(":");
          $.length == 3 && d.f.push($.pop());
          var F = "";
          $.length == 2 && $[1] != "" && (F = ":"), d.a.push($.join(F));
        }
      }
      function an(d) {
        if (d.a.length == 0) throw Error("No fonts to load!");
        if (d.c.indexOf("kit=") != -1) return d.c;
        for (var w = d.a.length, P = [], O = 0; O < w; O++) P.push(d.a[O].replace(/ /g, "+"));
        return w = d.c + "?family=" + P.join("%7C"), 0 < d.f.length && (w += "&subset=" + d.f.join(",")), 0 < d.g.length && (w += "&text=" + encodeURIComponent(d.g)), w;
      }
      function le(d) {
        this.f = d, this.a = [], this.c = {};
      }
      var fe = { latin: "BESbswy", "latin-ext": "\xE7\xF6\xFC\u011F\u015F", cyrillic: "\u0439\u044F\u0416", greek: "\u03B1\u03B2\u03A3", khmer: "\u1780\u1781\u1782", Hanuman: "\u1780\u1781\u1782" }, cn = { thin: "1", extralight: "2", "extra-light": "2", ultralight: "2", "ultra-light": "2", light: "3", regular: "4", book: "4", medium: "5", "semi-bold": "6", semibold: "6", "demi-bold": "6", demibold: "6", bold: "7", "extra-bold": "8", extrabold: "8", "ultra-bold": "8", ultrabold: "8", black: "9", heavy: "9", l: "3", r: "4", b: "7" }, un = { i: "i", italic: "i", n: "n", normal: "n" }, ln = /^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
      function fn(d) {
        for (var w = d.f.length, P = 0; P < w; P++) {
          var O = d.f[P].split(":"), $ = O[0].replace(/\+/g, " "), F = ["n4"];
          if (2 <= O.length) {
            var z, V = O[1];
            if (z = [], V) for (var V = V.split(","), Y = V.length, nt = 0; nt < Y; nt++) {
              var ct;
              if (ct = V[nt], ct.match(/^[\w-]+$/)) {
                var Et = ln.exec(ct.toLowerCase());
                if (Et == null) ct = "";
                else {
                  if (ct = Et[2], ct = ct == null || ct == "" ? "n" : un[ct], Et = Et[1], Et == null || Et == "") Et = "4";
                  else var Tt = cn[Et], Et = Tt || (isNaN(Et) ? "4" : Et.substr(0, 1));
                  ct = [ct, Et].join("");
                }
              } else ct = "";
              ct && z.push(ct);
            }
            0 < z.length && (F = z), O.length == 3 && (O = O[2], z = [], O = O ? O.split(",") : z, 0 < O.length && (O = fe[O[0]]) && (d.c[$] = O));
          }
          for (d.c[$] || (O = fe[$]) && (d.c[$] = O), O = 0; O < F.length; O += 1) d.a.push(new _($, F[O]));
        }
      }
      function Ie(d, w) {
        this.c = d, this.a = w;
      }
      var de = { Arimo: true, Cousine: true, Tinos: true };
      Ie.prototype.load = function(d) {
        var w = new y(), P = this.c, O = new ue(this.a.api, this.a.text), $ = this.a.families;
        sn(O, $);
        var F = new le($);
        fn(F), p(P, an(O), E(w)), S(w, function() {
          d(F.a, F.c, de);
        });
      };
      function Qt(d, w) {
        this.c = d, this.a = w;
      }
      Qt.prototype.load = function(d) {
        var w = this.a.id, P = this.c.o;
        w ? h(this.c, (this.a.api || "https://use.typekit.net") + "/" + w + ".js", function(O) {
          if (O) d([]);
          else if (P.Typekit && P.Typekit.config && P.Typekit.config.fn) {
            O = P.Typekit.config.fn;
            for (var $ = [], F = 0; F < O.length; F += 2) for (var z = O[F], V = O[F + 1], Y = 0; Y < V.length; Y++) $.push(new _(z, V[Y]));
            try {
              P.Typekit.load({ events: false, classes: false, async: true });
            } catch {
            }
            d($);
          }
        }, 2e3) : d([]);
      };
      function Se(d, w) {
        this.c = d, this.f = w, this.a = [];
      }
      Se.prototype.load = function(d) {
        var w = this.f.id, P = this.c.o, O = this;
        w ? (P.__webfontfontdeckmodule__ || (P.__webfontfontdeckmodule__ = {}), P.__webfontfontdeckmodule__[w] = function($, F) {
          for (var z = 0, V = F.fonts.length; z < V; ++z) {
            var Y = F.fonts[z];
            O.a.push(new _(Y.name, I("font-weight:" + Y.weight + ";font-style:" + Y.style)));
          }
          d(O.a);
        }, h(this.c, (this.f.api || "https://f.fontdeck.com/s/css/js/") + f(this.c) + "/" + w + ".js", function($) {
          $ && d([]);
        })) : d([]);
      };
      var R = new Zt(window);
      R.a.c.custom = function(d, w) {
        return new Pe(w, d);
      }, R.a.c.fontdeck = function(d, w) {
        return new Se(w, d);
      }, R.a.c.monotype = function(d, w) {
        return new Jt(w, d);
      }, R.a.c.typekit = function(d, w) {
        return new Qt(w, d);
      }, R.a.c.google = function(d, w) {
        return new Ie(w, d);
      };
      var H = { load: r(R.load, R) };
      t.exports ? t.exports = H : (window.WebFont = H, window.WebFontConfig && R.load(window.WebFontConfig));
    })();
  })(Lr)), Lr.exports;
}
var il = rl();
var ol = /* @__PURE__ */ Ae(il);
var qn = { exports: {} };
var io;
function sl() {
  if (io) return qn.exports;
  io = 1;
  function t(l, f) {
    var p = f && f.cache ? f.cache : v, h = f && f.serializer ? f.serializer : c, y = f && f.strategy ? f.strategy : o;
    return y(l, {
      cache: p,
      serializer: h
    });
  }
  function e(l) {
    return l == null || typeof l == "number" || typeof l == "boolean";
  }
  function n(l, f, p, h) {
    var y = e(h) ? h : p(h), E = f.get(y);
    return typeof E > "u" && (E = l.call(this, h), f.set(y, E)), E;
  }
  function r(l, f, p) {
    var h = Array.prototype.slice.call(arguments, 3), y = p(h), E = f.get(y);
    return typeof E > "u" && (E = l.apply(this, h), f.set(y, E)), E;
  }
  function i(l, f, p, h, y) {
    return p.bind(
      f,
      l,
      h,
      y
    );
  }
  function o(l, f) {
    var p = l.length === 1 ? n : r;
    return i(
      l,
      this,
      p,
      f.cache.create(),
      f.serializer
    );
  }
  function s(l, f) {
    var p = r;
    return i(
      l,
      this,
      p,
      f.cache.create(),
      f.serializer
    );
  }
  function a(l, f) {
    var p = n;
    return i(
      l,
      this,
      p,
      f.cache.create(),
      f.serializer
    );
  }
  function c() {
    return JSON.stringify(arguments);
  }
  function u() {
    this.cache = /* @__PURE__ */ Object.create(null);
  }
  u.prototype.has = function(l) {
    return l in this.cache;
  }, u.prototype.get = function(l) {
    return this.cache[l];
  }, u.prototype.set = function(l, f) {
    this.cache[l] = f;
  };
  var v = {
    create: function() {
      return new u();
    }
  };
  return qn.exports = t, qn.exports.strategies = {
    variadic: s,
    monadic: a
  }, qn.exports;
}
var al = sl();
var cl = /* @__PURE__ */ Ae(al);
var ul = window.AppcuesBundleSettings?.VERSION === "dev" ? "https://fast.appcues.com/v1" : window.AppcuesBundleSettings?.GENERIC_BUNDLE_DOMAIN ? `${window.AppcuesBundleSettings.GENERIC_BUNDLE_DOMAIN}/v1` : "https://fast.appcues.com/v1";
var ll = 9999;
var ur = {
  fastBaseUrl: null,
  // null means use default
  useAssetsPath: false
  // when true, use simplified theme path format
};
var fl = (t = {}) => {
  ur = { ...ur, ...t };
};
var dl = () => ur.fastBaseUrl ?? ul;
var oo = () => ur.useAssetsPath;
function pl(t) {
  return t.replace(/\/+$/, "");
}
var hl = cl(
  (t, e) => {
    const n = dl();
    if (oo()) {
      const r = pl(n);
      return fetch(
        `${r}/themes/${encodeURIComponent(t)}.json`
      ).then((i) => i.json());
    }
    return fetch(`${n}/accounts/${e}/styles/${t}`).then(
      (r) => r.json()
    );
  },
  {
    serializer: ([t, e]) => `${t}:${e}:${oo()}`
  }
);
var vl = (t, e) => {
  const n = {
    classes: false
  };
  e != null && (n.custom = {
    urls: [e.general.headerFontUrl, e.general.bodyFontUrl]
  }), t && (n.typekit = {
    id: t
  }), Object.keys(n).length > 1 && ol.load(n);
};
var so = (t, e, n) => {
  if (!t) return;
  const i = (n.ownerDocument || document).createElement("style");
  i.innerHTML = `${t}`, e && i.classList.add(`theme-${e}`), n.shadowRoot.prepend(i);
};
var Is = async (t) => {
  const e = t.getAttribute("themeId"), n = t.getAttribute("accountId"), r = await hl(e, n).catch(() => {
  }), { globalStyling: i, theme: o, typekitId: s } = r ?? {
    globalStyling: "",
    theme: {},
    typekitId: ""
  }, a = o?.json?.typekitId ?? s;
  vl(a, o?.json), so(o?.css, e, t), so(i, e, t);
};
var gl = async (t, e) => {
  await Is(t), e && t.shadowRoot.querySelectorAll(
    `.theme-${e}`
  ).forEach((r) => r.remove());
};
var yl = yt({
  step: ({ step: t }, e) => ({
    ...t,
    virtualizedContent: e.virtualizedContent
  })
});
var ml = (t) => yt({
  step: (e, n) => ({
    stepConfig: n.stepConfig,
    virtualizedContent: t(n.stepConfig)
  })
});
var El = yt({
  experience: (t, e) => e.experience,
  step: ({ step: t }, e) => ({
    ...t,
    ...e.stepConfig
  })
});
var Sl = qt(_u);
var bl = qt(({ step: t }) => ({
  type: Ss,
  id: t.id
}));
var wl = (t, { styles: e, getRoot: n }) => {
  const r = n();
  r && Object.entries(e).forEach(([i, o]) => {
    i.startsWith("--") ? r.style.setProperty(i, o) : r.style[i] = o;
  });
};
var xl = (t) => (e) => {
  const { theme: n, themeSystem: r, id: i } = e.experience;
  if (r || !n) return;
  const a = t("getWindowReference")().document.documentElement.querySelector(
    `#${Ne(i)}`
  ), c = a.getAttribute("themeId");
  a?.setAttribute("themeId", n), gl(a, c);
};
var _l = (t) => yt({
  step: ({ step: e }) => {
    if (e.type !== "tooltip") return e;
    const n = Object.entries(e.actions).filter(
      ([, i]) => i.find((o) => o.on === "click")
    ).map(([i]) => i), r = e.traits.filter(({ config: i }) => i.targetId).map(({ config: i }) => i.targetId);
    return {
      ...e,
      virtualizedContent: t(e, {
        interactiveEls: n,
        focusableEls: r
      })
    };
  }
});
var Tl = ss([
  {
    cond: (t, e) => e.errorEvent?.type === Si,
    actions: [
      os({
        type: Cu,
        isAutoRecoverEvent: true
      })
    ]
  }
]);
var Rl = yt({
  actionsRunning: true
});
var Cl = yt({
  actionsRunning: false
});
var Ol = (t, e) => {
  const n = e.changedExperienceTraits && e.changedExperienceTraits.changedTraits.length > 0, r = e.changedExperienceTraits && (e.changedExperienceTraits.addedTraits.length > 0 || e.changedExperienceTraits.removedTraits.length > 0), i = e.changedStepTraits && e.changedStepTraits.changedTraits.length > 0, o = e.changedStepTraits && (e.changedStepTraits.addedTraits.length > 0 || e.changedStepTraits.removedTraits.length > 0);
  return r || o ? false : !!(n || i);
};
var Al = "Key name should be string and callback a valid function";
var Ds = () => {
  const t = /* @__PURE__ */ new Map(), e = (r) => t.get(r);
  return {
    getCallback: e,
    registerCallback: (r, i) => {
      if (e(r), typeof r != "string" || typeof i != "function")
        throw new TypeError(Al);
      t.set(r, i);
    }
  };
};
var Ls = ({ getTrait: t, trait: e, ...n }) => {
  const r = t(e.type);
  r && r(n, e.config ?? {});
};
var { getCallback: ks, registerCallback: bt } = Ds();
var Nl = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, n) => (n &= 63, n < 36 ? e += n.toString(36) : n < 62 ? e += (n - 26).toString(36).toUpperCase() : n > 62 ? e += "-" : e += "_", e), "");
var Pl = ({
  experience: t,
  callback: e,
  step: n,
  findId: r,
  getContainer: i,
  getWindowReference: o
}) => {
  const s = (c, { forwardToParent: u = false } = {}) => {
    const v = ({ type: l, ...f }) => e(u ? {
      ...f,
      eventType: l,
      type: ku
    } : { type: l, ...f });
    return {
      querySelector: (l) => As(l, {
        step: n,
        checkOutsideContainer: false,
        stepContainer: i(),
        getWindowReference: o
      }),
      start: () => v({
        type: vs,
        id: c.id
      }),
      stop: () => v({
        type: yi,
        id: c.id
      }),
      setStepContainerTarget: (l) => {
        v({
          type: ys,
          id: c.id,
          container: l
        });
      },
      recover: ({ errorId: l }) => {
        v({
          type: Ru,
          id: c.id,
          errorId: l
        });
      },
      dismissExperience: () => v({
        type: Du
      }),
      snoozeExperience: () => v({
        type: Lu
      }),
      seen: () => v({
        type: Pu,
        id: c.id
      }),
      getConfig: () => c,
      interaction: (l, f) => v({
        type: Nu,
        id: c.id,
        interactionType: l,
        interactionData: f
      }),
      extendedEvent: (l, f) => v({
        type: Tu,
        id: c.id,
        name: l,
        ...f
      })
    };
  }, a = t.steps.map(
    (c) => s(c, { forwardToParent: !!n })
  );
  return n ? {
    getRootNodeId: () => r(n.virtualizedContent),
    steps: a,
    step: s(n, { forwardToParent: false })
  } : {
    getRootNodeId: () => r(n.virtualizedContent),
    steps: a
  };
};
var $s = ({
  experience: t,
  step: e,
  overrideStyle: n,
  getContainer: r,
  getRoot: i,
  callback: o,
  get: s,
  getAction: a = () => null
}) => {
  const { findId: c } = s("vNodeHandlers"), u = s("getWindowReference"), v = Pl({
    experience: t,
    step: e,
    callback: o,
    findId: c,
    getContainer: r,
    getWindowReference: u
  }), h = {
    getContainer: r,
    querySelector: (y) => As(y, {
      step: e,
      checkOutsideContainer: true,
      stepContainer: r(),
      getWindowReference: u
    }),
    reportError: (y) => {
      const E = Nl();
      return o({
        type: Au,
        message: y,
        errorId: E
      }), E;
    },
    onElementInserted: (y) => Gu({ ...y, getWindowReference: u }),
    onElementRemoved: (y) => wi({ ...y, getWindowReference: u }),
    ...v,
    stopExperience: () => o(Be),
    getExperienceId: () => t.id,
    getWindowReference: u,
    sendEvent: s("sendEvent"),
    sendCustomEvent: s("sendCustomEvent"),
    showFlow: s("showFlow"),
    updateUserProfile: s("updateUserProfile"),
    getAction: (y) => a(`${t.id}.${y}`) ?? a(`${e.id}.${y}`) ?? a(y)
  };
  return n ? {
    updateStyle: (S, g) => {
      n(S, g), o({
        type: gs,
        id: e.id
      });
    },
    updateRootStyle: (S, g = {}) => {
      o({
        type: Es,
        styles: S,
        options: g,
        getRoot: i
      });
    },
    ...h
  } : h;
};
var ao = "formData.";
var Il = (t, e) => {
  if (e.startsWith(ao)) {
    const n = e.replace(ao, "");
    return new FormData(t.target).get(n);
  }
  return vu(t, e);
};
var { getCallback: wn, registerCallback: ae } = Ds();
var Dl = (t, e, n) => {
  const r = {
    target: e.target,
    detail: e.detail
  };
  return Object.entries(t).reduce(
    (i, [o, s]) => {
      const a = Il(r, o);
      return a ? hu(i, s, a) : i;
    },
    n
  );
};
var Ll = ({ overrideStyle: t, getContainer: e }, n) => ({ experience: r, step: i }) => (o, s) => {
  s(({ type: a }) => {
    if (a === bi)
      try {
        const { findId: c, traverseTree: u, injectHandlers: v } = n("vNodeHandlers"), l = JSON.parse(
          JSON.stringify(i.virtualizedContent)
        );
        u(l, (p) => {
          const h = c(p);
          if (!i.actions[h]) return;
          const y = {}, E = (g, b) => {
            o({
              type: $u
            });
            const _ = $s({
              experience: r,
              step: i,
              overrideStyle: t,
              getContainer: e,
              callback: o,
              get: n,
              getAction: wn
            });
            try {
              y[g].forEach(([x, N, A]) => {
                if (A && b) {
                  const C = {
                    ...N,
                    ...Dl(
                      A,
                      b,
                      N
                    )
                  };
                  x(C, _);
                } else
                  x(N, _);
              });
            } catch {
              _.reportError(
                "something bad happened while running an action."
              );
            } finally {
              o({
                type: Mu
              });
            }
          }, S = i.actions[h].reduce(
            (g, { on: b, type: _, config: x, allowedKeys: N, mapEventToConfig: A }) => {
              const C = wn(`${r.id}.${_}`) ?? wn(`${i.id}.${_}`) ?? wn(_);
              return y[b] || (y[b] = []), C && y[b].push([C, x, A]), b.startsWith("hooks/") ? g.hook[b.replace("hooks/", "")] = () => E(b) : g.on[b] = (I) => {
                N && !N.includes(I.code) || (I.preventDefault(), I.stopPropagation(), E(b, I));
              }, g;
            },
            {
              on: {},
              hook: {}
            }
          );
          p = v(p, S);
        }), o({
          type: ms,
          virtualizedContent: l
        });
      } catch {
        o(Bu);
      }
  });
};
var kl = ({ addHook: t }) => (e) => (n) => {
  const { step: r } = e;
  try {
    r.traits.forEach(
      (i) => Ls({
        getTrait: ks,
        addHook: (o, s) => {
          t(o, { callback: s, traitId: i.id });
        },
        registerAction: (o, s) => {
          ae(`${r.id}.${i.type}.${o}`, s);
        },
        trait: i
      })
    ), n(bi);
  } catch {
    n(Os);
  }
};
var $l = ({ applyOverridesToVnode: t }) => {
  let e = {};
  const n = (s) => (a, c) => {
    e[a] || (e[a] = {}), e[a][s] || (e[a][s] = {}), e[a][s] = {
      ...e[a][s],
      ...c
    };
  }, r = (s) => e[s], i = () => {
    e = {};
  }, o = yt(({ step: s }) => ({
    step: {
      ...s,
      virtualizedContent: t(
        s.virtualizedContent,
        r
      )
    }
  }));
  return {
    createOverrideCallback: n,
    getOverrides: r,
    applyOverrides: o,
    clearOverrides: i
  };
};
function Ml(t, e) {
  return document.createElement(t, e);
}
function Hl(t, e, n) {
  return document.createElementNS(t, e, n);
}
function jl() {
  return Te(document.createDocumentFragment());
}
function Fl(t) {
  return document.createTextNode(t);
}
function Ul(t) {
  return document.createComment(t);
}
function Bl(t, e, n) {
  if (re(t)) {
    let r = t;
    for (; r && re(r); )
      r = Te(r).parent;
    t = r ?? t;
  }
  re(e) && (e = Te(e, t)), n && re(n) && (n = Te(n).firstChildNode), t.insertBefore(e, n);
}
function zl(t, e) {
  t.removeChild(e);
}
function ql(t, e) {
  re(e) && (e = Te(e, t)), t.appendChild(e);
}
function Ms(t) {
  if (re(t)) {
    for (; t && re(t); )
      t = Te(t).parent;
    return t ?? null;
  }
  return t.parentNode;
}
function Wl(t) {
  var e;
  if (re(t)) {
    const n = Te(t), r = Ms(n);
    if (r && n.lastChildNode) {
      const i = Array.from(r.childNodes), o = i.indexOf(n.lastChildNode);
      return (e = i[o + 1]) !== null && e !== void 0 ? e : null;
    }
    return null;
  }
  return t.nextSibling;
}
function Vl(t) {
  return t.tagName;
}
function Gl(t, e) {
  t.textContent = e;
}
function Kl(t) {
  return t.textContent;
}
function Xl(t) {
  return t.nodeType === 1;
}
function Yl(t) {
  return t.nodeType === 3;
}
function Zl(t) {
  return t.nodeType === 8;
}
function re(t) {
  return t.nodeType === 11;
}
function Te(t, e) {
  var n, r, i;
  const o = t;
  return (n = o.parent) !== null && n !== void 0 || (o.parent = e ?? null), (r = o.firstChildNode) !== null && r !== void 0 || (o.firstChildNode = t.firstChild), (i = o.lastChildNode) !== null && i !== void 0 || (o.lastChildNode = t.lastChild), o;
}
var xi = {
  createElement: Ml,
  createElementNS: Hl,
  createTextNode: Fl,
  createDocumentFragment: jl,
  createComment: Ul,
  insertBefore: Bl,
  removeChild: zl,
  appendChild: ql,
  parentNode: Ms,
  nextSibling: Wl,
  tagName: Vl,
  setTextContent: Gl,
  getTextContent: Kl,
  isElement: Xl,
  isText: Yl,
  isComment: Zl,
  isDocumentFragment: re
};
function Pt(t, e, n, r, i) {
  const o = e === void 0 ? void 0 : e.key;
  return { sel: t, data: e, children: n, text: r, elm: i, key: o };
}
var Ze = Array.isArray;
function Re(t) {
  return typeof t == "string" || typeof t == "number" || t instanceof String || t instanceof Number;
}
var kr = Pt("", {}, [], void 0, void 0);
function gn(t, e) {
  var n, r;
  const i = t.key === e.key, o = ((n = t.data) === null || n === void 0 ? void 0 : n.is) === ((r = e.data) === null || r === void 0 ? void 0 : r.is), s = t.sel === e.sel, a = !t.sel && t.sel === e.sel ? typeof t.text == typeof e.text : true;
  return s && i && o && a;
}
function Jl() {
  throw new Error("The document fragment is not supported on this platform.");
}
function Ql(t, e) {
  return t.isElement(e);
}
function tf(t, e) {
  return t.isDocumentFragment(e);
}
function ef(t, e, n) {
  var r;
  const i = {};
  for (let o = e; o <= n; ++o) {
    const s = (r = t[o]) === null || r === void 0 ? void 0 : r.key;
    s !== void 0 && (i[s] = o);
  }
  return i;
}
var nf = [
  "create",
  "update",
  "remove",
  "destroy",
  "pre",
  "post"
];
function Hs(t, e, n) {
  const r = {
    create: [],
    update: [],
    remove: [],
    destroy: [],
    pre: [],
    post: []
  }, i = e !== void 0 ? e : xi;
  for (const h of nf)
    for (const y of t) {
      const E = y[h];
      E !== void 0 && r[h].push(E);
    }
  function o(h) {
    const y = h.id ? "#" + h.id : "", E = h.getAttribute("class"), S = E ? "." + E.split(" ").join(".") : "";
    return Pt(i.tagName(h).toLowerCase() + y + S, {}, [], void 0, h);
  }
  function s(h) {
    return Pt(void 0, {}, [], void 0, h);
  }
  function a(h, y) {
    return function() {
      if (--y === 0) {
        const S = i.parentNode(h);
        S !== null && i.removeChild(S, h);
      }
    };
  }
  function c(h, y) {
    var E, S, g, b, _;
    let x;
    const N = h.data, A = N?.hook;
    (E = A?.init) === null || E === void 0 || E.call(A, h);
    const C = h.children, I = h.sel;
    if (I === "!")
      (S = h.text) !== null && S !== void 0 || (h.text = ""), h.elm = i.createComment(h.text);
    else if (I === "")
      h.elm = i.createTextNode(h.text);
    else if (I !== void 0) {
      const L = I.indexOf("#"), j = I.indexOf(".", L), k = L > 0 ? L : I.length, q = j > 0 ? j : I.length, K = L !== -1 || j !== -1 ? I.slice(0, Math.min(k, q)) : I, W = N?.ns, ot = W === void 0 ? i.createElement(K, N) : i.createElementNS(W, K, N);
      for (h.elm = ot, k < q && ot.setAttribute("id", I.slice(k + 1, q)), j > 0 && ot.setAttribute("class", I.slice(q + 1).replace(/\./g, " ")), x = 0; x < r.create.length; ++x)
        r.create[x](kr, h);
      if (Re(h.text) && (!Ze(C) || C.length === 0) && i.appendChild(ot, i.createTextNode(h.text)), Ze(C))
        for (x = 0; x < C.length; ++x) {
          const ut = C[x];
          ut != null && i.appendChild(ot, c(ut, y));
        }
      A !== void 0 && ((g = A.create) === null || g === void 0 || g.call(A, kr, h), A.insert !== void 0 && y.push(h));
    } else if (!((b = n?.experimental) === null || b === void 0) && b.fragments && h.children) {
      for (h.elm = ((_ = i.createDocumentFragment) !== null && _ !== void 0 ? _ : Jl)(), x = 0; x < r.create.length; ++x)
        r.create[x](kr, h);
      for (x = 0; x < h.children.length; ++x) {
        const L = h.children[x];
        L != null && i.appendChild(h.elm, c(L, y));
      }
    } else
      h.elm = i.createTextNode(h.text);
    return h.elm;
  }
  function u(h, y, E, S, g, b) {
    for (; S <= g; ++S) {
      const _ = E[S];
      _ != null && i.insertBefore(h, c(_, b), y);
    }
  }
  function v(h) {
    var y, E;
    const S = h.data;
    if (S !== void 0) {
      (E = (y = S?.hook) === null || y === void 0 ? void 0 : y.destroy) === null || E === void 0 || E.call(y, h);
      for (let g = 0; g < r.destroy.length; ++g)
        r.destroy[g](h);
      if (h.children !== void 0)
        for (let g = 0; g < h.children.length; ++g) {
          const b = h.children[g];
          b != null && typeof b != "string" && v(b);
        }
    }
  }
  function l(h, y, E, S) {
    for (var g, b; E <= S; ++E) {
      let _;
      const x = y[E];
      if (x != null)
        if (x.sel !== void 0) {
          v(x), _ = r.remove.length + 1;
          const N = a(x.elm, _);
          for (let C = 0; C < r.remove.length; ++C)
            r.remove[C](x, N);
          const A = (b = (g = x?.data) === null || g === void 0 ? void 0 : g.hook) === null || b === void 0 ? void 0 : b.remove;
          A !== void 0 ? A(x, N) : N();
        } else x.children ? (v(x), l(h, x.children, 0, x.children.length - 1)) : i.removeChild(h, x.elm);
    }
  }
  function f(h, y, E, S) {
    let g = 0, b = 0, _ = y.length - 1, x = y[0], N = y[_], A = E.length - 1, C = E[0], I = E[A], L, j, k, q;
    for (; g <= _ && b <= A; )
      x == null ? x = y[++g] : N == null ? N = y[--_] : C == null ? C = E[++b] : I == null ? I = E[--A] : gn(x, C) ? (p(x, C, S), x = y[++g], C = E[++b]) : gn(N, I) ? (p(N, I, S), N = y[--_], I = E[--A]) : gn(x, I) ? (p(x, I, S), i.insertBefore(h, x.elm, i.nextSibling(N.elm)), x = y[++g], I = E[--A]) : gn(N, C) ? (p(N, C, S), i.insertBefore(h, N.elm, x.elm), N = y[--_], C = E[++b]) : (L === void 0 && (L = ef(y, g, _)), j = L[C.key], j === void 0 ? (i.insertBefore(h, c(C, S), x.elm), C = E[++b]) : L[I.key] === void 0 ? (i.insertBefore(h, c(I, S), i.nextSibling(N.elm)), I = E[--A]) : (k = y[j], k.sel !== C.sel ? i.insertBefore(h, c(C, S), x.elm) : (p(k, C, S), y[j] = void 0, i.insertBefore(h, k.elm, x.elm)), C = E[++b]));
    b <= A && (q = E[A + 1] == null ? null : E[A + 1].elm, u(h, q, E, b, A, S)), g <= _ && l(h, y, g, _);
  }
  function p(h, y, E) {
    var S, g, b, _, x, N, A, C;
    const I = (S = y.data) === null || S === void 0 ? void 0 : S.hook;
    (g = I?.prepatch) === null || g === void 0 || g.call(I, h, y);
    const L = y.elm = h.elm;
    if (h === y)
      return;
    if (y.data !== void 0 || y.text !== void 0 && y.text !== h.text) {
      (b = y.data) !== null && b !== void 0 || (y.data = {}), (_ = h.data) !== null && _ !== void 0 || (h.data = {});
      for (let q = 0; q < r.update.length; ++q)
        r.update[q](h, y);
      (A = (N = (x = y.data) === null || x === void 0 ? void 0 : x.hook) === null || N === void 0 ? void 0 : N.update) === null || A === void 0 || A.call(N, h, y);
    }
    const j = h.children, k = y.children;
    y.text === void 0 ? j !== void 0 && k !== void 0 ? j !== k && f(L, j, k, E) : k !== void 0 ? (h.text !== void 0 && i.setTextContent(L, ""), u(L, null, k, 0, k.length - 1, E)) : j !== void 0 ? l(L, j, 0, j.length - 1) : h.text !== void 0 && i.setTextContent(L, "") : h.text !== y.text && (j !== void 0 && l(L, j, 0, j.length - 1), i.setTextContent(L, y.text)), (C = I?.postpatch) === null || C === void 0 || C.call(I, h, y);
  }
  return function(y, E) {
    let S, g, b;
    const _ = [];
    for (S = 0; S < r.pre.length; ++S)
      r.pre[S]();
    for (Ql(i, y) ? y = o(y) : tf(i, y) && (y = s(y)), gn(y, E) ? p(y, E, _) : (g = y.elm, b = i.parentNode(g), c(E, _), b !== null && (i.insertBefore(b, E.elm, i.nextSibling(g)), l(b, [y], 0, 0))), S = 0; S < _.length; ++S)
      _[S].data.hook.insert(_[S]);
    for (S = 0; S < r.post.length; ++S)
      r.post[S]();
    return E;
  };
}
function wr(t, e, n) {
  if (t.ns = "http://www.w3.org/2000/svg", n !== "foreignObject" && e !== void 0)
    for (let r = 0; r < e.length; ++r) {
      const i = e[r];
      if (typeof i == "string")
        continue;
      const o = i.data;
      o !== void 0 && wr(o, i.children, i.sel);
    }
}
function se(t, e, n) {
  let r = {}, i, o, s;
  if (n !== void 0 ? (e !== null && (r = e), Ze(n) ? i = n : Re(n) ? o = n.toString() : n && n.sel && (i = [n])) : e != null && (Ze(e) ? i = e : Re(e) ? o = e.toString() : e && e.sel ? i = [e] : r = e), i !== void 0)
    for (s = 0; s < i.length; ++s)
      Re(i[s]) && (i[s] = Pt(void 0, void 0, void 0, i[s], void 0));
  return t.startsWith("svg") && (t.length === 3 || t[3] === "." || t[3] === "#") && wr(r, i, t), Pt(t, r, i, o, void 0);
}
function si(t) {
  let e, n;
  if (Ze(t) ? e = t : Re(e) ? n = t : e && e.sel && (e = [t]), e !== void 0)
    for (let r = 0; r < e.length; ++r)
      Re(e[r]) && (e[r] = Pt(void 0, void 0, void 0, e[r], void 0));
  return Pt(void 0, {}, e, n, void 0);
}
function Qn(t, e) {
  var n;
  const r = (n = e.data) === null || n === void 0 ? void 0 : n.ns;
  t.data.fn = e.data.fn, t.data.args = e.data.args, e.data = t.data, e.children = t.children, e.text = t.text, e.elm = t.elm, r && wr(e.data, e.children, e.sel);
}
function rf(t) {
  const e = t.data, n = e.fn(...e.args);
  Qn(n, t);
}
function of(t, e) {
  let n;
  const r = t.data, i = e.data, o = r.args, s = i.args;
  if (r.fn !== i.fn || o.length !== s.length) {
    Qn(i.fn(...s), e);
    return;
  }
  for (n = 0; n < s.length; ++n)
    if (o[n] !== s[n]) {
      Qn(i.fn(...s), e);
      return;
    }
  Qn(t, e);
}
var sf = function(e, n, r, i) {
  return i === void 0 && (i = r, r = n, n = void 0), se(e, {
    key: n,
    hook: { init: rf, prepatch: of },
    fn: r,
    args: i
  });
};
function af(t, e) {
  const n = t.data.attachData;
  e.data.attachData.placeholder = n.placeholder, e.data.attachData.real = n.real, t.elm = t.data.attachData.real;
}
function cf(t, e) {
  e.elm = e.data.attachData.placeholder;
}
function uf(t) {
  t.elm !== void 0 && t.elm.parentNode.removeChild(t.elm), t.elm = t.data.attachData.real;
}
function lf(t, e) {
  const n = e.elm, r = e.data.attachData, i = document.createElement("span");
  e.elm = i, r.target.appendChild(n), r.real = n, r.placeholder = i;
}
function ff(t, e) {
  e.data === void 0 && (e.data = {}), e.data.hook === void 0 && (e.data.hook = {});
  const n = e.data, r = e.data.hook;
  return n.attachData = { target: t, placeholder: void 0, real: void 0 }, r.create = lf, r.prepatch = af, r.postpatch = cf, r.destroy = uf, e;
}
function df(t) {
  return t.slice(5).replace(/-([a-z])/g, (e, n) => n.toUpperCase());
}
function js(t, e) {
  var n;
  const r = e !== void 0 ? e : xi;
  let i;
  if (r.isElement(t)) {
    const o = t.id ? "#" + t.id : "", s = (n = t.getAttribute("class")) === null || n === void 0 ? void 0 : n.match(/[^\t\r\n\f ]+/g), a = s ? "." + s.join(".") : "", c = r.tagName(t).toLowerCase() + o + a, u = {}, v = {}, l = {}, f = [];
    let p, h, y;
    const E = t.attributes, S = t.childNodes;
    for (h = 0, y = E.length; h < y; h++)
      p = E[h].nodeName, p.startsWith("data-") ? v[df(p)] = E[h].nodeValue || "" : p !== "id" && p !== "class" && (u[p] = E[h].nodeValue);
    for (h = 0, y = S.length; h < y; h++)
      f.push(js(S[h], e));
    return Object.keys(u).length > 0 && (l.attrs = u), Object.keys(v).length > 0 && (l.dataset = v), c.startsWith("svg") && (c.length === 3 || c[3] === "." || c[3] === "#") && wr(l, f, c), Pt(c, l, f, void 0, t);
  } else return r.isText(t) ? (i = r.getTextContent(t), Pt(void 0, void 0, void 0, i, t)) : r.isComment(t) ? (i = r.getTextContent(t), Pt("!", {}, [], i, t)) : Pt("", {}, [], void 0, t);
}
var pf = "http://www.w3.org/1999/xlink";
var hf = "http://www.w3.org/2000/xmlns/";
var vf = "http://www.w3.org/XML/1998/namespace";
var co = 58;
var gf = 120;
var yf = 109;
function uo(t, e) {
  let n;
  const r = e.elm;
  let i = t.data.attrs, o = e.data.attrs;
  if (!(!i && !o) && i !== o) {
    i = i || {}, o = o || {};
    for (n in o) {
      const s = o[n];
      i[n] !== s && (s === true ? r.setAttribute(n, "") : s === false ? r.removeAttribute(n) : n.charCodeAt(0) !== gf ? r.setAttribute(n, s) : n.charCodeAt(3) === co ? r.setAttributeNS(vf, n, s) : n.charCodeAt(5) === co ? n.charCodeAt(1) === yf ? r.setAttributeNS(hf, n, s) : r.setAttributeNS(pf, n, s) : r.setAttribute(n, s));
    }
    for (n in i)
      n in o || r.removeAttribute(n);
  }
}
var Fs = {
  create: uo,
  update: uo
};
function lo(t, e) {
  let n, r;
  const i = e.elm;
  let o = t.data.class, s = e.data.class;
  if (!(!o && !s) && o !== s) {
    o = o || {}, s = s || {};
    for (r in o)
      o[r] && !Object.prototype.hasOwnProperty.call(s, r) && i.classList.remove(r);
    for (r in s)
      n = s[r], n !== o[r] && i.classList[n ? "add" : "remove"](r);
  }
}
var Us = { create: lo, update: lo };
var fo = /[A-Z]/g;
function po(t, e) {
  const n = e.elm;
  let r = t.data.dataset, i = e.data.dataset, o;
  if (!r && !i || r === i)
    return;
  r = r || {}, i = i || {};
  const s = n.dataset;
  for (o in r)
    o in i || (s ? o in s && delete s[o] : n.removeAttribute("data-" + o.replace(fo, "-$&").toLowerCase()));
  for (o in i)
    r[o] !== i[o] && (s ? s[o] = i[o] : n.setAttribute("data-" + o.replace(fo, "-$&").toLowerCase(), i[o]));
}
var mf = {
  create: po,
  update: po
};
function Bs(t, e, n) {
  if (typeof t == "function")
    t.call(e, n, e);
  else if (typeof t == "object")
    for (let r = 0; r < t.length; r++)
      Bs(t[r], e, n);
}
function Ef(t, e) {
  const n = t.type, r = e.data.on;
  r && r[n] && Bs(r[n], e, t);
}
function Sf() {
  return function t(e) {
    Ef(e, t.vnode);
  };
}
function $r(t, e) {
  const n = t.data.on, r = t.listener, i = t.elm, o = e && e.data.on, s = e && e.elm;
  let a;
  if (n !== o) {
    if (n && r)
      if (o)
        for (a in n)
          o[a] || i.removeEventListener(a, r, false);
      else
        for (a in n)
          i.removeEventListener(a, r, false);
    if (o) {
      const c = e.listener = t.listener || Sf();
      if (c.vnode = e, n)
        for (a in o)
          n[a] || s.addEventListener(a, c, false);
      else
        for (a in o)
          s.addEventListener(a, c, false);
    }
  }
}
var zs = {
  create: $r,
  update: $r,
  destroy: $r
};
function ho(t, e) {
  let n, r, i;
  const o = e.elm;
  let s = t.data.props, a = e.data.props;
  if (!(!s && !a) && s !== a) {
    s = s || {}, a = a || {};
    for (n in a)
      r = a[n], i = s[n], i !== r && (n !== "value" || o[n] !== r) && (o[n] = r);
  }
}
var qs = { create: ho, update: ho };
var vo = typeof window?.requestAnimationFrame == "function" ? window.requestAnimationFrame.bind(window) : setTimeout;
var bf = (t) => {
  vo(() => {
    vo(t);
  });
};
var ai = false;
function wf(t, e, n) {
  bf(() => {
    t[e] = n;
  });
}
function go(t, e) {
  let n, r;
  const i = e.elm;
  let o = t.data.style, s = e.data.style;
  if (!o && !s || o === s)
    return;
  o = o || {}, s = s || {};
  const a = "delayed" in o;
  for (r in o)
    r in s || (r[0] === "-" && r[1] === "-" ? i.style.removeProperty(r) : i.style[r] = "");
  for (r in s)
    if (n = s[r], r === "delayed" && s.delayed)
      for (const c in s.delayed)
        n = s.delayed[c], (!a || n !== o.delayed[c]) && wf(i.style, c, n);
    else r !== "remove" && n !== o[r] && (r[0] === "-" && r[1] === "-" ? i.style.setProperty(r, n) : i.style[r] = n);
}
function xf(t) {
  let e, n;
  const r = t.elm, i = t.data.style;
  if (!(!i || !(e = i.destroy)))
    for (n in e)
      r.style[n] = e[n];
}
function _f(t, e) {
  const n = t.data.style;
  if (!n || !n.remove) {
    e();
    return;
  }
  ai || (t.elm.offsetLeft, ai = true);
  let r;
  const i = t.elm;
  let o = 0;
  const s = n.remove;
  let a = 0;
  const c = [];
  for (r in s)
    c.push(r), i.style[r] = s[r];
  const v = getComputedStyle(i)["transition-property"].split(", ");
  for (; o < v.length; ++o)
    c.indexOf(v[o]) !== -1 && a++;
  i.addEventListener("transitionend", (l) => {
    l.target === i && --a, a === 0 && e();
  });
}
function Tf() {
  ai = false;
}
var Ws = {
  pre: Tf,
  create: go,
  update: go,
  destroy: xf,
  remove: _f
};
function Rf(t, ...e) {
  const n = _i(e, []);
  return n.length === 1 && !n[0].sel && n[0].text ? Pt(void 0, void 0, void 0, n[0].text, void 0) : Pt(void 0, t ?? {}, n, void 0, void 0);
}
function _i(t, e) {
  for (const n of t)
    n != null && n !== false && n !== "" && (Array.isArray(n) ? _i(n, e) : typeof n == "string" || typeof n == "number" || typeof n == "boolean" ? e.push(Pt(void 0, void 0, void 0, String(n), void 0)) : e.push(n));
  return e;
}
function Cf(t, e, ...n) {
  const r = _i(n, []);
  return typeof t == "function" ? t(e, r) : r.length === 1 && !r[0].sel && r[0].text ? se(t, e, r[0].text) : se(t, e, r);
}
var Of = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Fragment: Rf,
  array: Ze,
  attachTo: ff,
  attributesModule: Fs,
  classModule: Us,
  datasetModule: mf,
  eventListenersModule: zs,
  fragment: si,
  h: se,
  htmlDomApi: xi,
  init: Hs,
  jsx: Cf,
  primitive: Re,
  propsModule: qs,
  styleModule: Ws,
  thunk: sf,
  toVNode: js,
  vnode: Pt
}, Symbol.toStringTag, { value: "Module" }));
var Af = (...t) => (e) => t.reduce((n, r) => r(n), e);
var yo = (t) => t.reduce(
  (e, { callback: n, context: r }) => e.then(() => n(r)),
  Promise.resolve()
);
var Nf = ({
  experience: t,
  onRender: e,
  onRenderReset: n,
  wrapContent: r,
  getWindowReference: i = () => window
}) => {
  let o = null, s = null;
  const a = () => {
    const b = i().document, _ = Ne(t.id);
    return b.documentElement.querySelector(`#${_}`);
  }, c = () => s ? s.shadowRoot : null, u = () => o ? o.shadowRoot : null, l = Af(
    (b) => (u() !== null || c() !== null || (o = a()), b),
    r,
    ({ step: { virtualizedContent: b } }) => {
      e(
        c() ?? u(),
        b
      );
    }
  );
  return {
    render: async (b) => new Promise((_) => {
      _(l(b));
    }),
    unmount: () => e(null, se("!")),
    setContainer: (b, { container: _ }) => {
      const { theme: x, themeSystem: N, accountId: A } = b.experience, { id: C } = b.step;
      s && s.remove(), s = Ns({
        accountId: A,
        id: C,
        // a defined themeSystem value means the theme is an open-builder theme and so we don't need to load it via the legacy theme system
        ...!N && { theme: x },
        getWindowReference: i
      }), _.parentNode.replaceChild(s, _);
    },
    resetRender: () => {
      o = null, s && s.remove(), s = null, n();
    },
    getContainer: () => c() ?? u() ?? a().shadowRoot,
    getRoot: () => s ?? a(),
    hasCustomContainer: (b, _) => _.type === Es && _.options?.forceUpdate || !!c()
  };
};
var Pf = ({ container: t, nodes: e }, n = 0) => t.replace(/<% node %>/, e[n]);
var If = (t) => t.replaceAll("//twemoji.maxcdn.com/2/svg/", "//cdn.jsdelivr.net/gh/twitter/twemoji@14.0.2/assets/svg/");
var Df = (t) => t.split("_").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
var Bt = ({ experience: t, experienceInstanceId: e }, n) => ({
  experienceId: t.id,
  experienceName: t.name,
  experienceType: t.type,
  isCoreEvent: true,
  localeName: t.context?.localeName || "default",
  localeId: t.context?.localeId || "default",
  timestamp: Date.now(),
  version: t.version,
  name: Df(n),
  experienceInstanceId: e
});
var ge = ({ step: t }) => ({
  stepId: t.id,
  stepName: t.name,
  stepType: t.type
});
var Lf = (t, e) => !t.blockedEvents[e.type];
var Vs = (t) => {
  const e = (p) => {
    const h = "experience_started", y = Bt(p, h);
    t("sendEvent")(h, y);
  }, n = (p) => {
    const h = "experience_completed", y = Bt(p, h);
    t("sendEvent")(h, y);
  }, r = (p, { message: h }) => {
    const y = "experience_error", E = Bt(p, y);
    t("sendEvent")(y, { ...E, message: h });
  }, i = (p) => {
    const h = "experience_dismissed", y = Bt(p, h), E = ge(p);
    t("sendEvent")(h, {
      ...y,
      ...E
    });
  }, o = (p) => {
    const h = "experience_snoozed", y = Bt(p, h), E = ge(p);
    t("sendEvent")(h, {
      ...y,
      ...E
    });
  }, s = (p) => {
    const h = "step_seen", y = Bt(p, h), E = ge(p);
    t("sendEvent")(h, {
      ...y,
      ...E
    });
  }, a = (p) => {
    const h = "step_completed", y = Bt(p, h), E = ge(p);
    t("sendEvent")(h, {
      ...y,
      ...E
    });
  }, c = (p, h) => {
    const y = Bt(p, h.name), E = ge(p), S = t("sendEvent"), { name: g, ...b } = h;
    S(g, {
      ...y,
      ...E,
      ...b
    });
  }, u = (p, { interactionType: h, interactionData: y }) => {
    const E = "step_interaction", S = Bt(p, E), g = ge(p);
    t("sendEvent")(E, {
      ...S,
      ...g,
      interactionType: h,
      interactionData: y
    });
  }, v = (p, { message: h, errorId: y }) => {
    const E = "step_error", S = Bt(p, E), g = ge(p);
    t("sendEvent")(E, {
      ...S,
      ...g,
      message: h,
      errorId: y
    });
  }, l = (p, { errorId: h }) => {
    const y = "step_recovered", E = Bt(p, y), S = ge(p);
    t("sendEvent")(y, {
      ...E,
      ...S,
      errorId: h
    });
  }, f = yt((p, { type: h, name: y = "" }) => {
    const E = h === "EXTENDED_EVENT" ? y : h;
    return {
      blockedEvents: {
        ...p.blockedEvents,
        [E]: true
      }
    };
  });
  return {
    experienceActions: {
      experienceStarted: e,
      experienceError: r,
      experienceCompleted: n
    },
    stepActions: {
      // NOTE: see above why this "experience" event is included in stepActions
      experienceDismissed: i,
      experienceSnoozed: o,
      stepSeen: s,
      stepInteraction: u,
      stepError: v,
      stepRecovered: l,
      stepExtendedEvent: c,
      stepCompleted: a
    },
    helpers: {
      blockEvent: f,
      isEventEnabled: Lf
    }
  };
};
var kf = Er({
  initial: "waitingForAsyncEvents",
  context: {
    runHooksDone: false
  },
  states: {
    waitingForAsyncEvents: {
      on: {
        UPDATE_STEP: "update_step",
        ERROR: "error",
        RUN_HOOKS_DONE: {
          target: "",
          actions: yt({
            runHooksDone: true
          })
        }
      }
    },
    update_step: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [qt("RERENDER")]
        }
      ],
      on: {
        UPDATE_STEP: "",
        ERROR: "error",
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            yt({
              runHooksDone: true
            }),
            qt("RERENDER")
          ]
        }
      }
    },
    error: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [qt("FORCE_ERROR")]
        }
      ],
      on: {
        UPDATE_STEP: "",
        ERROR: "",
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            yt({
              runHooksDone: true
            }),
            qt("FORCE_ERROR")
          ]
        }
      }
    },
    done: {
      type: "final"
    }
  }
});
var $f = Er({
  initial: "waitingForAsyncEvents",
  context: {
    runHooksDone: false
  },
  states: {
    waitingForAsyncEvents: {
      on: {
        RECOVER_STEP: "recover_step",
        RUN_HOOKS_DONE: {
          target: "",
          actions: yt({
            runHooksDone: true
          })
        }
      }
    },
    recover_step: {
      always: [
        {
          target: "done",
          cond: (t) => t.runHooksDone,
          actions: [qt("FORCE_RECOVER")]
        }
      ],
      on: {
        RUN_HOOKS_DONE: {
          target: "done",
          actions: [
            yt({
              runHooksDone: true
            }),
            qt("FORCE_RECOVER")
          ]
        }
      }
    },
    done: {
      type: "final"
    }
  }
});
var Mf = {
  initial: "waiting_to_render",
  on: {
    SET_STEP_CONTAINER_TARGET: {
      actions: ["setContainer", "runStepContainerChangeHooks"],
      target: ""
    },
    UPDATE_ROOT_STYLE: {
      actions: "updateRootStyle",
      target: "",
      // updateRootStyle should only be called if
      // step has custom container since otherwise,
      // it would affect the global appcues-container
      // where multiple steps may coexist.
      cond: "hasCustomContainer"
    },
    UPDATE_STEP_CONTENT: {
      actions: "setContent",
      target: ""
    },
    RUN_HOOKS_ERROR: "destroyed",
    BIND_ACTIONS_ERROR: "destroyed",
    STOP_STEP: [
      {
        cond: "hasPendingActions",
        target: "waitingPendingActions",
        actions: ["saveStopReason"],
        internal: true
      },
      {
        target: "running_end_hooks",
        actions: ["saveStopReason"]
      }
    ],
    // Transitions by default are internal: false
    // meaning it will run entry, exit actions and also invoked services.
    // In this case we can't let it be false, otherwise the service instance (hooks and actions)
    // will not be the same and the sync callback calls will stop working
    // since the current callback instance was stopped to start a new one.
    // letting internal:true the service will be started just one time.
    // check https://xstate.js.org/docs/guides/transitions.html#internal-transitions
    // to understand better about internal config.
    PARENT_RECOVER_STEP: {
      actions: ["stepRecovered"],
      target: "rendering",
      internal: true
    },
    EXPERIENCE_DISMISSED: {
      target: "",
      actions: [
        "experienceDismissed",
        qt({ type: Be, reason: Oe.DISMISSED })
      ]
    },
    EXPERIENCE_SNOOZED: {
      target: "",
      actions: ["experienceSnoozed"]
    },
    STEP_SEEN: {
      target: "",
      actions: ["stepSeen", "blockEvent"],
      cond: "isEventEnabled"
    },
    STEP_INTERACTION: {
      target: "",
      actions: ["stepInteraction"]
    },
    EXTENDED_EVENT: {
      actions: ["stepExtendedEvent", "blockEvent"],
      cond: "isEventEnabled"
    },
    RELOAD: [
      {
        target: "reload",
        actions: ["updateTheme", "updateStepContext"],
        cond: "didThemeChange"
      },
      {
        target: "reloading_traits",
        actions: ["setVirtualizedContent", "updateStepContext"],
        cond: "shouldOnlyReloadTraits"
      },
      {
        target: "reload",
        actions: ["setVirtualizedContent", "updateStepContext"],
        cond: "shouldStepReload"
      },
      {
        target: "rendering",
        internal: true,
        actions: ["setVirtualizedContent", "updateStepContext"],
        cond: "didContentChanged"
      }
    ],
    [Be]: {
      actions: [qt(Be)]
    },
    FORWARD_TO_PARENT: [
      {
        actions: [
          qt((t, { eventType: e, ...n }) => ({
            ...n,
            type: e
          }))
        ],
        internal: true
      }
    ],
    ACTIONS_STARTED: {
      target: "",
      actions: "setActionsRunning",
      internal: true
    },
    ACTIONS_FINISHED: {
      target: "",
      actions: "setActionsFinished",
      internal: true
    }
  },
  invoke: [
    {
      id: "hooksService",
      src: "hooksService"
    },
    {
      id: "actionsService",
      src: "actionsService"
    },
    {
      id: "themeRemovalService",
      src: "themeRemovalService"
    }
  ],
  states: {
    waiting_to_render: {
      on: {
        START_STEP: "running_traits"
      }
    },
    reload: {
      entry: [
        "removeCustomContainer",
        "unmount",
        "resetRender",
        "clearOverrides",
        "runStepEndHooks"
      ],
      exit: ["removeStepHooks"],
      on: {
        RUN_HOOKS_DONE: {
          target: "running_traits"
        }
      }
    },
    reloading_traits: {
      entry: ["runStepEndHooks", "runStepBeginHooks"],
      // Only run for the changed traits
      on: {
        // Certain traits can dispatch errors while in begin state
        // like inline traits, in this case we still need to catch these errors
        // and we send it directly to error state, since the rendering flow didn't started.
        ERROR: {
          target: "error",
          internal: true,
          actions: "stepError"
        },
        RUN_HOOKS_DONE: {
          target: "rendering",
          actions: "ensuresElementsAreAccessible",
          cond: "isHooksDoneEventBeginType"
        }
      }
    },
    running_traits: {
      invoke: {
        src: "runStepTraits"
      },
      on: {
        RUN_TRAITS_DONE: {
          target: "begin",
          // We can only bind actions' callbacks after running the traits
          // because traits can register actions.
          // so the action service will only do something after receiving
          // the confirmation that the traits are done with its execution.
          actions: Me("actionsService")
        },
        RUN_TRAITS_ERROR: "destroyed"
      }
    },
    begin: {
      entry: ["runStepBeginHooks"],
      on: {
        // Certain traits can dispatch errors while in begin state
        // like inline traits, in this case we still need to catch these errors
        // and we send it directly to error state, since the rendering flow didn't started.
        ERROR: {
          target: "error",
          internal: true,
          actions: "stepError"
        },
        RUN_HOOKS_DONE: {
          target: "rendering",
          actions: "ensuresElementsAreAccessible",
          cond: "isHooksDoneEventBeginType"
        }
      }
    },
    rendering: {
      initial: "pre-render",
      on: {
        STEP_CONTAINER_REMOVED: {
          target: "error",
          internal: false
        }
      },
      states: {
        "pre-render": {
          entry: ["runStepPreRenderHooks"],
          on: {
            RUN_HOOKS_DONE: [
              {
                target: "render",
                actions: ["applyOverrides"],
                cond: "isHooksDoneEventPreRenderType"
              }
            ]
          }
        },
        render: {
          invoke: {
            src: "render",
            onDone: [
              {
                target: "post-render",
                cond: "hasCustomContainer",
                actions: "startThemeRemovalListener"
              },
              {
                target: "post-render"
              }
            ]
          }
        },
        "post-render": {
          invoke: {
            id: "postRenderAsyncEventsHandler",
            src: kf
          },
          entry: ["runStepPostRenderHooks"],
          on: {
            FORCE_ERROR: "#error",
            RERENDER: "pre-render",
            UPDATE_STEP: {
              target: "",
              actions: [Me("postRenderAsyncEventsHandler")]
            },
            ERROR: {
              target: "",
              actions: [Me("postRenderAsyncEventsHandler"), "stepError"]
            },
            RUN_HOOKS_DONE: {
              target: "",
              cond: "isHooksDoneEventPostRenderType",
              actions: [
                "notifyExperienceStarted",
                Me("postRenderAsyncEventsHandler")
              ]
            }
          }
        }
      }
    },
    running_end_hooks: {
      entry: ["runStepEndHooks"],
      on: {
        RUN_HOOKS_DONE: [
          {
            cond: "shouldFireStepCompletedEvent",
            target: "end",
            actions: [
              "removeCustomContainer",
              "unmount",
              "stepCompleted",
              "notifyStepStopped",
              "removeStepHooks"
            ]
          },
          {
            cond: "isHooksDoneEventEndType",
            target: "end",
            actions: [
              "removeCustomContainer",
              "unmount",
              "notifyStepStopped",
              "removeStepHooks"
            ]
          }
        ]
      }
    },
    end: {
      type: "final"
    },
    error: {
      id: "error",
      invoke: [
        {
          id: "errorAsyncEventsHandler",
          src: $f
        }
      ],
      entry: ["unmount", "runStepErrorHooks", "stopThemeRemovalListener"],
      on: {
        RUN_HOOKS_DONE: {
          target: "",
          cond: "isHooksDoneEventErrorType",
          actions: [Me("errorAsyncEventsHandler"), "autoRecover"]
        },
        RECOVER_STEP: {
          target: "",
          actions: [Me("errorAsyncEventsHandler")]
        },
        FORCE_RECOVER: {
          target: "begin",
          actions: ["resetRender", "stepRecovered"]
        },
        AUTO_RECOVER_STEP: {
          target: "begin",
          actions: "resetRender",
          cond: "isAutoRecoverEvent"
        }
      }
    },
    destroyed: {
      entry: ["stepError", "unmount"]
    },
    waitingPendingActions: {
      on: {
        ACTIONS_FINISHED: {
          target: "running_end_hooks",
          actions: "setActionsFinished"
        }
      }
    }
  }
};
var Gs = (t, { createStepHooks: e, createHooksService: n, experience: r, get: i, experienceInstanceId: o }) => {
  const {
    virtualizeContent: s,
    createVnodeTree: a,
    wrapContent: c,
    applyOverridesToVnode: u
  } = i("vNodeHandlers"), { makeElementsAccessible: v } = i("accessibilityHandlers"), { applyOverrides: l, createOverrideCallback: f, clearOverrides: p } = $l({
    applyOverridesToVnode: u
  }), h = f("style"), y = i("getWindowReference"), { onRender: E, onRenderReset: S } = i("createRenderListener")(), {
    render: g,
    unmount: b,
    setContainer: _,
    resetRender: x,
    getContainer: N,
    hasCustomContainer: A,
    getRoot: C
  } = Nf({
    experience: r,
    onRender: E,
    onRenderReset: S,
    wrapContent: c,
    getWindowReference: y
  }), {
    addHook: I,
    runStepBeginHooks: L,
    runStepPreRenderHooks: j,
    runStepPostRenderHooks: k,
    runStepEndHooks: q,
    runStepErrorHooks: K,
    removeStepHooks: W,
    runStepContainerChangeHooks: ot
  } = e({
    step: t,
    overrideStyle: h
  }), ut = kl({
    addHook: I
  }), Q = Ll(
    {
      overrideStyle: h,
      getContainer: N
    },
    i
  ), mt = n(
    {
      overrideStyle: h,
      getContainer: N,
      getRoot: C
    },
    i
  ), et = el({
    getRoot: C,
    getWindowReference: y
  }), at = xl(i), lt = Vs(i), wt = (X) => X.contentType === "text/html" ? s(If(Pf(X.content))) : a(X.content);
  return Er(
    {
      ...Mf,
      context: {
        id: `step-machine-${t.id}`,
        step: {
          ...t,
          /**
           * Even though we receive an step content as HTML
           * the first thing even before running the step is parsing it to a vnode tree
           *
           * The virtualizeContent lib, returns a vnode tree in the format that snabdom
           * understands. But it helps not only for rendering, but also to attach actions to an element for example,
           * since we use a tree traversal technique to find and match the element id with the actions callbacks.
           *
           */
          activeNodeIndex: 0,
          virtualizedContent: wt(t)
        },
        experience: r,
        blockedEvents: {},
        actionsRunning: false,
        experienceInstanceId: o,
        stopReason: null
      }
    },
    {
      actions: {
        // injecting action coming from step level
        setContent: yl,
        updateRootStyle: wl,
        // injecting action coming from render
        unmount: b,
        setContainer: _,
        updateTheme: at,
        resetRender: x,
        // injecting action coming from hooks
        runStepBeginHooks: L,
        runStepPreRenderHooks: j,
        runStepPostRenderHooks: k,
        runStepEndHooks: q,
        runStepErrorHooks: K,
        runStepContainerChangeHooks: ot,
        updateStepContext: El,
        removeStepHooks: () => W(),
        clearOverrides: () => p(),
        setVirtualizedContent: ml(
          wt
        ),
        // injecting action coming from overrides
        applyOverrides: l,
        // injecting actions coming from dom
        startThemeRemovalListener: Ps,
        stopThemeRemovalListener: nl,
        removeCustomContainer: Qu({ getRoot: C }),
        ensuresElementsAreAccessible: _l(
          v
        ),
        notifyExperienceStarted: Sl,
        notifyStepStopped: bl,
        // core events
        ...lt.stepActions,
        blockEvent: lt.helpers.blockEvent,
        autoRecover: Tl,
        setActionsRunning: Rl,
        setActionsFinished: Cl,
        // stop reason handling
        saveStopReason: yt({
          stopReason: (X, B) => B.reason
        })
      },
      services: {
        // injecting services coming from step level
        runStepTraits: ut,
        // injecting services coming from render
        render: g,
        // injecting services coming from hooks
        hooksService: mt,
        // injecting services coming from steps
        actionsService: Q,
        // injecting services coming from dom
        themeRemovalService: et
      },
      guards: {
        hasCustomContainer: A,
        isAutoRecoverEvent: (X, B) => B.isAutoRecoverEvent,
        isEventEnabled: lt.helpers.isEventEnabled,
        didContentChanged: (X, B) => !bn(X.step.content, B.stepConfig.content),
        shouldOnlyReloadTraits: Ol,
        shouldStepReload: (X, B) => !bn(X.step.traits, B.stepConfig.traits) || !bn(X.step.actions, B.stepConfig.actions) || !bn(X.experience.traits, B.experience.traits),
        didThemeChange: (X, B) => X.experience.theme !== B.experience.theme,
        isHooksDoneEventPostRenderType: (X, B) => B.hookType === ws,
        isHooksDoneEventPreRenderType: (X, B) => B.hookType === bs,
        isHooksDoneEventBeginType: (X, B) => B.hookType === mi,
        isHooksDoneEventErrorType: (X, B) => B.hookType === xs,
        isHooksDoneEventEndType: (X, B) => B.hookType === cr,
        hasPendingActions: (X) => X.actionsRunning,
        shouldFireStepCompletedEvent: (X, B) => B.hookType === cr && X.stopReason !== Oe.NAVIGATION && X.stopReason !== Oe.DISMISSED
      }
    }
  );
};
var Hf = ({
  createStepHooks: t,
  createHooksService: e,
  get: n
}) => yt({
  stepMachines: ({ experience: r, experienceInstanceId: i }) => {
    const o = {
      experience: r,
      experienceInstanceId: i,
      createStepHooks: t,
      createHooksService: e,
      get: n
    };
    return r.steps.reduce((s, a) => (s[`${a.id}`] = ds(
      Gs(a, o),
      `step-machine - ${a.id}`
    ), s), {});
  }
});
var jf = ({
  createStepHooks: t,
  createHooksService: e,
  get: n
}) => yt({
  stepMachines: ({ experience: r, stepMachines: i }, o) => {
    const s = {
      experience: r,
      createStepHooks: t,
      createHooksService: e,
      get: n
    }, a = r.steps.find(
      (c) => c.id === o.id
    );
    return a ? {
      ...i,
      [`${o.id}`]: ds(
        Gs(a, s),
        `step-machine - ${o.id}`
      )
    } : i;
  }
});
var tn = (t) => (e, { id: n, ...r }) => {
  e.stepMachines[n]?.send({
    ...r,
    type: t
  });
};
var Ff = tn(vs);
var Uf = tn(yi);
var Bf = tn(gs);
var zf = tn(
  ys
);
var qf = tn(Ou);
var Wf = tn(ms);
var Vf = (t, e) => {
  Object.values(t.stepMachines).forEach((n) => {
    n.send({
      type: yi,
      reason: e.reason
    });
  });
};
var mo = (t = [], e = []) => {
  const n = new Map(
    t.map((a) => [a.id, a])
  ), r = new Map(e.map((a) => [a.id, a])), i = e.filter((a) => {
    const c = n.get(a.id);
    return !c || c.type !== a.type;
  }), o = t.filter((a) => {
    const c = r.get(a.id);
    return !c || c.type !== a.type;
  }), s = e.filter((a) => {
    const c = n.get(a.id);
    if (!c || c.type !== a.type) return false;
    const u = c.config || {}, v = a.config || {};
    return !bn(u, v);
  });
  return {
    addedTraits: i,
    removedTraits: o,
    changedTraits: s
  };
};
var Gf = yt((t, e) => {
  const n = mo(
    t.experience.traits,
    e.experience.traits
  );
  return Object.entries(t.stepMachines).forEach(([r, i]) => {
    const o = t.experience.steps.find(
      (c) => c.id === r
    ), s = e.experience.steps.find((c) => c.id === r);
    if (!o || !s)
      return;
    const a = mo(
      o.traits,
      s.traits
    );
    i.send({
      type: Iu,
      stepConfig: s,
      experience: e.experience,
      changedExperienceTraits: n,
      changedStepTraits: a
    });
  }), {
    experience: e.experience
  };
});
var Kf = (t) => {
  Object.values(t.stepMachines).forEach((e) => {
    e.send({
      type: Si
    });
  });
};
var Xf = yt({
  experienceInstanceId: () => bu()
});
var Yf = yt({
  stepMachines: (t, e) => Object.entries(t.stepMachines).reduce(
    (n, [r, i]) => (r !== e.id && (n[r] = i), n),
    {}
  )
});
var Zf = yt({
  experience: ({ experience: t }, e) => {
    const n = t.steps.findIndex((r) => r.id === e.id);
    return n === -1 ? t : Jn(
      t,
      `steps.${n}.traits`,
      (r) => r.filter(({ once: i = false }) => !i)
    );
  }
});
var Jf = ({ addHook: t }) => ({ experience: e }) => (n) => {
  try {
    e.traits.forEach(
      (r) => Ls({
        getTrait: ks,
        trait: r,
        addHook: (i, o) => {
          t(i, { callback: o, traitId: r.id });
        },
        registerAction: (i, o) => ae(
          `${e.id}.${r.type}.${i}`,
          o
        )
      })
    ), n(bi);
  } catch {
    n(Os);
  }
};
var Eo = (t, e) => (n, { callback: r, traitId: i }) => {
  const o = t();
  o.get(n) || o.set(n, []);
  const s = o.get(n);
  e(n, [...s, { callback: r, traitId: i }]);
};
var Ee = (t, e) => gi(
  (n, r) => {
    let i = e;
    return r.changedExperienceTraits && (i = {
      ...i,
      onlyExperienceTraits: r.changedExperienceTraits.changedTraits.filter((o) => o.id != null).map(({ id: o }) => o)
    }), r.changedStepTraits && (i = {
      ...i,
      onlyStepTraits: r.changedStepTraits.changedTraits.filter((o) => o.id != null).map(({ id: o }) => o)
    }), {
      type: Ts,
      hookType: t,
      experience: n.experience,
      step: n.step,
      ...i
    };
  },
  { to: "hooksService" }
);
var Qf = Ee(Hu);
var td = Ee(ju);
var ed = Ee(mi);
var nd = Ee(bs);
var rd = Ee(ws);
var id = Ee(cr);
var od = Fc(
  (t, e) => Ee(xs, { errorEvent: e })
);
var sd = Ee(_s);
var ad = () => {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = (i = {}, o) => () => (
    // eslint-disable-next-line unicorn/consistent-function-scoping
    ((s, a) => {
      a(async ({ type: c, hookType: u, experience: v, step: l, ...f }) => {
        if (c !== Ts) return;
        let p = {
          experience: v,
          step: l,
          callback: s,
          get: o,
          getContainer: i.getContainer
        };
        [mi, _s, cr].includes(u) && (p = { ...p, ...i });
        const h = ({ callback: E, trait: S }) => {
          const g = {
            ...$s({
              ...p,
              getAction: wn
            }),
            getTraitConfig: () => S.config
          };
          return {
            callback: E,
            context: g
          };
        }, y = (t.get(u) ?? []).filter(
          ({ traitId: E }) => !f.onlyExperienceTraits || f.onlyExperienceTraits && f.onlyExperienceTraits.includes(E)
        ).map(
          (E) => h({
            ...E,
            trait: (v.traits ?? []).find(
              (S) => S.id === E.traitId
            )
          })
        );
        try {
          if (await yo(y), l) {
            const E = (e.get(l.id)?.get(u) ?? []).filter(
              ({ traitId: S }) => !f.onlyStepTraits || f.onlyStepTraits && f.onlyStepTraits.includes(S)
            ).map(
              (S) => h({
                ...S,
                trait: (l.traits ?? []).find(
                  (g) => g.id === S.traitId
                )
              })
            );
            await yo(E);
          }
          s({ type: Fu, hookType: u, ...f });
        } catch {
          s("RUN_HOOKS_ERROR");
        }
      });
    })
  ), r = ({ step: i }) => (e.get(i.id) || e.set(i.id, /* @__PURE__ */ new Map()), {
    addHook: Eo(
      () => e.get(i.id),
      (o, s) => e.get(i.id).set(o, s)
    ),
    removeStepHooks: () => e.set(i.id, /* @__PURE__ */ new Map()),
    runStepBeginHooks: ed,
    runStepPreRenderHooks: nd,
    runStepPostRenderHooks: rd,
    runStepEndHooks: id,
    runStepErrorHooks: od,
    runStepContainerChangeHooks: sd
  });
  return {
    addHook: Eo(
      () => t,
      (i, o) => t.set(i, o)
    ),
    createStepHooks: r,
    createHooksService: n,
    runExperienceBeginHooks: Qf,
    runExperienceEndHooks: td
  };
};
var cd = {
  id: "experience",
  initial: "idle",
  invoke: [
    {
      src: "hooksService",
      id: "hooksService"
    },
    {
      id: "themeRemovalService",
      src: "globalThemeRemovalService"
    }
  ],
  on: {
    RUN_HOOKS_ERROR: "destroyed",
    EXPERIENCE_STARTED: {
      target: "",
      actions: ["experienceStarted", "blockEvent"],
      cond: "isEventEnabled"
    },
    SHOW: "running-traits"
  },
  states: {
    idle: {
      on: {
        SHOW: [
          {
            target: "running-traits",
            actions: ["updateExperienceInstanceId"]
          },
          {
            target: "destroyed"
          }
        ]
      }
    },
    "running-traits": {
      invoke: {
        src: "runGlobalExperienceTraits"
      },
      on: {
        RUN_TRAITS_ERROR: "destroyed",
        RUN_TRAITS_DONE: "rendering-steps"
      }
    },
    "rendering-steps": {
      on: {
        STOP_EXPERIENCE: [
          {
            target: "end",
            actions: ["experienceCompleted", "stopSteps"],
            cond: "shouldFireCompletedEvent"
          },
          {
            target: "end",
            actions: ["stopSteps"]
          }
        ],
        START_STEP: [
          {
            target: "",
            cond: "doesStepInstanceExist",
            actions: "startStep"
          },
          {
            target: "",
            actions: ["startStepMachine", "startStep"]
          }
        ],
        STOP_STEP: {
          target: "",
          actions: "stopStep"
        },
        UPDATE_STEP: {
          target: "",
          actions: "updateStep"
        },
        SET_STEP_CONTAINER_TARGET: {
          target: "",
          actions: "setStepContainerTarget"
        },
        RECOVER_STEP: {
          target: "",
          actions: "recoverStep"
        },
        GLOBAL_CONTAINER_REMOVED: {
          target: "",
          actions: [
            "createGlobalThemeComponent",
            "startThemeRemovalListener",
            "notifyStepsContainerRemoved"
          ]
        },
        UPDATE_STEP_CONTENT: {
          target: "",
          actions: "updateStepContent"
        },
        SHOW: {
          target: "",
          actions: ["reloadSteps"]
        },
        STEP_STOPPED: [
          {
            target: "end-final",
            cond: "areAllStepsStopped",
            actions: [
              "experienceCompleted",
              "removeGlobalThemeComponent",
              "runExperienceEndHooks"
            ]
          },
          {
            target: "",
            actions: ["cleanStepMachines", "cleanRunOnceTraits"]
          }
        ]
      },
      entry: [
        "createGlobalThemeComponent",
        "startStepMachines",
        "runExperienceBeginHooks",
        "startThemeRemovalListener"
      ]
    },
    end: {
      entry: ["removeGlobalThemeComponent", "runExperienceEndHooks"],
      on: {
        [Ss]: { target: "end-final", cond: "areAllStepsStopped" }
      }
    },
    "end-final": {
      final: true
    },
    destroyed: {
      entry: "experienceError",
      type: "final"
    }
  }
};
var ud = (t, e) => {
  const {
    addHook: n,
    createStepHooks: r,
    createHooksService: i,
    runExperienceBeginHooks: o,
    runExperienceEndHooks: s
  } = ad(), a = i({}, e), c = Hf({
    createStepHooks: r,
    createHooksService: i,
    get: e
  }), u = jf({
    createStepHooks: r,
    createHooksService: i,
    get: e
  }), v = Jf({
    addHook: n
  }), l = Vs(e), f = Yu(e), p = Zu(e), h = tl(e);
  return Er(
    {
      ...cd,
      context: {
        experience: t,
        blockedEvents: {},
        experienceInstanceId: null
      }
    },
    {
      actions: {
        // experience
        startStep: Ff,
        stopStep: Uf,
        updateStep: Bf,
        setStepContainerTarget: zf,
        recoverStep: qf,
        startStepMachines: c,
        stopSteps: Vf,
        notifyStepsContainerRemoved: Kf,
        updateStepContent: Wf,
        reloadSteps: Gf,
        updateExperienceInstanceId: Xf,
        cleanStepMachines: Yf,
        startStepMachine: u,
        // hooks
        runExperienceBeginHooks: o,
        runExperienceEndHooks: s,
        // dom
        createGlobalThemeComponent: f,
        removeGlobalThemeComponent: p,
        startThemeRemovalListener: Ps,
        // traits
        cleanRunOnceTraits: Zf,
        // core events
        ...l.experienceActions,
        blockEvent: l.helpers.blockEvent
      },
      services: {
        // experiences
        runGlobalExperienceTraits: v,
        // hooks
        hooksService: a,
        // dom
        globalThemeRemovalService: h
      },
      guards: {
        isEventEnabled: l.helpers.isEventEnabled,
        areAllStepsStopped: (y) => Object.values(y.stepMachines).every(
          (E) => E.state.done
        ),
        doesStepInstanceExist: (y, E) => y.stepMachines?.[E.id] !== void 0,
        shouldFireCompletedEvent: (y, E) => E.reason !== Oe.NAVIGATION && E.reason !== Oe.DISMISSED
      }
    }
  );
};
var Ks = Hs(
  [
    Us,
    qs,
    Ws,
    zs,
    Fs
  ],
  void 0,
  {
    experimental: {
      fragments: true
    }
  }
);
function ld(t) {
  const n = (t.ownerDocument || document).createElement("div");
  return t.append(n), Ks(n, se("div"));
}
var fd = () => {
  let t = null;
  return {
    onRender: (e, n) => {
      !t && !e || (t || (t = ld(e)), t = Ks(t, n));
    },
    onRenderReset: () => {
      t = null;
    }
  };
};
var Wn = {};
var Mr;
var So;
function dd() {
  return So || (So = 1, Mr = {
    area: true,
    base: true,
    br: true,
    col: true,
    embed: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    menuitem: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true
  }), Mr;
}
var Hr;
var bo;
function pd() {
  if (bo) return Hr;
  bo = 1;
  var t = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g, e = dd();
  return Hr = function(n) {
    var r = 0, i, o = true, s = {
      type: "tag",
      name: "",
      voidElement: false,
      attrs: {},
      children: []
    };
    return n.replace(t, function(a) {
      if (a === "=") {
        o = true, r++;
        return;
      }
      o ? r === 0 ? ((e[a] || n.charAt(n.length - 2) === "/") && (s.voidElement = true), s.name = a) : (s.attrs[i] = a.replace(/^['"]|['"]$/g, ""), i = void 0) : (i && (s.attrs[i] = i), i = a), r++, o = false;
    }), s;
  }, Hr;
}
var jr;
var wo;
function hd() {
  if (wo) return jr;
  wo = 1;
  var t = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"|'[^']*'|[^'">])+>)/g, e = pd(), n = Object.create ? /* @__PURE__ */ Object.create(null) : {};
  function r(i, o, s, a, c) {
    var u = o.indexOf("<", a), v = o.slice(a, u === -1 ? void 0 : u);
    /^\s*$/.test(v) && (v = " "), (!c && u > -1 && s + i.length >= 0 || v !== " ") && i.push({
      type: "text",
      content: v
    });
  }
  return jr = function(o, s) {
    s || (s = {}), s.components || (s.components = n);
    var a = [], c, u = -1, v = [], l = {}, f = false;
    return o.replace(t, function(p, h) {
      if (f) {
        if (p !== "</" + c.name + ">")
          return;
        f = false;
      }
      var y = p.charAt(1) !== "/", E = p.indexOf("<!--") === 0, S = h + p.length, g = o.charAt(S), b;
      y && !E && (u++, c = e(p), c.type === "tag" && s.components[c.name] && (c.type = "component", f = true), !c.voidElement && !f && g && g !== "<" && r(c.children, o, u, S, s.ignoreWhitespace), l[c.tagName] = c, u === 0 && a.push(c), b = v[u - 1], b && b.children.push(c), v[u] = c), (E || !y || c.voidElement) && (E || u--, !f && g !== "<" && g && (b = u === -1 ? a : v[u].children, r(b, o, u, S, s.ignoreWhitespace)));
    }), !a.length && o.length && r(a, o, 0, 0, s.ignoreWhitespace), a;
  }, jr;
}
var Xs = /* @__PURE__ */ cu(Of);
var He = {};
var xo;
function vd() {
  if (xo) return He;
  xo = 1, Object.defineProperty(He, "__esModule", {
    value: true
  }), He.createTextVNode = e, He.transformName = n, He.unescapeEntities = o;
  var t = Xs;
  function e(s, a) {
    return (0, t.vnode)(void 0, void 0, void 0, o(s, a));
  }
  function n(s) {
    s = s.replace(/-(\w)/g, function(u, v) {
      return v.toUpperCase();
    });
    var a = s.charAt(0).toLowerCase();
    return "" + a + s.substring(1);
  }
  var r = new RegExp("&[a-z0-9#]+;", "gi"), i = null;
  function o(s, a) {
    return i || (i = a.createElement("div")), s.replace(r, function(c) {
      return i.innerHTML = c, i.textContent;
    });
  }
  return He;
}
var _o;
function gd() {
  if (_o) return Wn;
  _o = 1, Object.defineProperty(Wn, "__esModule", {
    value: true
  }), Wn.default = function(l) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, p = f.context || document;
    if (!l)
      return null;
    var h = [], y = s((0, e.default)(l), h, p), E = void 0;
    return y ? y.length === 1 ? E = y[0] : E = y : E = a({ type: "text", content: l }, h, p), f.hooks && f.hooks.create && h.forEach(function(S) {
      f.hooks.create(S);
    }), E;
  };
  var t = hd(), e = i(t), n = Xs, r = vd();
  function i(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function o(l, f, p) {
    return f in l ? Object.defineProperty(l, f, { value: p, enumerable: true, configurable: true, writable: true }) : l[f] = p, l;
  }
  function s(l, f, p) {
    if (l instanceof Array && l.length > 0)
      return l.map(function(h) {
        return a(h, f, p);
      });
  }
  function a(l, f, p) {
    var h = void 0;
    return l.type === "text" ? h = (0, r.createTextVNode)(l.content, p) : h = (0, n.h)(l.name, c(l, p), s(l.children, f, p)), f.push(h), h;
  }
  function c(l, f) {
    var p = {};
    if (!l.attrs)
      return p;
    var h = Object.keys(l.attrs).reduce(function(S, g) {
      if (g !== "style" && g !== "class") {
        var b = (0, r.unescapeEntities)(l.attrs[g], f);
        S ? S[g] = b : S = o({}, g, b);
      }
      return S;
    }, null);
    h && (p.attrs = h);
    var y = u(l);
    y && (p.style = y);
    var E = v(l);
    return E && (p.class = E), p;
  }
  function u(l) {
    try {
      return l.attrs.style.split(";").reduce(function(f, p) {
        var h = p.split(":"), y = (0, r.transformName)(h[0].trim());
        if (y) {
          var E = h[1].replace("!important", "").trim();
          f ? f[y] = E : f = o({}, y, E);
        }
        return f;
      }, null);
    } catch {
      return null;
    }
  }
  function v(l) {
    try {
      return l.attrs.class.split(" ").reduce(function(f, p) {
        return p = p.trim(), p && (f ? f[p] = true : f = o({}, p, true)), f;
      }, null);
    } catch {
      return null;
    }
  }
  return Wn;
}
var Fr;
var To;
function yd() {
  return To || (To = 1, Fr = gd()), Fr;
}
var md = yd();
var Ed = /* @__PURE__ */ Ae(md);
var Ys = "data-interaction-style";
var Sd = (t) => t.replace(/([A-Z])/g, (e) => `-${e[0].toLowerCase()}`);
var Zs = (t) => t.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&quot;/g, '"');
var Js = ({ nodeId: t, interactionId: e, state: n }) => {
  const r = e ? `[${Ys}="${e}"]` : `#${t}`;
  return Object.keys(n).map((i) => `${r}:${i} {
        ${Object.entries(n[i]).map(([o, s]) => {
    const a = Zs(String(s));
    return `${Sd(
      o
    )}:${a} !important`;
  }).join(";")}
      }`).join(" ");
};
var Qs = (t) => t.data && t.data.attrs ? t.data.attrs.id : void 0;
var ta = (t, e) => Object.keys(e).reduce(
  (n, r) => ({
    ...n,
    [r]: {
      ...n[r],
      ...e[r]
    }
  }),
  t.data || {}
);
var Ti = (t, e) => {
  t && (e(t), t.children && t.children.forEach((n) => Ti(n, e)));
};
var ea = (t) => {
  if (typeof t == "string")
    return Zs(t);
  if (t == null)
    return si([]);
  const {
    is: e = "div",
    children: n = [],
    style: r,
    behaviors: i,
    ...o
  } = t.props, { state: s, ...a } = r ?? {}, c = t.props.id, u = t.props[Ys], v = {
    ...Object.keys(a).length > 0 && { style: a },
    ...Object.keys(o).length > 0 && { attrs: o }
  }, l = se(e, v, n.map(ea));
  return s ? si([
    se("style", Js({ nodeId: c, interactionId: u, state: s })),
    l
  ]) : l;
};
var na = (t, e) => {
  const n = Qs(t), r = e(n) ?? {};
  return {
    ...t,
    data: ta(t, r),
    children: t.children?.map(
      (i) => na(i, e)
    )
  };
};
var bd = ({ step: t }) => {
  const e = Ne(t.id), n = se(
    "div",
    {
      attrs: {
        [Cs]: e
      },
      style: {
        // this solution can adding extra height to the page, so we need a way to avoid this scenario
        // display: 'inline-block',
        // position: 'relative',
        width: "100%",
        display: "contents"
      }
    },
    [t.virtualizedContent]
  );
  return {
    step: {
      ...t,
      virtualizedContent: n
    }
  };
};
var wd = (t, e) => (t.data = {
  ...t.data,
  on: e.on,
  hook: e.hook
}, t);
var xd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  applyOverridesToVnode: na,
  createStyleState: Js,
  createVnodeTree: ea,
  findId: Qs,
  injectHandlers: wd,
  mergeVnodeData: ta,
  traverseTree: Ti,
  virtualizeContent: Ed,
  wrapContent: bd
}, Symbol.toStringTag, { value: "Module" }));
var Ro = (t, e) => e.includes(t.data?.attrs?.id) && typeof t.data?.attrs?.tabindex != "string" && typeof t.data?.attrs?.tabIndex != "number";
var _d = (t) => {
  t.data.attrs.tabindex = 0, t.sel = "button", t.data.style = {
    ...t.data.style,
    border: t.data?.style?.border ?? "none",
    ...t?.children?.length > 0 && {
      backgroundColor: t.data?.style?.backgroundColor ?? "transparent"
    }
  };
};
var Td = ({ virtualizedContent: t, index: e }, { interactiveEls: n = [], focusableEls: r = [] }) => (Ti(t, (i) => {
  Ro(i, n) ? _d(i) : Ro(i, r) && (i.data.attrs = {
    ...i.data.attrs,
    tabindex: 0,
    role: "dialog",
    "aria-labelledby": `content-${e}`,
    "aria-describedby": `content-${e}`
  }), i.data?.class?.canvas && (i.data.attrs = {
    ...i.data.attrs,
    id: `content-${e}`
  });
}), t);
var Rd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  makeElementsAccessible: Td
}, Symbol.toStringTag, { value: "Module" }));
var Cd = "@appcues/close";
var Co = {
  markComplete: true
};
var Od = ({ markComplete: t = Co.markComplete } = Co, { stopExperience: e, step: n }) => {
  t ? e() : n.dismissExperience();
};
ae(Cd, Od);
var Ad = "@appcues/redirectTo";
var Nd = ({ url: t = "", openInNewWindow: e = false } = {}, { reportError: n, getWindowReference: r }) => {
  if (!t) {
    n("Can't redirect to undefined URL");
    return;
  }
  r().open(
    t,
    e ? "_blank" : "_self",
    "noopener"
  );
};
ae(Ad, Nd);
var Pd = "@appcues/trackEvent";
var Id = ({ name: t, properties: e = {} }, { sendCustomEvent: n }) => {
  n(t, e);
};
ae(Pd, Id);
var Dd = "@appcues/triggerFlow";
var Ld = ({ flowId: t, url: e, prefetch: n = false } = {}, { showFlow: r }) => {
  r({ flowId: t, url: e, prefetch: n });
};
ae(Dd, Ld);
var kd = (t) => Object.keys(t).length === 0;
var $d = (t) => t === "date.now" ? Date.now() : null;
var Md = (t) => typeof t == "string" && t.startsWith("{") && t.endsWith("}");
var Hd = (t) => Object.entries(t).reduce((e, [n, r]) => {
  if (Md(r)) {
    const i = r.slice(1, -1), o = $d(i);
    return { ...e, [n]: o ?? r };
  }
  return { ...e, [n]: r };
}, {});
var jd = "@appcues/setUserProperties";
var Fd = (t, { updateUserProfile: e }) => {
  if (!kd(t)) {
    const n = Hd(t);
    e(n);
  }
};
ae(jd, Fd);
var Ud = "@appcues/toggleActions";
var Bd = ({ actions: t = [], target: e } = {}, n) => {
  const r = n.querySelector(e.selector);
  r.length !== 0 && t.forEach((i) => {
    const o = `toggleActions_${i.id}`, s = n.getAction(i.type), [a] = r, c = !a.getAttribute(o);
    s && c && (s(i.config, n), a.setAttribute(o, true)), c || a.removeAttribute(o);
  });
};
ae(Ud, Bd);
var zd = /([\.\*\+\^\$\[\]\\\(\)\|\{\}\,\-\:\?])/g;
var Oo = /^([a-zA-Z]{2,3}|[a-zA-Z]{5,8})(-[a-zA-Z]{4})?(-(?:[a-zA-Z]{2}|\d{3}))?(-(?:[a-zA-Z\d]{5,8}|\d[a-zA-Z\d]{3}))?$/;
var Ce = class _Ce {
  // eslint-disable-line consistent-this
  /**
   * @param {string} locale
   */
  constructor(e) {
    if (typeof e != "string")
      throw new TypeError("A string argument is expected");
    if (!Oo.test(e))
      throw new RangeError("A proper locale must be provided");
    this._locale = e;
  }
  // Private functions - star
  /**
   * @param {null|undefined|string} [str]
   * @returns {null|undefined|string}
   */
  static _escapeRegExpPattern(e) {
    return typeof e != "string" ? e : e.replace(zd, "\\$1");
  }
  /**
   * @param {string|null} [str]
   * @param {boolean} [reserveReturnValue]
   */
  static _toLowerCase(e, n) {
    return typeof e != "string" ? n && e : e.toLowerCase();
  }
  /**
   * @param {string|null} [str]
   * @param {boolean} [reserveReturnValue]
   */
  static _toUpperCase(e, n) {
    return typeof e != "string" ? n && e : e.toUpperCase();
  }
  /**
   * @param {string|null} [str]
   * @param {string|null|string[]|boolean} [delimiter]
   * @param {boolean} [reserveReturnValue]
   */
  static _trim(e, n, r) {
    const i = [];
    let o;
    const s = function(c) {
      i.push("^" + c + "+|" + c + "+$");
    };
    if (typeof n == "boolean" && (r = n, n = null), typeof e != "string")
      return r ? e : void 0;
    if (Array.isArray(n) && n.map((c) => {
      const u = this._escapeRegExpPattern(c);
      s(u);
    }), typeof n == "string") {
      const c = this._escapeRegExpPattern(n);
      s(c);
    }
    n || s("\\s");
    const a = "(" + i.join("|") + ")";
    for (o = new RegExp(a, "g"); e.match(o); )
      e = e.replace(o, "");
    return e;
  }
  /**
   * @typedef {{
   *   lang: string,
   *   script: string|undefined,
   *   countryCode: string|undefined
   * }} LocaleInfo
   */
  /**
   * @param {string|null} [strLocale]
   * @returns {undefined|LocaleInfo}
   */
  static _parseLocale(e) {
    if (typeof e != "string")
      return;
    const n = Oo.exec(e);
    let r, i, o;
    if (!e || !n)
      return;
    const s = this._trim(n[2], ["-", "_"]), a = this._trim(n[3], ["-", "_"]);
    return r = /** @type {string} */
    this._toLowerCase(n[1]), i = this._toLowerCase(s) || i, o = this._toUpperCase(a) || o, {
      lang: r,
      script: i,
      countryCode: o
    };
  }
  // Private functions - End
  _isRtlLang() {
    const { lang: e, script: n } = (
      /** @type {LocaleInfo} */
      _Ce._parseLocale(this._locale)
    );
    return n ? _Ce._RTL_SCRIPTS.indexOf(n) >= 0 : _Ce._BIDI_RTL_LANGS.indexOf(e) >= 0;
  }
  // Public functions - star
  get textInfo() {
    return { direction: this._isRtlLang() ? "rtl" : "ltr" };
  }
  // Public functions - End
};
Ce._RTL_SCRIPTS = [
  "adlm",
  "arab",
  "armi",
  "avst",
  "chrs",
  "cprt",
  "elym",
  "hatr",
  "hebr",
  "hung",
  "khar",
  "lydi",
  "mand",
  "mani",
  "mend",
  "merc",
  "mero",
  "narb",
  "nbat",
  "nkoo",
  "orkh",
  "ougr",
  "palm",
  "phli",
  "phlp",
  "phnx",
  "prti",
  "rohg",
  "samr",
  "sarb",
  "sogd",
  "sogo",
  "syrc",
  "thaa",
  "yezi"
];
Ce._BIDI_RTL_LANGS = [
  // Const BIDI_RTL_LANGS Array
  // BIDI_RTL_LANGS ref: http://en.wikipedia.org/wiki/Right-to-left
  // Table of scripts in Unicode: https://en.wikipedia.org/wiki/Script_(Unicode)
  "ae",
  // Avestan
  "aeb",
  // Tunisian Arabic
  "ajt",
  // Tunisian Arabic (old)
  "apc",
  // Levantine Arabic
  "apd",
  // Sudanese Arabic
  "ar",
  // 'العربية', Arabic
  "ara",
  // Arabic
  "arb",
  // Standard Arabic
  "arc",
  // Aramaic
  "arq",
  // Algerian Arabic
  "ars",
  // Najdi Arabic
  "ary",
  // Moroccan Arabic
  "arz",
  // Egyptian Arabic
  "ave",
  // Avestan
  "avl",
  // Eastern Egyptian Bedawi Arabic
  "bal",
  // Baluchi
  "bcc",
  // 'بلوچی مکرانی', Southern Balochi
  "bej",
  // Beja; Bedawiyet
  "bft",
  // Balti
  "bgn",
  // Western Balochi
  "bqi",
  // 'بختياري', Bakthiari
  "brh",
  // Brahui
  "cja",
  // Cham, Western
  "ckb",
  // 'Soranî / کوردی', Sorani
  "cld",
  // Chaldean Neo-Aramaic
  "dcc",
  // Deccan
  "dgl",
  // Andaandi
  "div",
  // Divehi
  "drw",
  // Darwazi (old)
  "dv",
  // Dhivehi
  "fa",
  // 'فارسی', Persian
  "fas",
  // Persian
  "fia",
  // Nobiin
  "fub",
  // Fulfulde (Adamawa)
  "gbz",
  // Dari, Zoroastrian
  "gjk",
  // Koli, Kachi
  "gju",
  // Gujari
  "glk",
  // 'گیلکی', Gilaki
  "grc",
  // Greek, Ancient (to 1453)
  "gwc",
  // Kalami
  "gwt",
  // Gawar-Bati
  "haz",
  // Hazaragi
  "he",
  // 'עברית', Hebrew
  "heb",
  // Hebrew
  "hnd",
  // Hindko, Southern
  "hno",
  // Hindko, Northern
  "iw",
  // Hebrew (old)
  "ji",
  // Yiddish (old)
  "kas",
  // Kashmiri
  "kby",
  // Kanuri, Manga
  "khw",
  // Khowar
  "ks",
  // Kashmiri
  "kvx",
  // Koli, Parkari
  "kxp",
  // Koli, Wadiyara
  "kzh",
  // Kenuzi-Dongola (old)
  "lad",
  // Ladino
  "lah",
  // Lahnda
  "lki",
  // Laki
  "lrc",
  // Luri, Northern
  "luz",
  // Luri, Southern
  "mde",
  // Maba (Chad)
  "mfa",
  // Malay, Pattani
  "mki",
  // Dhatki
  "mvy",
  // Kohistani, Indus
  "myz",
  // Mandaic, Classical
  "mzn",
  // 'مازِرونی', Mazanderani
  "nqo",
  // N'Ko
  "oru",
  // Ormuri
  "ota",
  // Turkish, Ottoman (1500–1928)
  "otk",
  // Turkish, Old
  "oui",
  // Uighur, Old
  "pal",
  // Pahlavi
  "pbu",
  // Pashto, Northern
  "per",
  // Persian
  "pes",
  // Western Farsi
  "phl",
  // Phalura
  "phn",
  // Phoenician
  "pnb",
  // 'پنجابی', Western Punjabi
  "pra",
  // Prakrit languages
  "prd",
  // Dari (Persian)
  "prs",
  // 'دری', Darī
  "ps",
  // 'پښتو', Pashto,
  "pus",
  // Pushto
  "rhg",
  // Rohingya
  "rmt",
  // Domari
  "scl",
  // Shina
  "sd",
  // 'سنڌي', Sindhi
  "sdh",
  // Kurdish, Southern
  "shu",
  // Arabic (Chadian)
  "skr",
  // Saraiki
  "smp",
  // Samaritan
  "snd",
  // Sindhi
  "sog",
  // Sogdian
  "swb",
  // Comorian
  "syr",
  // Syriac
  "tnf",
  // Tangshewi (old)
  "trw",
  // Torwali
  "ug",
  // 'Uyghurche / ئۇيغۇرچە', Uyghur
  "uig",
  // Uighur
  "ur",
  // 'اردو', Urdu
  "urd",
  // Urdu
  "wni",
  // Comorian, Ndzwani
  "xco",
  // Chorasmian
  "xld",
  // Lydian
  "xmn",
  // Manichaean Middle Persian
  "xmr",
  // Meroitic
  "xna",
  // North Arabian, Ancient
  "xpr",
  // Parthian
  "xsa",
  // Sabaean
  "ydd",
  // Yiddish, Eastern
  "yi",
  // 'ייִדיש', Yiddish
  "yid",
  // Yiddish
  "zdj"
  // Comorian, Ngazidja
];
var qd = "@appcues/content-direction";
function Wd(t) {
  try {
    return new Ce(t).textInfo;
  } catch {
    return { direction: "ltr" };
  }
}
var Ao = ({ updateRootStyle: t, getTraitConfig: e }) => {
  const n = navigator.languages ? navigator.languages[0] : navigator.language || navigator.userLanguage, { currentLanguage: r = n, forceDirection: i = null } = e(), o = Wd(r);
  t(
    {
      direction: i ?? o.direction
    },
    { forceUpdate: true }
  );
};
var Vd = ({ addHook: t }) => {
  t("step.begin", Ao), t("step.container_change", Ao);
};
bt(qd, Vd);
var ra = ["top", "right", "bottom", "left"];
var No = ["start", "end"];
var Po = /* @__PURE__ */ ra.reduce((t, e) => t.concat(e, e + "-" + No[0], e + "-" + No[1]), []);
var Cn = Math.min;
var ze = Math.max;
var lr = Math.round;
var Kt = (t) => ({
  x: t,
  y: t
});
var Gd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var Kd = {
  start: "end",
  end: "start"
};
function ci(t, e, n) {
  return ze(t, Cn(e, n));
}
function en(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function nn(t) {
  return t.split("-")[0];
}
function ie(t) {
  return t.split("-")[1];
}
function ia(t) {
  return t === "x" ? "y" : "x";
}
function Ri(t) {
  return t === "y" ? "height" : "width";
}
var Xd = /* @__PURE__ */ new Set(["top", "bottom"]);
function xr(t) {
  return Xd.has(nn(t)) ? "y" : "x";
}
function Ci(t) {
  return ia(xr(t));
}
function Yd(t, e, n) {
  n === void 0 && (n = false);
  const r = ie(t), i = Ci(t), o = Ri(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (s = Io(s)), [s, Io(s)];
}
function Zd(t) {
  return t.replace(/start|end/g, (e) => Kd[e]);
}
function Io(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Gd[e]);
}
function Jd(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function oa(t) {
  return typeof t != "number" ? Jd(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function fr(t) {
  const {
    x: e,
    y: n,
    width: r,
    height: i
  } = t;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
function Do(t, e, n) {
  let {
    reference: r,
    floating: i
  } = t;
  const o = xr(e), s = Ci(e), a = Ri(s), c = nn(e), u = o === "y", v = r.x + r.width / 2 - i.width / 2, l = r.y + r.height / 2 - i.height / 2, f = r[a] / 2 - i[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: v,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: l
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: l
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (ie(e)) {
    case "start":
      p[s] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && u ? -1 : 1);
      break;
  }
  return p;
}
var Qd = async (t, e, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let u = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: i
  }), {
    x: v,
    y: l
  } = Do(u, r, c), f = r, p = {}, h = 0;
  for (let y = 0; y < a.length; y++) {
    const {
      name: E,
      fn: S
    } = a[y], {
      x: g,
      y: b,
      data: _,
      reset: x
    } = await S({
      x: v,
      y: l,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: p,
      rects: u,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    v = g ?? v, l = b ?? l, p = {
      ...p,
      [E]: {
        ...p[E],
        ..._
      }
    }, x && h <= 50 && (h++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (u = x.rects === true ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: i
    }) : x.rects), {
      x: v,
      y: l
    } = Do(u, f, c)), y = -1);
  }
  return {
    x: v,
    y: l,
    placement: f,
    strategy: i,
    middlewareData: p
  };
};
async function dr(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = t, {
    boundary: u = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: l = "floating",
    altBoundary: f = false,
    padding: p = 0
  } = en(e, t), h = oa(p), E = a[f ? l === "floating" ? "reference" : "floating" : l], S = fr(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(E))) == null || n ? E : E.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: v,
    strategy: c
  })), g = l === "floating" ? {
    x: r,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), _ = await (o.isElement == null ? void 0 : o.isElement(b)) ? await (o.getScale == null ? void 0 : o.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = fr(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: g,
    offsetParent: b,
    strategy: c
  }) : g);
  return {
    top: (S.top - x.top + h.top) / _.y,
    bottom: (x.bottom - S.bottom + h.bottom) / _.y,
    left: (S.left - x.left + h.left) / _.x,
    right: (x.right - S.right + h.right) / _.x
  };
}
var tp = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: a,
      middlewareData: c
    } = e, {
      element: u,
      padding: v = 0
    } = en(t, e) || {};
    if (u == null)
      return {};
    const l = oa(v), f = {
      x: n,
      y: r
    }, p = Ci(i), h = Ri(p), y = await s.getDimensions(u), E = p === "y", S = E ? "top" : "left", g = E ? "bottom" : "right", b = E ? "clientHeight" : "clientWidth", _ = o.reference[h] + o.reference[p] - f[p] - o.floating[h], x = f[p] - o.reference[p], N = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(u));
    let A = N ? N[b] : 0;
    (!A || !await (s.isElement == null ? void 0 : s.isElement(N))) && (A = a.floating[b] || o.floating[h]);
    const C = _ / 2 - x / 2, I = A / 2 - y[h] / 2 - 1, L = Cn(l[S], I), j = Cn(l[g], I), k = L, q = A - y[h] - j, K = A / 2 - y[h] / 2 + C, W = ci(k, K, q), ot = !c.arrow && ie(i) != null && K !== W && o.reference[h] / 2 - (K < k ? L : j) - y[h] / 2 < 0, ut = ot ? K < k ? K - k : K - q : 0;
    return {
      [p]: f[p] + ut,
      data: {
        [p]: W,
        centerOffset: K - W - ut,
        ...ot && {
          alignmentOffset: ut
        }
      },
      reset: ot
    };
  }
});
function ep(t, e, n) {
  return (t ? [...n.filter((i) => ie(i) === t), ...n.filter((i) => ie(i) !== t)] : n.filter((i) => nn(i) === i)).filter((i) => t ? ie(i) === t || (e ? Zd(i) !== i : false) : true);
}
var np = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var n, r, i;
      const {
        rects: o,
        middlewareData: s,
        placement: a,
        platform: c,
        elements: u
      } = e, {
        crossAxis: v = false,
        alignment: l,
        allowedPlacements: f = Po,
        autoAlignment: p = true,
        ...h
      } = en(t, e), y = l !== void 0 || f === Po ? ep(l || null, p, f) : f, E = await dr(e, h), S = ((n = s.autoPlacement) == null ? void 0 : n.index) || 0, g = y[S];
      if (g == null)
        return {};
      const b = Yd(g, o, await (c.isRTL == null ? void 0 : c.isRTL(u.floating)));
      if (a !== g)
        return {
          reset: {
            placement: y[0]
          }
        };
      const _ = [E[nn(g)], E[b[0]], E[b[1]]], x = [...((r = s.autoPlacement) == null ? void 0 : r.overflows) || [], {
        placement: g,
        overflows: _
      }], N = y[S + 1];
      if (N)
        return {
          data: {
            index: S + 1,
            overflows: x
          },
          reset: {
            placement: N
          }
        };
      const A = x.map((L) => {
        const j = ie(L.placement);
        return [L.placement, j && v ? (
          // Check along the mainAxis and main crossAxis side.
          L.overflows.slice(0, 2).reduce((k, q) => k + q, 0)
        ) : (
          // Check only the mainAxis.
          L.overflows[0]
        ), L.overflows];
      }).sort((L, j) => L[1] - j[1]), I = ((i = A.filter((L) => L[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        ie(L[0]) ? 2 : 3
      ).every((j) => j <= 0))[0]) == null ? void 0 : i[0]) || A[0][0];
      return I !== a ? {
        data: {
          index: S + 1,
          overflows: x
        },
        reset: {
          placement: I
        }
      } : {};
    }
  };
};
function Lo(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function ko(t) {
  return ra.some((e) => t[e] >= 0);
}
var rp = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = en(t, e);
      switch (r) {
        case "referenceHidden": {
          const o = await dr(e, {
            ...i,
            elementContext: "reference"
          }), s = Lo(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: ko(s)
            }
          };
        }
        case "escaped": {
          const o = await dr(e, {
            ...i,
            altBoundary: true
          }), s = Lo(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: ko(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
var ip = /* @__PURE__ */ new Set(["left", "top"]);
async function op(t, e) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = t, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = nn(n), a = ie(n), c = xr(n) === "y", u = ip.has(s) ? -1 : 1, v = o && c ? -1 : 1, l = en(e, t);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: h
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: l.mainAxis || 0,
    crossAxis: l.crossAxis || 0,
    alignmentAxis: l.alignmentAxis
  };
  return a && typeof h == "number" && (p = a === "end" ? h * -1 : h), c ? {
    x: p * v,
    y: f * u
  } : {
    x: f * u,
    y: p * v
  };
}
var sp = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: s,
        middlewareData: a
      } = e, c = await op(e, t);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + c.x,
        y: o + c.y,
        data: {
          ...c,
          placement: s
        }
      };
    }
  };
};
var ap = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: r,
        placement: i
      } = e, {
        mainAxis: o = true,
        crossAxis: s = false,
        limiter: a = {
          fn: (E) => {
            let {
              x: S,
              y: g
            } = E;
            return {
              x: S,
              y: g
            };
          }
        },
        ...c
      } = en(t, e), u = {
        x: n,
        y: r
      }, v = await dr(e, c), l = xr(nn(i)), f = ia(l);
      let p = u[f], h = u[l];
      if (o) {
        const E = f === "y" ? "top" : "left", S = f === "y" ? "bottom" : "right", g = p + v[E], b = p - v[S];
        p = ci(g, p, b);
      }
      if (s) {
        const E = l === "y" ? "top" : "left", S = l === "y" ? "bottom" : "right", g = h + v[E], b = h - v[S];
        h = ci(g, h, b);
      }
      const y = a.fn({
        ...e,
        [f]: p,
        [l]: h
      });
      return {
        ...y,
        data: {
          x: y.x - n,
          y: y.y - r,
          enabled: {
            [f]: o,
            [l]: s
          }
        }
      };
    }
  };
};
function _r() {
  return typeof window < "u";
}
function rn(t) {
  return sa(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Mt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ce(t) {
  var e;
  return (e = (sa(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function sa(t) {
  return _r() ? t instanceof Node || t instanceof Mt(t).Node : false;
}
function Wt(t) {
  return _r() ? t instanceof Element || t instanceof Mt(t).Element : false;
}
function Yt(t) {
  return _r() ? t instanceof HTMLElement || t instanceof Mt(t).HTMLElement : false;
}
function $o(t) {
  return !_r() || typeof ShadowRoot > "u" ? false : t instanceof ShadowRoot || t instanceof Mt(t).ShadowRoot;
}
var cp = /* @__PURE__ */ new Set(["inline", "contents"]);
function Nn(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: r,
    display: i
  } = Vt(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + n) && !cp.has(i);
}
var up = /* @__PURE__ */ new Set(["table", "td", "th"]);
function lp(t) {
  return up.has(rn(t));
}
var fp = [":popover-open", ":modal"];
function Tr(t) {
  return fp.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return false;
    }
  });
}
var dp = ["transform", "translate", "scale", "rotate", "perspective"];
var pp = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
var hp = ["paint", "layout", "strict", "content"];
function Oi(t) {
  const e = Ai(), n = Wt(t) ? Vt(t) : t;
  return dp.some((r) => n[r] ? n[r] !== "none" : false) || (n.containerType ? n.containerType !== "normal" : false) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : false) || !e && (n.filter ? n.filter !== "none" : false) || pp.some((r) => (n.willChange || "").includes(r)) || hp.some((r) => (n.contain || "").includes(r));
}
function vp(t) {
  let e = me(t);
  for (; Yt(e) && !Je(e); ) {
    if (Oi(e))
      return e;
    if (Tr(e))
      return null;
    e = me(e);
  }
  return null;
}
function Ai() {
  return typeof CSS > "u" || !CSS.supports ? false : CSS.supports("-webkit-backdrop-filter", "none");
}
var gp = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Je(t) {
  return gp.has(rn(t));
}
function Vt(t) {
  return Mt(t).getComputedStyle(t);
}
function Rr(t) {
  return Wt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function me(t) {
  if (rn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    $o(t) && t.host || // Fallback.
    ce(t)
  );
  return $o(e) ? e.host : e;
}
function aa(t) {
  const e = me(t);
  return Je(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Yt(e) && Nn(e) ? e : aa(e);
}
function pr(t, e, n) {
  var r;
  e === void 0 && (e = []), n === void 0 && (n = true);
  const i = aa(t), o = i === ((r = t.ownerDocument) == null ? void 0 : r.body), s = Mt(i);
  if (o) {
    const a = ui(s);
    return e.concat(s, s.visualViewport || [], Nn(i) ? i : [], a && n ? pr(a) : []);
  }
  return e.concat(i, pr(i, [], n));
}
function ui(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function ca(t) {
  const e = Vt(t);
  let n = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = Yt(t), o = i ? t.offsetWidth : n, s = i ? t.offsetHeight : r, a = lr(n) !== o || lr(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function ua(t) {
  return Wt(t) ? t : t.contextElement;
}
function qe(t) {
  const e = ua(t);
  if (!Yt(e))
    return Kt(1);
  const n = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = ca(e);
  let s = (o ? lr(n.width) : n.width) / r, a = (o ? lr(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
var yp = /* @__PURE__ */ Kt(0);
function la(t) {
  const e = Mt(t);
  return !Ai() || !e.visualViewport ? yp : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function mp(t, e, n) {
  return e === void 0 && (e = false), !n || e && n !== Mt(t) ? false : e;
}
function On(t, e, n, r) {
  e === void 0 && (e = false), n === void 0 && (n = false);
  const i = t.getBoundingClientRect(), o = ua(t);
  let s = Kt(1);
  e && (r ? Wt(r) && (s = qe(r)) : s = qe(t));
  const a = mp(o, n, r) ? la(o) : Kt(0);
  let c = (i.left + a.x) / s.x, u = (i.top + a.y) / s.y, v = i.width / s.x, l = i.height / s.y;
  if (o) {
    const f = Mt(o), p = r && Wt(r) ? Mt(r) : r;
    let h = f, y = ui(h);
    for (; y && r && p !== h; ) {
      const E = qe(y), S = y.getBoundingClientRect(), g = Vt(y), b = S.left + (y.clientLeft + parseFloat(g.paddingLeft)) * E.x, _ = S.top + (y.clientTop + parseFloat(g.paddingTop)) * E.y;
      c *= E.x, u *= E.y, v *= E.x, l *= E.y, c += b, u += _, h = Mt(y), y = ui(h);
    }
  }
  return fr({
    width: v,
    height: l,
    x: c,
    y: u
  });
}
function Cr(t, e) {
  const n = Rr(t).scrollLeft;
  return e ? e.left + n : On(ce(t)).left + n;
}
function fa(t, e) {
  const n = t.getBoundingClientRect(), r = n.left + e.scrollLeft - Cr(t, n), i = n.top + e.scrollTop;
  return {
    x: r,
    y: i
  };
}
function Ep(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: r,
    strategy: i
  } = t;
  const o = i === "fixed", s = ce(r), a = e ? Tr(e.floating) : false;
  if (r === s || a && o)
    return n;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Kt(1);
  const v = Kt(0), l = Yt(r);
  if ((l || !l && !o) && ((rn(r) !== "body" || Nn(s)) && (c = Rr(r)), Yt(r))) {
    const p = On(r);
    u = qe(r), v.x = p.x + r.clientLeft, v.y = p.y + r.clientTop;
  }
  const f = s && !l && !o ? fa(s, c) : Kt(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - c.scrollLeft * u.x + v.x + f.x,
    y: n.y * u.y - c.scrollTop * u.y + v.y + f.y
  };
}
function Sp(t) {
  return Array.from(t.getClientRects());
}
function bp(t) {
  const e = ce(t), n = Rr(t), r = t.ownerDocument.body, i = ze(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), o = ze(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Cr(t);
  const a = -n.scrollTop;
  return Vt(r).direction === "rtl" && (s += ze(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
var Mo = 25;
function wp(t, e) {
  const n = Mt(t), r = ce(t), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const v = Ai();
    (!v || v && e === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  const u = Cr(r);
  if (u <= 0) {
    const v = r.ownerDocument, l = v.body, f = getComputedStyle(l), p = v.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, h = Math.abs(r.clientWidth - l.clientWidth - p);
    h <= Mo && (o -= h);
  } else u <= Mo && (o += u);
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
var xp = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function _p(t, e) {
  const n = On(t, true, e === "fixed"), r = n.top + t.clientTop, i = n.left + t.clientLeft, o = Yt(t) ? qe(t) : Kt(1), s = t.clientWidth * o.x, a = t.clientHeight * o.y, c = i * o.x, u = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function Ho(t, e, n) {
  let r;
  if (e === "viewport")
    r = wp(t, n);
  else if (e === "document")
    r = bp(ce(t));
  else if (Wt(e))
    r = _p(e, n);
  else {
    const i = la(t);
    r = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return fr(r);
}
function da(t, e) {
  const n = me(t);
  return n === e || !Wt(n) || Je(n) ? false : Vt(n).position === "fixed" || da(n, e);
}
function Tp(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let r = pr(t, [], false).filter((a) => Wt(a) && rn(a) !== "body"), i = null;
  const o = Vt(t).position === "fixed";
  let s = o ? me(t) : t;
  for (; Wt(s) && !Je(s); ) {
    const a = Vt(s), c = Oi(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && xp.has(i.position) || Nn(s) && !c && da(t, s)) ? r = r.filter((v) => v !== s) : i = a, s = me(s);
  }
  return e.set(t, r), r;
}
function Rp(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = t;
  const s = [...n === "clippingAncestors" ? Tr(e) ? [] : Tp(e, this._c) : [].concat(n), r], a = s[0], c = s.reduce((u, v) => {
    const l = Ho(e, v, i);
    return u.top = ze(l.top, u.top), u.right = Cn(l.right, u.right), u.bottom = Cn(l.bottom, u.bottom), u.left = ze(l.left, u.left), u;
  }, Ho(e, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Cp(t) {
  const {
    width: e,
    height: n
  } = ca(t);
  return {
    width: e,
    height: n
  };
}
function Op(t, e, n) {
  const r = Yt(e), i = ce(e), o = n === "fixed", s = On(t, true, o, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Kt(0);
  function u() {
    c.x = Cr(i);
  }
  if (r || !r && !o)
    if ((rn(e) !== "body" || Nn(i)) && (a = Rr(e)), r) {
      const p = On(e, true, o, e);
      c.x = p.x + e.clientLeft, c.y = p.y + e.clientTop;
    } else i && u();
  o && !r && i && u();
  const v = i && !r && !o ? fa(i, a) : Kt(0), l = s.left + a.scrollLeft - c.x - v.x, f = s.top + a.scrollTop - c.y - v.y;
  return {
    x: l,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Ur(t) {
  return Vt(t).position === "static";
}
function jo(t, e) {
  if (!Yt(t) || Vt(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return ce(t) === n && (n = n.ownerDocument.body), n;
}
function pa(t, e) {
  const n = Mt(t);
  if (Tr(t))
    return n;
  if (!Yt(t)) {
    let i = me(t);
    for (; i && !Je(i); ) {
      if (Wt(i) && !Ur(i))
        return i;
      i = me(i);
    }
    return n;
  }
  let r = jo(t, e);
  for (; r && lp(r) && Ur(r); )
    r = jo(r, e);
  return r && Je(r) && Ur(r) && !Oi(r) ? n : r || vp(t) || n;
}
var Ap = async function(t) {
  const e = this.getOffsetParent || pa, n = this.getDimensions, r = await n(t.floating);
  return {
    reference: Op(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Np(t) {
  return Vt(t).direction === "rtl";
}
var Pp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ep,
  getDocumentElement: ce,
  getClippingRect: Rp,
  getOffsetParent: pa,
  getElementRects: Ap,
  getClientRects: Sp,
  getDimensions: Cp,
  getScale: qe,
  isElement: Wt,
  isRTL: Np
};
var Ip = sp;
var Dp = np;
var Lp = ap;
var kp = rp;
var $p = tp;
var Mp = (t, e, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Pp,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return Qd(t, e, {
    ...i,
    platform: o
  });
};
var Br;
var Fo;
function Hp() {
  if (Fo) return Br;
  Fo = 1;
  var t = "Expected a function", e = NaN, n = "[object Symbol]", r = /^\s+|\s+$/g, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt, c = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, u = typeof self == "object" && self && self.Object === Object && self, v = c || u || Function("return this")(), l = Object.prototype, f = l.toString, p = Math.max, h = Math.min, y = function() {
    return v.Date.now();
  };
  function E(x, N, A) {
    var C, I, L, j, k, q, K = 0, W = false, ot = false, ut = true;
    if (typeof x != "function")
      throw new TypeError(t);
    N = _(N) || 0, S(A) && (W = !!A.leading, ot = "maxWait" in A, L = ot ? p(_(A.maxWait) || 0, N) : L, ut = "trailing" in A ? !!A.trailing : ut);
    function Q(Z) {
      var ft = C, _t = I;
      return C = I = void 0, K = Z, j = x.apply(_t, ft), j;
    }
    function mt(Z) {
      return K = Z, k = setTimeout(lt, N), W ? Q(Z) : j;
    }
    function et(Z) {
      var ft = Z - q, _t = Z - K, It = N - ft;
      return ot ? h(It, L - _t) : It;
    }
    function at(Z) {
      var ft = Z - q, _t = Z - K;
      return q === void 0 || ft >= N || ft < 0 || ot && _t >= L;
    }
    function lt() {
      var Z = y();
      if (at(Z))
        return wt(Z);
      k = setTimeout(lt, et(Z));
    }
    function wt(Z) {
      return k = void 0, ut && C ? Q(Z) : (C = I = void 0, j);
    }
    function X() {
      k !== void 0 && clearTimeout(k), K = 0, C = q = I = k = void 0;
    }
    function B() {
      return k === void 0 ? j : wt(y());
    }
    function xt() {
      var Z = y(), ft = at(Z);
      if (C = arguments, I = this, q = Z, ft) {
        if (k === void 0)
          return mt(q);
        if (ot)
          return k = setTimeout(lt, N), Q(q);
      }
      return k === void 0 && (k = setTimeout(lt, N)), j;
    }
    return xt.cancel = X, xt.flush = B, xt;
  }
  function S(x) {
    var N = typeof x;
    return !!x && (N == "object" || N == "function");
  }
  function g(x) {
    return !!x && typeof x == "object";
  }
  function b(x) {
    return typeof x == "symbol" || g(x) && f.call(x) == n;
  }
  function _(x) {
    if (typeof x == "number")
      return x;
    if (b(x))
      return e;
    if (S(x)) {
      var N = typeof x.valueOf == "function" ? x.valueOf() : x;
      x = S(N) ? N + "" : N;
    }
    if (typeof x != "string")
      return x === 0 ? x : +x;
    x = x.replace(r, "");
    var A = o.test(x);
    return A || s.test(x) ? a(x.slice(2), A ? 2 : 8) : i.test(x) ? e : +x;
  }
  return Br = E, Br;
}
var jp = Hp();
var ha = /* @__PURE__ */ Ae(jp);
var zr;
var Uo;
function Fp() {
  if (Uo) return zr;
  Uo = 1;
  var t = 200, e = "__lodash_hash_undefined__", n = 1 / 0, r = "[object Function]", i = "[object GeneratorFunction]", o = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, a = typeof Ft == "object" && Ft && Ft.Object === Object && Ft, c = typeof self == "object" && self && self.Object === Object && self, u = a || c || Function("return this")();
  function v(R, H) {
    var d = R ? R.length : 0;
    return !!d && f(R, H, 0) > -1;
  }
  function l(R, H, d, w) {
    for (var P = R.length, O = d + -1; ++O < P; )
      if (H(R[O], O, R))
        return O;
    return -1;
  }
  function f(R, H, d) {
    if (H !== H)
      return l(R, p, d);
    for (var w = d - 1, P = R.length; ++w < P; )
      if (R[w] === H)
        return w;
    return -1;
  }
  function p(R) {
    return R !== R;
  }
  function h(R, H) {
    return R.has(H);
  }
  function y(R, H) {
    return R?.[H];
  }
  function E(R) {
    var H = false;
    if (R != null && typeof R.toString != "function")
      try {
        H = !!(R + "");
      } catch {
      }
    return H;
  }
  function S(R) {
    var H = -1, d = Array(R.size);
    return R.forEach(function(w) {
      d[++H] = w;
    }), d;
  }
  var g = Array.prototype, b = Function.prototype, _ = Object.prototype, x = u["__core-js_shared__"], N = (function() {
    var R = /[^.]+$/.exec(x && x.keys && x.keys.IE_PROTO || "");
    return R ? "Symbol(src)_1." + R : "";
  })(), A = b.toString, C = _.hasOwnProperty, I = _.toString, L = RegExp(
    "^" + A.call(C).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), j = g.splice, k = fe(u, "Map"), q = fe(u, "Set"), K = fe(Object, "create");
  function W(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.clear(); ++H < d; ) {
      var w = R[H];
      this.set(w[0], w[1]);
    }
  }
  function ot() {
    this.__data__ = K ? K(null) : {};
  }
  function ut(R) {
    return this.has(R) && delete this.__data__[R];
  }
  function Q(R) {
    var H = this.__data__;
    if (K) {
      var d = H[R];
      return d === e ? void 0 : d;
    }
    return C.call(H, R) ? H[R] : void 0;
  }
  function mt(R) {
    var H = this.__data__;
    return K ? H[R] !== void 0 : C.call(H, R);
  }
  function et(R, H) {
    var d = this.__data__;
    return d[R] = K && H === void 0 ? e : H, this;
  }
  W.prototype.clear = ot, W.prototype.delete = ut, W.prototype.get = Q, W.prototype.has = mt, W.prototype.set = et;
  function at(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.clear(); ++H < d; ) {
      var w = R[H];
      this.set(w[0], w[1]);
    }
  }
  function lt() {
    this.__data__ = [];
  }
  function wt(R) {
    var H = this.__data__, d = ue(H, R);
    if (d < 0)
      return false;
    var w = H.length - 1;
    return d == w ? H.pop() : j.call(H, d, 1), true;
  }
  function X(R) {
    var H = this.__data__, d = ue(H, R);
    return d < 0 ? void 0 : H[d][1];
  }
  function B(R) {
    return ue(this.__data__, R) > -1;
  }
  function xt(R, H) {
    var d = this.__data__, w = ue(d, R);
    return w < 0 ? d.push([R, H]) : d[w][1] = H, this;
  }
  at.prototype.clear = lt, at.prototype.delete = wt, at.prototype.get = X, at.prototype.has = B, at.prototype.set = xt;
  function Z(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.clear(); ++H < d; ) {
      var w = R[H];
      this.set(w[0], w[1]);
    }
  }
  function ft() {
    this.__data__ = {
      hash: new W(),
      map: new (k || at)(),
      string: new W()
    };
  }
  function _t(R) {
    return le(this, R).delete(R);
  }
  function It(R) {
    return le(this, R).get(R);
  }
  function Zt(R) {
    return le(this, R).has(R);
  }
  function Dt(R, H) {
    return le(this, R).set(R, H), this;
  }
  Z.prototype.clear = ft, Z.prototype.delete = _t, Z.prototype.get = It, Z.prototype.has = Zt, Z.prototype.set = Dt;
  function Lt(R) {
    var H = -1, d = R ? R.length : 0;
    for (this.__data__ = new Z(); ++H < d; )
      this.add(R[H]);
  }
  function Jt(R) {
    return this.__data__.set(R, e), this;
  }
  function Pe(R) {
    return this.__data__.has(R);
  }
  Lt.prototype.add = Lt.prototype.push = Jt, Lt.prototype.has = Pe;
  function ue(R, H) {
    for (var d = R.length; d--; )
      if (Ie(R[d][0], H))
        return d;
    return -1;
  }
  function on(R) {
    if (!Qt(R) || un(R))
      return false;
    var H = de(R) || E(R) ? L : s;
    return H.test(ln(R));
  }
  function sn(R, H, d) {
    var w = -1, P = v, O = R.length, $ = true, F = [], z = F;
    if (O >= t) {
      var V = an(R);
      if (V)
        return S(V);
      $ = false, P = h, z = new Lt();
    } else
      z = F;
    t:
      for (; ++w < O; ) {
        var Y = R[w], nt = Y;
        if (Y = Y !== 0 ? Y : 0, $ && nt === nt) {
          for (var ct = z.length; ct--; )
            if (z[ct] === nt)
              continue t;
          F.push(Y);
        } else P(z, nt, d) || (z !== F && z.push(nt), F.push(Y));
      }
    return F;
  }
  var an = q && 1 / S(new q([, -0]))[1] == n ? function(R) {
    return new q(R);
  } : Se;
  function le(R, H) {
    var d = R.__data__;
    return cn(H) ? d[typeof H == "string" ? "string" : "hash"] : d.map;
  }
  function fe(R, H) {
    var d = y(R, H);
    return on(d) ? d : void 0;
  }
  function cn(R) {
    var H = typeof R;
    return H == "string" || H == "number" || H == "symbol" || H == "boolean" ? R !== "__proto__" : R === null;
  }
  function un(R) {
    return !!N && N in R;
  }
  function ln(R) {
    if (R != null) {
      try {
        return A.call(R);
      } catch {
      }
      try {
        return R + "";
      } catch {
      }
    }
    return "";
  }
  function fn(R) {
    return R && R.length ? sn(R) : [];
  }
  function Ie(R, H) {
    return R === H || R !== R && H !== H;
  }
  function de(R) {
    var H = Qt(R) ? I.call(R) : "";
    return H == r || H == i;
  }
  function Qt(R) {
    var H = typeof R;
    return !!R && (H == "object" || H == "function");
  }
  function Se() {
  }
  return zr = fn, zr;
}
var Up = Fp();
var Bp = /* @__PURE__ */ Ae(Up);
var va = 10;
var zp = 12;
var qp = (t, e, n, r) => {
  const { staticSide: i, offset: o, rotation: s, shadowOpacity: a } = {
    top: {
      staticSide: "bottom",
      offset: "-5px",
      rotation: 45,
      shadowOpacity: 40
    },
    bottom: {
      staticSide: "top",
      offset: "-5px",
      rotation: 225,
      shadowOpacity: 7
    },
    right: {
      staticSide: "left",
      offset: "-5px",
      rotation: 135,
      shadowOpacity: 7
    },
    left: {
      staticSide: "right",
      offset: "-5px",
      rotation: -45,
      shadowOpacity: 40
    }
  }[t.split("-")[0]];
  return {
    boxShadow: `1px 1px 1px hsl(0deg 0% 13% / ${a}%)`,
    transform: `rotate(${s}deg)`,
    left: e != null ? `${e}px` : "",
    top: n != null ? `${n}px` : "",
    right: "",
    bottom: "",
    [i]: o,
    zIndex: r
  };
};
var Bo = (t, e) => {
  const n = t.slice(1);
  return e.find(
    ({ config: r, type: i }) => i === "@appcues/overlay" && n === r.rootId
  );
};
var Wp = (t, e) => {
  const n = va + zp / 2;
  return e.includes("start") ? t - n : t + n;
};
var Vp = ({
  placementUnit: t,
  distance: e,
  skidding: n,
  placement: r,
  targetEl: i
}) => {
  const o = r.startsWith("left") || r.startsWith("right"), s = o ? e : n, a = o ? n : e;
  if (t !== "percentage" || !i)
    return {
      mainAxis: e,
      crossAxis: n
    };
  const { width: c, height: u } = i.getBoundingClientRect(), v = o ? c * s / 100 : u * a / 100, l = o ? u * a / 100 : c * s / 100;
  return {
    mainAxis: v,
    crossAxis: l
  };
};
var hr = (t, e) => {
  try {
    const n = e(), r = n.document, i = n.getComputedStyle(t), { overflow: o, overflowY: s, overflowX: a } = i, c = /* @__PURE__ */ new Set([o, s, a]);
    if (i.position === "fixed" || i.position === "sticky" || c.has("auto") || c.has("hidden"))
      return true;
    const { host: u = null } = t?.getRootNode() ?? {}, v = u?.tagName?.includes(Sr) || u?.tagName?.includes(br);
    return t.parentElement === null && u && !v ? hr(u.parentElement, e) : t.parentElement !== null && t.parentElement !== r.body ? hr(t.parentElement, e) : false;
  } catch {
    return false;
  }
};
function zo(t) {
  return t === "fixed" || t === "relative" || t === "absolute" || t === "sticky";
}
function qo(t) {
  return t.display === "flex" || t.display === "inline-flex";
}
function ga(t, e, n, r, i) {
  let o = i, s = e.zIndex;
  const a = e.position, c = t.parentElement, u = c ? r.getComputedStyle(c) : {};
  if (s !== "" && s !== "auto" && !zo(a) && !qo(u) && (s = "auto"), (!o || s !== "" && s !== "auto" && (zo(a) || qo(u))) && (o = s), c && c !== n.body && c !== n.documentElement)
    return ga(c, u, n, r, o);
  if (/^\d+$/.test(o)) {
    let v = Number.parseInt(o, 10);
    v += 1, o = v;
  }
  return o;
}
var Gp = (t, e) => {
  const n = e(), r = n.document, i = n.getComputedStyle(t);
  return ga(t, i, r, n);
};
var Kp = ({
  targetEl: t,
  rootStyle: e,
  shouldAutoCalculateZIndex: n,
  getWindowReference: r
}) => {
  let i = e;
  if (n) {
    const o = Gp(t, r);
    i = { ...e, zIndex: o };
  }
  return i;
};
var Xp = () => {
  const t = /* @__PURE__ */ new Map();
  function e(i) {
    i.composedPath().forEach((o) => {
      (t.get(o) ?? {})[i.type]?.map((a) => a(i));
    });
  }
  return {
    addEventListener: (i, o, s) => {
      t.get(i) || t.set(i, {});
      const a = t.get(i);
      a[o] || (a[o] = []), a[o].includes(s) || (a[o] = [...a[o], s], t.set(i, a)), a[o].length === 1 && i.addEventListener(o, e, true);
    },
    removeEventListener: (i, o, s) => {
      const a = t.get(i);
      if (!a)
        return;
      const c = (a[o] ?? []).filter(
        (u) => u !== s
      );
      a[o] = c, t.set(i, a), a[o].length === 0 && i.removeEventListener(o, e, true);
    }
  };
};
var { addEventListener: vr, removeEventListener: gr } = Xp();
var Yp = () => {
  const t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Map(), n = (o) => {
    if (e.has(o)) return;
    const s = setInterval(() => {
      t.get(o).forEach((c) => c());
    }, o);
    e.set(o, s);
  }, r = (o, s) => {
    const a = t.get(s);
    if (a) {
      const c = a.filter((v) => v !== o);
      if (c.length > 0) {
        t.set(s, c);
        return;
      }
      const u = e.get(s);
      clearInterval(u), t.delete(s), e.delete(s);
    }
  };
  return (o, s) => {
    const a = t.get(s) ?? [];
    return t.set(s, [...a, o]), n(s), () => r(o, s);
  };
};
var Zp = Yp();
var We = (t, e) => {
  if (!e) return t;
  const { order: n, text: r } = e;
  let i = [...t];
  return r && r !== "" && (i = i.filter(
    (o) => o.textContent.replace(/\r\n|\r|\n/g, " ").toLowerCase().trim() === r.toString().toLowerCase().trim()
  )), n != null ? i.length > n ? [i[n]] : [] : i;
};
var Jp = "@appcues/overlay";
var Qp = {
  top: "top",
  "top-left": "top-start",
  "top-right": "top-end",
  right: "right",
  "right-top": "right-start",
  "right-bottom": "right-end",
  bottom: "bottom",
  "bottom-right": "bottom-end",
  "bottom-left": "bottom-start",
  left: "left",
  "left-bottom": "left-end",
  "left-top": "left-start",
  center: "top-start"
};
var th = (t) => {
  let e, n, r, i = [], o, s = () => {
  }, a;
  function c() {
    t();
  }
  const u = ha(c, 100);
  function v() {
    const l = e.getBoundingClientRect();
    a && (l.x !== a.x || l.y !== a.y || l.width !== a.width || l.height !== a.height) && u(), a = l;
  }
  return {
    setElements(l, f, p) {
      return e = l, n = f, r = p, i = [], this;
    },
    start() {
      r && (i = Bp([...pr(r)])), i.forEach((l) => {
        vr(l, "scroll", u), vr(l, "resize", u);
      }), o = new ResizeObserver(u), o.observe(n), a = e.getBoundingClientRect(), s = Zp(v, 200);
    },
    remove() {
      i.forEach((l) => {
        gr(l, "scroll", u), gr(l, "resize", u);
      }), o?.unobserve(n), s();
    }
  };
};
var eh = ({ addHook: t, registerAction: e }) => {
  let n, r = false, i = false, o, s, a, c, u, v, l = false, f = "absolute", p, h;
  t(
    "step.begin",
    ({
      onElementRemoved: y,
      querySelector: E,
      reportError: S,
      step: g,
      updateStyle: b,
      getWindowReference: _,
      getTraitConfig: x
    }) => {
      const { traits: N } = g.getConfig(), {
        arrowId: A = "arrow",
        target: C,
        rootId: I,
        placement: L = "auto",
        distance: j,
        skidding: k,
        placementUnit: q = "pixels",
        shouldAutoCalculateZIndex: K = true
      } = x(), W = Bo(C.selector, N), ut = N.find((et) => et.type === "@appcues/toggle")?.config?.startHidden ?? true;
      ut || b(I, { position: "absolute" }), a = () => {
        const et = g.querySelector(`#${I}`), at = g.querySelector(`#${A}`), lt = We(
          E(C.selector),
          C.filters
        );
        return {
          matchingElements: lt,
          targetEl: lt[0],
          rootEl: et[0],
          arrowEl: at[0]
        };
      };
      const Q = async () => {
        const { targetEl: et, rootEl: at, arrowEl: lt } = a();
        if (!r && et && at) {
          r = true;
          const wt = Vp({
            placement: L,
            targetEl: et,
            distance: j,
            skidding: k,
            placementUnit: q
          }), X = [
            Ip(({ placement: Lt }) => ({
              ...wt,
              crossAxis: lt && /start|end/gm.test(Lt) ? Wp(k, Lt) : wt.crossAxis
            }))
          ];
          L === "auto" && X.push(
            Lp(),
            Dp({
              crossAxis: true
            })
          ), lt && X.push($p({ element: lt, padding: va })), X.push(kp());
          const {
            middlewareData: B,
            strategy: xt,
            x: Z,
            y: ft,
            placement: _t
          } = await Mp(et, at, {
            middleware: X,
            placement: Qp[L] ?? "auto",
            strategy: f
          }), { referenceHidden: It } = B.hide;
          if (lt) {
            const { x: Lt, y: Jt } = B.arrow;
            b(
              A,
              qp(_t, Lt, Jt)
            );
          }
          const Zt = {
            left: `${Z}px`,
            position: xt,
            top: `${ft}px`
          }, Dt = Kp({
            targetEl: et,
            rootStyle: Zt,
            shouldAutoCalculateZIndex: K,
            getWindowReference: _
          });
          et.style.visibility === "hidden" && (Dt.visibility = "hidden", v = et.style.visibility), It && at.style.visibility !== "hidden" && (u = at.style.visibility, l = true, Dt.visibility = "hidden"), !It && l && (Dt.visibility = u ?? "visible", l = false), !It && et.style.visibility !== "hidden" && et.style.visibility !== "" && v === "hidden" && (Dt.visibility = "visible"), L === "center" && (Dt.transform = "translate(-50%, 50%)"), b(I, Dt);
        }
      };
      p = () => {
        r = false, Q();
      }, c = th(p);
      const mt = () => We(E(C.selector), C.filters);
      n = async () => {
        o && o(), s && s();
        const { matchingElements: et, rootEl: at } = a(), lt = et.length === 1, wt = et.length > 1, X = et.length === 0, B = () => {
          W || (s = y({
            getTarget: mt,
            onRemoved: () => {
              r = false, h = S(`Target got removed => ${C.selector}`), c.remove();
            }
          }));
        };
        if (lt) {
          const xt = W ? E(W.config.target.selector) : null;
          if (ut) {
            const Z = xt != null ? hr(
              xt[0]?.parentElement,
              _
            ) : false;
            f = hr(
              et[0]?.parentElement,
              _
            ) || Z ? "fixed" : "absolute", b(I, { position: f });
          }
          await Q(), B(), c.setElements(
            et[0],
            at,
            xt ? xt[0] : null
          ).start();
          return;
        }
        wt && S(
          `Found ${et.length} elements for selector ${C.selector}.`
        ), X && (h = S(
          `Could not find element for selector ${C.selector}.`
        ));
      };
    }
  ), t("step.postrender", async () => {
    i || (await n(), i = true);
  }), t("step.end", () => {
    o && o(), s && s(), c.remove(), r = false, i = false;
  }), t(
    "step.error",
    ({ step: y, getTraitConfig: E, onElementInserted: S, querySelector: g }) => {
      r = false, i = false;
      const { target: b } = E(), { traits: _ } = y.getConfig(), x = () => We(g(b.selector), b.filters);
      Bo(b.selector, _) || (o = S({
        getTarget: x,
        onInserted: () => {
          i = false, y.recover({ errorId: h });
        }
      }));
    }
  );
};
bt(Jp, eh);
var nh = "@appcues/persistent";
var rh = ({ addHook: t }) => {
  t("experience.begin", ({ steps: e }) => {
    e.map((n) => n.start());
  });
};
bt(nh, rh);
var ih = {
  left: "beforebegin",
  "inner-left": "afterbegin",
  right: "afterend",
  "inner-right": "beforeend"
};
var oh = "@appcues/inline";
var sh = ({
  distanceUnit: t,
  yOffset: e,
  xOffset: n,
  targetEl: r
}) => {
  if (t !== "%" || !r)
    return {
      x: `${n}px`,
      y: `${e}px`
    };
  const { width: i, height: o } = r.getBoundingClientRect();
  return {
    x: `${i * n / 100}px`,
    y: `${o * e / 100}px`
  };
};
function ah({ addHook: t }) {
  let e, n, r;
  t(
    "step.begin",
    ({
      step: i,
      getTraitConfig: o,
      reportError: s,
      onElementRemoved: a,
      updateRootStyle: c,
      querySelector: u,
      getWindowReference: v
    }) => {
      const {
        target: l,
        placement: f = "right",
        verticalAlignment: p = "bottom",
        allowOverlap: h = false,
        xOffset: y = 0,
        yOffset: E = 0,
        distanceUnit: S = "px",
        sticky: g = false,
        rootDisplay: b = "inline-block",
        clearContainer: _ = false
      } = o();
      e && e(), n && n();
      const x = We(
        u(l.selector),
        l.filters
      ), N = x.length === 1, A = x.length > 1, C = x.length === 0, I = (k) => {
        const q = v().document.createElement("div");
        if (_ && f.includes("inner"))
          for (; k.firstChild; )
            k.removeChild(k.firstChild);
        if (k.insertAdjacentElement(
          ih[f],
          q
        ) == null) {
          s(`can't insert inline container on the ${f}`);
          return;
        }
        i.setStepContainerTarget(q);
      }, L = () => We(u(l.selector), l.filters), j = () => {
        n = a({
          getTarget: L,
          onRemoved: () => {
            r = s(`Target got removed => ${l.selector}`);
          }
        });
      };
      if (N) {
        I(x[0]);
        const k = {
          display: b,
          verticalAlign: p
        }, { x: q, y: K } = sh({
          distanceUnit: S,
          xOffset: y,
          yOffset: E,
          targetEl: x[0]
        });
        if (h)
          k.position = "absolute", k.transform = `translate(${q}, ${K})`;
        else {
          const W = f.includes("left") ? "right" : "left";
          k[`margin-${W}`] = q, k[`margin-${p}`] = K;
        }
        if (g) {
          k.position = "sticky";
          const W = f.includes("left") ? "top" : "bottom";
          k[W] = 0, k.zIndex = ll;
        }
        c(k), j();
        return;
      }
      A && s(
        `Found ${x.length} elements for selector ${l.selector}.`
      ), C && (r = s(
        `Could not find element for selector ${l.selector}.`
      ));
    }
  ), t(
    "step.error",
    ({ step: i, getTraitConfig: o, onElementInserted: s, querySelector: a }) => {
      const { target: c } = o();
      e = s({
        getTarget: () => We(a(c.selector), c.filters),
        onInserted: () => {
          i.recover({ errorId: r });
        }
      });
    }
  ), t("step.end", () => {
    e && e(), n && n();
  });
}
bt(oh, ah);
var ch = (t, e, n) => {
  const { height: r, width: i, left: o, top: s } = t.getBoundingClientRect();
  return Math.floor(
    Math.sqrt(
      (e - (o + i / 2)) ** 2 + (n - (s + r / 2)) ** 2
    ) / 2
  );
};
var uh = (t, e) => {
  const { height: n, width: r } = t.getBoundingClientRect(), i = Math.floor(Math.sqrt(n ** 2 + r ** 2) / 4);
  return (e > 0 ? e : 0) + i;
};
var lh = (t) => t.key === "Escape";
var fh = (t, e) => ![...t.composedPath()].filter((i) => i.nodeType === Node.ELEMENT_NODE).some((i) => i?.contains?.(e) ?? false);
var Vn = (t, e) => ({
  remove: () => {
    t.removeEventListener("keydown", e), t.removeEventListener("click", e, true);
  },
  start: () => {
    t.addEventListener("click", e, true), t.addEventListener("keydown", e);
  }
});
var qr = (t, e, n) => e.length === 0 ? (n("Element not found"), false) : e.length > 1 ? (n(`More than one element found with id: ${t}`), false) : true;
var dh = "@appcues/toggle.style";
var ya = ({ targetId: t, styles: e = {} }, { updateStyle: n }) => {
  n(t, e);
};
var Wo = {
  [dh]: ya
};
var ph = ({ addHook: t, registerAction: e }, {
  startHidden: n = true,
  targetId: r,
  transition: i,
  closeOnClickOutside: o = true,
  closeRadius: s
}) => {
  let a, c, u, v = false, l = [], f = null, p = [];
  const h = () => {
    l.forEach((S) => S.remove()), l = [];
  };
  n && t("step.begin", ({ updateStyle: S, getWindowReference: g }) => {
    S(r, {
      opacity: "0",
      visibility: "hidden",
      "pointer-events": "none"
    }), p = [...g().document.querySelectorAll("iframe")];
  }), t("step.end", () => {
    o && h(), f?.remove(), f = null;
  }), t("step.error", () => {
    o && h(), f?.remove(), f = null;
  });
  const y = ({ on: S } = {}, g) => {
    const { reportError: b, step: _, updateStyle: x, getWindowReference: N } = g, A = N().document, C = _.querySelector(`#${r}`);
    if (!qr(r, C, b)) return;
    o && h();
    const I = {};
    i || (I.visibility = "hidden", I["pointer-events"] = "none"), x(r, {
      ...I,
      opacity: "0"
    }), i && setTimeout(() => {
      x(r, {
        visibility: "hidden",
        "pointer-events": "none"
      });
    }, i.duration * 1e3), s && v && (gr(A, "mousemove", a), p.forEach((L) => {
      L.contentDocument?.body && gr(
        L.contentDocument.body,
        "mousemove",
        a
      );
    }), v = false), S?.close?.forEach(
      (L) => Wo[L.type](L.config, g)
    );
  }, E = ({ on: S } = {}, g) => {
    const { reportError: b, step: _, updateStyle: x, getWindowReference: N } = g, A = N().document, C = _.querySelector(`#${r}`);
    if (!qr(r, C, b)) return;
    const I = {};
    if (i && (I.transition = `opacity ${i.duration}s ${i.easing}`), x(r, {
      ...I,
      visibility: "visible",
      opacity: "1",
      "pointer-events": "auto"
    }), S?.open?.forEach(
      (L) => Wo[L.type](L.config, g)
    ), o && l.length === 0) {
      const L = _.querySelector(":first-child")[0];
      u = (k) => {
        (lh(k) || fh(k, C[0])) && y({ on: S }, g);
      };
      const j = p.map((k) => k.contentDocument?.body ? Vn(
        k.contentDocument.body,
        u
      ) : null).filter(Boolean);
      l.push(
        Vn(A, u),
        Vn(L, u),
        ...j
      ), l.forEach((k) => k.start());
    }
    if (f || (c = (L) => {
      if (L.type === "keydown" && !["Enter", " "].includes(L.key))
        return;
      const j = [...L.composedPath()];
      ["a", "button"].includes(j[0].tagName.toLowerCase()) && y({ on: S }, g);
    }, f = Vn(C[0], c), f.start()), s && !v) {
      const L = uh(C[0], s);
      a = ha((j) => {
        ch(
          C[0],
          j.clientX,
          j.clientY
        ) > L && y({ on: S }, { reportError: b, step: _, updateStyle: x, getWindowReference: N });
      }, 60), vr(A, "mousemove", a), p.forEach((j) => {
        j.contentDocument?.body && vr(
          j.contentDocument.body,
          "mousemove",
          a
        );
      }), v = true;
    }
  };
  e("run", ({ on: S } = {}, g) => {
    const { step: b, reportError: _, getWindowReference: x } = g, N = b.querySelector(`#${r}`);
    if (!qr(r, N, _)) return;
    if (x().getComputedStyle(N[0]).visibility === "hidden") {
      E({ on: S }, g);
      return;
    }
    y({ on: S }, g);
  }), e("open", E), e("close", y), e("style", ya);
};
var hh = "@appcues/toggle";
bt(hh, ph);
var vh = "@appcues/coreEvents";
var gh = ({ registerAction: t }) => {
  t("step_seen", (e, { step: n }) => {
    n.seen();
  }), t("extended_event", ({ name: e, ...n }, { step: r }) => {
    r.extendedEvent(e, n);
  }), t("step_interaction", (e, { step: n }) => {
    n.interaction(e.interactionType, e.interactionData);
  }), t("experience_dismissed", (e, { step: n }) => {
    n.dismissExperience();
  }), t("experience_snoozed", (e, { step: n }) => {
    n.snoozeExperience();
  });
};
bt(vh, gh);
var yh = (t, e = {}, n = () => window) => {
  let r = e;
  const i = [], o = n().document, s = (v) => {
    const { el: l, callbackFn: f } = v.detail;
    i.push([l, f]), l[f].apply(v.target, [r]);
  };
  return o.addEventListener(`${t}:connect`, s), {
    getState: () => r,
    setState: (v) => {
      r = { ...r, ...v }, i.forEach(([l, f]) => {
        l[f].apply(l, [r]);
      });
    },
    destroy: () => {
      o.removeEventListener(`${t}:connect`, s);
    }
  };
};
var mh = "@appcues/store";
var Eh = ({ addHook: t, registerAction: e }, { id: n, initialState: r = {} }) => {
  let i;
  t("step.begin", ({ getWindowReference: o }) => {
    i = yh(n, r, o);
  }), t("step.end", () => {
    i && i.destroy();
  }), e("setState", ({ stateKey: o }, s, a) => {
    i && i.setState({ [o]: a?.detail });
  });
};
bt(mh, Eh);
var Sh = {
  slide_in_down: [
    {
      transform: "translate3d(0, -100%, 0)",
      visibility: "visible"
    },
    {
      transform: "translate3d(0, 0, 0)"
    }
  ],
  slide_out_down: [
    {
      transform: "translate3d(0, 0, 0)",
      offset: 0
    },
    {
      transform: "translate3d(0, 100%, 0)",
      offset: 0.99
    },
    {
      visibility: "hidden",
      offset: 1
    }
  ],
  slide_in_up: [
    {
      transform: "translate3d(0, 100%, 0)",
      visibility: "visible"
    },
    {
      transform: "translate3d(0, 0, 0)"
    }
  ],
  pulse: [
    {
      transform: "scale3d(1, 1, 1)"
    },
    {
      transform: "scale3d(1.05, 1.05, 1.05)"
    },
    {
      transform: "scale3d(1, 1, 1)"
    }
  ]
};
var bh = "@appcues/animate";
var wh = 500;
var xh = "none";
var Wr = (t, e) => new Promise((n) => {
  const {
    keyframes: r,
    duration: i = wh,
    iterations: o,
    effect: s,
    fill: a = xh,
    easing: c = "linear"
  } = e, u = Sh[s] || r, v = {
    duration: i,
    iterations: o,
    fill: a,
    easing: c
  };
  if (!u) return;
  const l = t.animate(u, v);
  l?.addEventListener ? l.addEventListener("finish", n, { once: true }) : n();
});
var _h = ({ addHook: t, registerAction: e }, n) => {
  t("step.postrender", ({ querySelector: r }) => {
    const { target: i } = n;
    if (!i) return;
    const o = r(i.selector);
    o.length !== 0 && Wr(o[0], n);
  }), e(
    "toggle",
    ({ toggleGroupId: r, target: i, animations: o }, { querySelector: s }) => {
      const a = s(i.selector);
      if (a.length === 0) return;
      const [c] = a, v = c.getAttribute(r) === o[0].id ? o[1] : o[0];
      Wr(c, v), v.id && c.setAttribute(r, v.id);
    }
  ), e("run", async (r, i) => {
    const { querySelector: o, getAction: s } = i, {
      toggleGroupId: a,
      target: c,
      animation: u,
      ignoreToggleGroup: v = false,
      onFinish: l = []
    } = r;
    if (!c) return;
    const f = o(c.selector);
    if (f.length === 0) return;
    const p = f[0], h = p.getAttribute(a);
    (!h || h === u.id) && !v || (await Wr(p, u ?? r), l.forEach((y) => {
      s(y.type)(y?.config ?? {}, i);
    }), v || p.setAttribute(a, u.id));
  });
};
bt(bh, _h);
var ma = {
  pixels: "px",
  percentage: "%"
};
function Th(t, e, n, r) {
  const i = ma[n] || "px";
  switch (t) {
    case "left":
      return {
        left: 0,
        transform: `translateX(${e}${i})`,
        ...r && {
          right: "unset"
        }
      };
    case "center":
      return {
        left: "50%",
        transform: `translateX(calc(-50% + ${e}${i}))`,
        ...r && {
          right: "unset"
        }
      };
    default:
      return {
        right: 0,
        transform: `translateX(-${e}${i})`,
        ...r && {
          left: "unset"
        }
      };
  }
}
function Rh(t, e, n, r) {
  const i = ma[n] || "px";
  switch (t) {
    case "top":
      return {
        top: 0,
        transform: `translateY(${e}${i})`,
        ...r && {
          bottom: "unset"
        }
      };
    case "center":
      return {
        top: "50%",
        transform: `translateY(calc(-50% + ${e}${i}))`,
        ...r && {
          bottom: "unset"
        }
      };
    default:
      return {
        bottom: 0,
        transform: `translateY(-${e}${i})`,
        ...r && {
          top: "unset"
        }
      };
  }
}
var Ch = "@appcues/floating";
var Oh = ({ addHook: t }) => {
  t("step.begin", ({ getTraitConfig: e, updateStyle: n, updateRootStyle: r }) => {
    const {
      target: i,
      strategy: o = "fixed",
      xOffset: s = 0,
      yOffset: a = 0,
      xPosition: c = "left",
      yPosition: u = "top",
      placementUnit: v = "pixels",
      unsetOppositeDirection: l = false,
      applyToRoot: f = false
    } = e(), p = [
      Th(
        c,
        s,
        v,
        l
      ),
      Rh(
        u,
        a,
        v,
        l
      )
    ].reduce((y, E) => {
      const { transform: S, ...g } = E;
      return S && (y.transform = y.transform ? `${y.transform} ${S}` : S), { ...y, ...g };
    }, {}), h = {
      position: o,
      ...p
    };
    if (f) {
      r(h, { forceUpdate: true });
      return;
    }
    n(i.selector, h);
  });
};
bt(Ch, Oh);
var Ah = "@appcues/dismissible";
function Vo(t) {
  return `_experience_dismissed_${t}`;
}
var Nh = ({ addHook: t, registerAction: e }, { strategy: n = "permanent" }) => {
  function r(i, o) {
    return n === "session" ? o().sessionStorage.getItem(Vo(i)) === "1" : false;
  }
  t(
    "experience.begin",
    ({ stopExperience: i, getExperienceId: o, getWindowReference: s }) => {
      r(o(), s) && i();
    }
  ), e(
    "dismiss",
    (i, { stopExperience: o, updateUserProfile: s, getExperienceId: a, getWindowReference: c }) => {
      const u = Vo(a());
      n === "session" ? c().sessionStorage.setItem(u, "1") : n === "permanent" && s({ [u]: "permanently_dismissed" }), o();
    }
  );
};
bt(Ah, Nh);
var Ph = "@appcues/experienceStyle";
var Ih = ({ addHook: t }) => {
  t("step.begin", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = n();
    e(r, { forceUpdate: true });
  }), t("step.container_change", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = n();
    e(r, { forceUpdate: true });
  }), t("step.end", ({ updateRootStyle: e, getTraitConfig: n }) => {
    const r = Object.keys(n()).reduce((i, o) => (i[o] = null, i), {});
    e(r, { forceUpdate: true });
  });
};
bt(Ph, Ih);
var Dh = "@appcues/rootStyle";
var Go = ({ getTraitConfig: t, updateRootStyle: e }) => {
  const { forceUpdate: n = false, ...r } = t();
  e(r, { forceUpdate: n });
};
function Lh({ addHook: t }) {
  t("step.begin", Go), t("step.container_change", Go);
}
bt(Dh, Lh);
var kh = "appcues:launchpad_close";
var $h = "appcues:launchpad_search";
var Mh = "appcues:launchpad_search_error";
var Hh = "appcues:launchpad_search_response";
var Ni = function(t, e) {
  return window.addEventListener(t, e), function() {
    return window.removeEventListener(t, e);
  };
};
var jh = function(t) {
  return Ni(kh, t);
};
var Fh = function(t, e, n) {
  var r = new CustomEvent($h, {
    detail: {
      integrationId: t,
      query: e,
      experienceId: n
    }
  });
  window.dispatchEvent(r);
};
var Uh = function(t, e) {
  return Ni("".concat(Hh, ":").concat(t), e);
};
var Bh = function(t, e) {
  return Ni("".concat(Mh, ":").concat(t), e);
};
var zh = "@appcues/sdk-middleware-events";
var qh = ({ addHook: t }, { onLaunchpadClose: e }) => {
  let n;
  t("step.begin", (r) => {
    n = jh(() => {
      e.forEach((i) => {
        r.getAction(i.type)?.(i.config, r);
      });
    });
  }), t("step.end", () => {
    n?.();
  });
};
bt(zh, qh);
var Wh = "@appcues/knowledge-base-integration";
var Gn = (t, { querySelector: e, reportError: n }) => {
  const r = e(t), i = r.length > 1, o = r.length === 0;
  return i && n(
    "The target element is duplicated, please provide a more specific selector"
  ), o && n("The target element is not found"), r[0];
};
var Vh = ({ addHook: t, registerAction: e }, n) => {
  const { integrationConnected: r = false } = n;
  let i, o, s, a, c;
  const u = () => {
    r && o?.prev();
  }, v = (l) => {
    if (!r) return;
    const { integrationId: f } = n, { inputValue: p } = l.detail;
    s.setAttribute("searchTerm", p), s.setAttribute("state", "loading"), i.setAttribute("loading", true), a && (a.scrollTop = 0), o?.next(), Fh(f, p, c);
  };
  t("step.begin", ({ getExperienceId: l }) => {
    c = l(), Uh(c, (f) => {
      const p = f.detail, h = p.results?.length === 0 ? "empty" : "showing_results";
      s.setAttribute("state", h), s.setAttribute("results", JSON.stringify(p.results)), i.setAttribute("loading", false);
    }), Bh(c, () => {
      s.setAttribute("state", "error"), i.setAttribute("loading", false);
    });
  }), t("step.end", () => {
    i?.removeEventListener("onSearch", v), i?.removeEventListener("onCancel", u);
  }), e("bindListeners", (l, f) => {
    const { navigation: p } = n;
    (!o || !i) && (o = Gn(p.selector, f), i = Gn("appcues-search-header", f), s = Gn("appcues-search-results", f), a = Gn("#launchpad-container", f), i?.addEventListener("onSearch", v), i?.addEventListener("onCancel", u));
  });
};
bt(Wh, Vh);
var Gh = "@appcues/sequential";
var Kh = ({ addHook: t, registerAction: e }) => {
  let n;
  const r = (s, { steps: a }) => {
    n !== 0 && (a[n].stop(), n -= 1, a[n].start());
  }, i = (s, { steps: a }) => {
    if (n === a.length - 1) {
      a[n].stop();
      return;
    }
    a[n].stop(), n += 1, a[n].start();
  }, o = (s, { step: a, steps: c }) => {
    a.stop();
    const u = c.findIndex(
      (v) => v.getConfig()?.id === s.stepId
    );
    u !== -1 && (n = u, c[n].start());
  };
  t("experience.begin", ({ steps: s }) => {
    n = 0, s[n].start();
  }), e("next", i), e("prev", r), e("goTo", o);
};
bt(Gh, Kh);
var Xh = ({
  getWindowReference: t,
  backdropZIndex: e,
  backdropBlur: n,
  backdropColor: r
}) => {
  if (t().document.querySelector(
    "#appcues-custom-backdrop"
  ))
    return null;
  const o = t().document.createElement("div");
  return o.id = "appcues-custom-backdrop", o.style.cssText = `
    z-index: ${e};
    position: fixed;
    inset: 0;
    backdrop-filter: ${n};
    background-color: ${r};
    pointer-events: none;
  `, o;
};
var Yh = "@appcues/dialog";
var Zh = `
  dialog { all: unset; }
  ::backdrop { backdrop-filter: var(--backdrop-blur); background-color: var(--backdrop-color); }
  :-internal-dialog-in-top-layer { all: unset; }
`;
function Jh(t) {
  const { backdropBlur: e, backdropColor: n } = t;
  return {
    ...e && { "--backdrop-blur": e },
    ...n && { "--backdrop-color": n }
  };
}
var Qh = ({ addHook: t }, e) => {
  const { backdrop: n, variables: r, customBackdrop: i } = e, { dialogZIndex: o, backdropZIndex: s, backdropBlur: a, backdropColor: c } = r || {};
  let u, v, l;
  if (n && !i) {
    const f = ({ getTraitConfig: p, updateRootStyle: h }) => {
      const { variables: y } = p();
      h(Jh(y || {}), {
        forceUpdate: true
      });
    };
    t("step.begin", f), t("step.container_change", f);
  }
  t("step.postrender", ({ step: f, getWindowReference: p }) => {
    if ([v] = f.querySelector("dialog") ?? [], !v) return;
    n && i && (l?.remove(), l = Xh({
      getWindowReference: p,
      backdropZIndex: s,
      backdropBlur: a,
      backdropColor: c
    }), l && p().document.body.append(l)), i || (u?.remove(), u = p().document.createElement("style"), u.textContent = Zh, v.prepend(u)), v.style.zIndex = o, v[n && !i ? "showModal" : "show"]();
  }), t("step.end", () => {
    v?.close(), u?.remove(), l?.remove();
  });
};
bt(Yh, Qh);
var tv = "@appcues/experienceTheme";
var ev = ({ addHook: t }) => {
  let e = null;
  function n({
    getContainer: i,
    getExperienceId: o,
    getWindowReference: s,
    getTraitConfig: a
  }) {
    const { css: c } = a(), u = i();
    if (!c || e && e.parentNode === u)
      return;
    const v = o();
    u && (e = s().document.createElement("style"), e.id = `appcues-experience-style-${v}`, e.textContent = c, u.prepend(e));
  }
  function r() {
    e && (e.remove(), e = null);
  }
  t("step.begin", n), t("experience.end", r);
};
bt(tv, ev);
var nv = (t) => class extends t.HTMLElement {
  constructor() {
    super();
    const n = this.ownerDocument || t.document;
    this.hideContentStyles = n.createElement("style"), this.hideContentStyles.innerHTML = `
        * {
          visibility: hidden;
        }
      `;
    try {
      this.attachShadow({ mode: "open" });
    } catch {
    }
    this.webComponentStyles = n.createElement("style"), this.webComponentStyles.innerHTML = `
        :host {
          all: initial;
          display: inline;
        }
      `;
  }
  async connectedCallback() {
    this.shadowRoot.append(this.hideContentStyles), this.shadowRoot.append(...this.childNodes), this.getAttribute("themeId") && await Is(this), this.shadowRoot.prepend(this.webComponentStyles), this.shadowRoot.removeChild(this.hideContentStyles);
  }
};
var Vr = /* @__PURE__ */ new WeakMap();
var rv = (t = () => window) => {
  const e = t();
  if (Vr.has(e))
    return Vr.get(e);
  if (!e.customElements.get(Tn)) {
    const r = nv(e);
    e.customElements.define(Tn, r);
  }
  const n = e.customElements.whenDefined(Tn);
  return Vr.set(e, n), n;
};
var iv = false;
function sv({
  runningExperiences: t = /* @__PURE__ */ new Map(),
  sendEvent: e = () => {
  },
  sendCustomEvent: n = () => {
  },
  showFlow: r = () => {
  },
  updateUserProfile: i = () => {
  },
  createRenderListener: o = fd,
  vNodeHandlers: s = xd,
  accessibilityHandlers: a = Rd,
  getWindowReference: c = () => window,
  apiOverrides: u = {}
} = {}) {
  fl(u);
  const v = /* @__PURE__ */ new Map(), l = {
    sendEvent: e,
    sendCustomEvent: n,
    showFlow: r,
    updateUserProfile: i,
    createRenderListener: o,
    vNodeHandlers: s,
    accessibilityHandlers: a,
    getWindowReference: c,
    apiOverrides: u
  }, f = (_) => _ ? l?.[_] ? l[_] : () => {
    throw new Error(`can't find external dependency called ${_}`);
  } : l, p = ({ reason: _ = Oe.NAVIGATION } = {}) => {
    t.forEach((x) => {
      x.experienceService.send({ type: Be, reason: _ }), x.experienceService.subscribe((N) => {
        N.matches("end-final") && x.experienceService.stop();
      });
    }), t.clear();
  }, h = (_, { reason: x = Oe.NAVIGATION } = {}) => {
    t.has(_) && (t.get(_).experienceService.send({ type: Be, reason: x }), t.delete(_));
  };
  return {
    registerAction: ae,
    registerTrait: bt,
    show: async (_) => {
      rv(c), await c().customElements.whenDefined(Tn);
      const x = Jn(
        Jn(
          _,
          "traits",
          (A) => (A ?? []).map((C, I) => ({
            ...C,
            id: C.id || `${C.type}:${I}`
          }))
        ),
        "steps",
        (A) => (A ?? []).map(
          (C) => Jn(
            C,
            "traits",
            (I) => (I ?? []).map((L, j) => ({
              ...L,
              id: L.id || `${L.type}:${j}`
            }))
          )
        )
      ), N = t.get(_.id)?.experienceService ?? ps(ud(x, f), {
        devTools: iv
      }).start();
      N.send({
        type: Qi,
        experience: x
      }), t.set(_.id, {
        experienceService: N,
        experience: x
      });
    },
    stopAll: p,
    stop: h,
    pause: (_) => {
      if (v.get(_)) return;
      const N = t.get(_);
      N && (h(_), v.set(_, {
        experienceService: N.experienceService,
        experience: N.experience
      }));
    },
    resume: (_) => {
      const x = v.get(_);
      x && (x.experienceService.send({ type: Qi }), t.set(_, {
        experienceService: x.experienceService,
        experience: x.experience
      }), v.delete(_));
    },
    getRunningExperiences: () => [...t].map(([, { experience: _ }]) => _),
    isExperiencePaused: (_) => v.has(_)
  };
}

// src/components/PreviewPane/WebPreviewFrame.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var WebPreviewFrame = ({
  title,
  experience
}) => {
  const [sdk, setSdk] = useState(null);
  const iframeRef = useCallback((node) => {
    if (node === null) return;
    const injectedDeps = {
      sendEvent: () => {
      },
      updateUserProfile: () => {
      },
      showFlow: () => {
      },
      getWindowReference: () => node.contentWindow
    };
    setSdk(sv(injectedDeps));
  }, []);
  useEffect2(() => {
    sdk?.show(experience);
  }, [sdk, experience]);
  return /* @__PURE__ */ jsxs2(Preview.Wrapper, { children: [
    /* @__PURE__ */ jsx2(
      Preview.Frame,
      {
        ref: iframeRef,
        title,
        scrolling: "no",
        src: "about:blank"
      }
    ),
    title && /* @__PURE__ */ jsx2(Preview.Title, { children: title })
  ] });
};

// src/components/PreviewPane/PreviewFrame.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var PreviewFrame2 = ({
  theme,
  platform,
  component,
  title,
  colorMode = "light"
}) => {
  if (platform === "mobile") {
    const mobileExperience = component ? wrapMobileComponentPreview(component) : makeMobileExperience(theme);
    return /* @__PURE__ */ jsx3(
      MobilePreviewFrame,
      {
        title,
        mobileExperience,
        colorMode
      }
    );
  }
  const webExperience = component?.block ? wrapWebComponentPreview(component.block) : makeWebExperience(theme);
  return /* @__PURE__ */ jsx3(WebPreviewFrame, { title, experience: webExperience });
};

// src/components/PreviewPane/PreviewPane.tsx
import { jsx as jsx4, jsxs as jsxs3 } from "react/jsx-runtime";
var PreviewPane = ({
  platform,
  theme
}) => {
  const [colorMode, setColorMode] = useState2("light");
  return /* @__PURE__ */ jsxs3(Panel, { colorMode, "data-theme": colorMode, children: [
    /* @__PURE__ */ jsx4(ControlBar, { children: /* @__PURE__ */ jsxs3(
      SegmentedControlGroup,
      {
        iconOnly: true,
        value: colorMode,
        size: "small",
        "aria-label": "Preview mode",
        onValueChange: (value) => setColorMode(value),
        children: [
          /* @__PURE__ */ jsx4(SegmentedControlGroupItem, { value: "light", children: /* @__PURE__ */ jsx4(Icon, { icon: import_faSun.faSun }) }),
          /* @__PURE__ */ jsx4(SegmentedControlGroupItem, { value: "dark", children: /* @__PURE__ */ jsx4(Icon, { icon: import_faMoon.faMoon }) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx4(PreviewFrame2, { theme, platform, colorMode })
  ] });
};

// src/components/DonateComponentModal/DonateComponentModal.styled.ts
import styled2 from "styled-components";
var Form = styled2.form`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-large, 24px);
`;
var FormField = styled2.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
`;
var Preview2 = styled2.div`
  display: flex;
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-small);

  > div:nth-child(n + 2)::before {
    content: '';
    position: absolute;
    top: var(--spacing-regular);
    bottom: var(--spacing-regular);
    left: 0;
    width: 1px;
    background-color: var(--border-default);
  }
`;

// src/components/DonateComponentModal/DonateComponentModal.tsx
import { Fragment, jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var makeUpdatedComponentDefinition = (base, delta) => {
  const result = { ...base };
  Object.entries(delta).forEach(([key, value]) => {
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      result[key] = makeUpdatedComponentDefinition(result[key] || {}, value);
    } else if (value === void 0) {
      delete result[key];
    } else {
      result[key] = delta[key];
    }
  });
  return result;
};
var DonateComponentModal = ({
  platform,
  onSave
}) => {
  const {
    container,
    theme,
    updateTheme,
    donatedComponent,
    setDonatedComponent
  } = useThemeEditor();
  const [componentName, setComponentName] = useState3("");
  const [saveState, setSaveState] = useState3(
    "idle"
  );
  const { isCreate, type, existingPath } = donatedComponent ?? {};
  const existingName = existingPath?.split(".").pop();
  const path = isCreate ? `${type}.${camelCase(componentName)}` : existingPath;
  useEffect3(() => {
    const initialName = existingName ? `${existingName.split(".").pop()} 2` : void 0;
    setComponentName(initialName ?? "");
    setSaveState("idle");
  }, [existingName]);
  useEffect3(() => {
    if (saveState === "pending") {
      onSave({ donatedVariantName: path });
      setSaveState("saving");
    }
  }, [saveState, onSave, path]);
  if (!donatedComponent || !theme) return null;
  const unavailableNames = Object.keys(
    theme.content.components[donatedComponent.type] ?? {}
  );
  const showErrors = saveState === "idle";
  const nameIsError = showErrors && unavailableNames.includes(camelCase(componentName));
  const handleSave = () => {
    const existingComponent = get2(theme.content.components, existingPath) ?? {};
    const updatedComponent = makeUpdatedComponentDefinition(
      existingComponent,
      donatedComponent.componentDefinition
    );
    updateTheme(`content.components.${path}`, updatedComponent);
    setSaveState("pending");
  };
  return /* @__PURE__ */ jsx5(
    Modal,
    {
      container,
      open: donatedComponent !== null,
      onOpenChange: () => setDonatedComponent(null),
      children: /* @__PURE__ */ jsxs4(ModalContent, { children: [
        /* @__PURE__ */ jsx5(ModalHeader, { children: /* @__PURE__ */ jsxs4(ModalTitle, { children: [
          /* @__PURE__ */ jsx5(Icon2, { icon: isCreate ? import_faFloppyDisk.faFloppyDisk : import_faArrowsRotate.faArrowsRotate }),
          isCreate ? "Save as new variant" : `Update \u201C${startCase(existingName)}\u201D`
        ] }) }),
        /* @__PURE__ */ jsx5(ModalDescription, { children: /* @__PURE__ */ jsxs4(Form, { "aria-label": "save component form", role: "form", "data-theme": "light", children: [
          isCreate && /* @__PURE__ */ jsxs4(Fragment, { children: [
            "Save your changes as a new variant so it can be reused in flows that use the theme \u201C",
            theme.name,
            "\u201D.",
            /* @__PURE__ */ jsxs4(FormItem, { children: [
              /* @__PURE__ */ jsx5(FormLabel, { htmlFor: "name", children: "Variant name" }),
              /* @__PURE__ */ jsx5(FormControl, { children: /* @__PURE__ */ jsx5(
                Input,
                {
                  id: "name",
                  defaultValue: componentName,
                  onChange: (event) => setComponentName(event.target.value),
                  placeholder: "Component name"
                }
              ) }),
              nameIsError && /* @__PURE__ */ jsxs4(FormMessage, { state: "error", children: [
                "\u201C",
                componentName,
                "\u201D already exists."
              ] })
            ] })
          ] }),
          !isCreate && /* @__PURE__ */ jsxs4(Alert, { variant: "warning", children: [
            /* @__PURE__ */ jsx5(Icon2, { icon: import_faCircleExclamation.faCircleExclamation, size: "small" }),
            /* @__PURE__ */ jsx5(AlertDescription, { children: "This updated style will immediately be applied to all flows that use this variant." })
          ] }),
          /* @__PURE__ */ jsxs4(Preview2, { children: [
            donatedComponent.originalReferenceModel && /* @__PURE__ */ jsx5(
              PreviewFrame2,
              {
                theme,
                platform,
                title: "Original",
                component: donatedComponent.originalReferenceModel
              }
            ),
            /* @__PURE__ */ jsx5(
              PreviewFrame2,
              {
                theme,
                platform,
                title: isCreate ? "Preview" : "Updated",
                component: donatedComponent.referenceModel
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ jsxs4(ModalFooter, { children: [
          /* @__PURE__ */ jsx5(
            Button,
            {
              type: "button",
              variant: "outline",
              onClick: () => setDonatedComponent(null),
              children: "Cancel"
            }
          ),
          /* @__PURE__ */ jsx5(
            Button,
            {
              type: "button",
              variant: "primary",
              disabled: isCreate && !(componentName && !nameIsError),
              onClick: handleSave,
              children: isCreate ? "Save" : "Update variant"
            }
          )
        ] })
      ] })
    }
  );
};

// src/components/ThemeModal/ThemeModal.tsx
var import_faSwatchbook = __toESM(require_faSwatchbook());
import {
  Modal as Modal2,
  ModalContent as ModalContent2,
  ModalHeader as ModalHeader2,
  ModalTitle as ModalTitle2,
  ModalFooter as ModalFooter2,
  Icon as Icon3,
  Button as Button2
} from "@appcues/sonar-builder";

// src/components/StyleSettings/StyleSettings.tsx
import { Accordion } from "@appcues/sonar-builder";

// src/components/StyleSettings/OverviewSection.tsx
import { useState as useState4 } from "react";
import {
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
  Input as Input2,
  Label,
  Switch
} from "@appcues/sonar-builder";

// src/lib/color-handler.ts
var updateToDarkMode = (enabled, components) => {
  const processValue = (value) => {
    if (!value || typeof value !== "object") {
      return value;
    }
    if ("light" in value && typeof value.light === "string") {
      if (!enabled) {
        const { dark, ...rest } = value;
        return rest;
      }
      return {
        ...value,
        dark: value.light.startsWith("{colors.") ? value.light.replace("{colors.", "{colors.dark.") : value.light
      };
    }
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [key, processValue(val)])
    );
  };
  return processValue(components);
};

// src/components/StyleSettings/StyleSettings.styled.ts
import styled3 from "styled-components";
var Controls = styled3.div`
  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing) * 3); /* 12px spacing between accordions */
`;
var FieldSet = styled3.fieldset`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--spacing-small);
  margin: 0;
  padding: 0;
  border: none;
  > label {
    min-width: 40%;
    flex: 1;
  }
`;

// src/components/StyleSettings/OverviewSection.tsx
import { jsx as jsx6, jsxs as jsxs5 } from "react/jsx-runtime";
var OverviewSection = ({ theme }) => {
  const { updateTheme } = useThemeEditor();
  const { name: themeName, content } = theme;
  const { meta, components } = content;
  const [name, setName] = useState4(themeName);
  const [darkMode, setDarkMode] = useState4(meta?.darkMode ?? false);
  const handleNameChange = (event) => {
    const { value } = event.target;
    setName(value);
    updateTheme("", { name: value });
  };
  const handleDarkModeChange = (checked) => {
    setDarkMode(checked);
    updateTheme("content", {
      meta: {
        ...meta,
        darkMode: checked
      },
      components: updateToDarkMode(checked, components)
    });
  };
  return /* @__PURE__ */ jsxs5(AccordionItem, { value: "overview", children: [
    /* @__PURE__ */ jsx6(AccordionTrigger, { children: "Theme settings" }),
    /* @__PURE__ */ jsx6(AccordionContent, { children: /* @__PURE__ */ jsxs5(Controls, { children: [
      /* @__PURE__ */ jsxs5(FieldSet, { children: [
        /* @__PURE__ */ jsx6(Label, { htmlFor: "name", children: "Name" }),
        /* @__PURE__ */ jsx6(
          Input2,
          {
            size: "small",
            id: "name",
            defaultValue: name,
            onChange: handleNameChange,
            placeholder: "Theme name"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs5(FieldSet, { children: [
        /* @__PURE__ */ jsx6(Label, { htmlFor: "dark-mode", children: "Enable dark mode" }),
        /* @__PURE__ */ jsx6(
          Switch,
          {
            id: "dark-mode",
            checked: darkMode,
            onCheckedChange: handleDarkModeChange
          }
        )
      ] })
    ] }) })
  ] });
};

// src/components/StyleSettings/ColorSection.tsx
import startCase2 from "lodash.startcase";
import { get as get3 } from "object-path-immutable";
import {
  AccordionItem as AccordionItem2,
  AccordionTrigger as AccordionTrigger2,
  AccordionContent as AccordionContent2,
  Label as Label2
} from "@appcues/sonar-builder";

// src/components/StyleSettings/ColorTokenInput.tsx
import { useState as useState5 } from "react";
import { Input as Input3 } from "@appcues/sonar-builder";
import { jsx as jsx7 } from "react/jsx-runtime";
var ColorTokenInput = ({ path, token }) => {
  const { updateTheme, container } = useThemeEditor();
  const [color, setColor] = useState5(token?.$value ?? "");
  const handleChange = (event) => {
    const { value } = event.target;
    setColor(value);
    updateTheme(path, {
      ...token,
      $value: value
    });
  };
  return /* @__PURE__ */ jsx7(
    Input3,
    {
      id: path,
      type: "text",
      value: color,
      onChange: handleChange,
      size: "small",
      container
    }
  );
};

// src/components/StyleSettings/ColorSection.tsx
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var ColorSection = ({ tokens, showDarkMode }) => {
  const controls = ["foreground", "background", "primary"].map((field) => ({
    light: {
      path: `content.tokens.colors.${field}`,
      label: startCase2(field),
      token: get3(tokens, `colors.${field}`)
    },
    ...showDarkMode && {
      dark: {
        path: `content.tokens.colors.dark.${field}`,
        token: get3(tokens, `colors.dark.${field}`)
      }
    }
  }));
  return /* @__PURE__ */ jsxs6(AccordionItem2, { value: "color", children: [
    /* @__PURE__ */ jsx8(AccordionTrigger2, { children: "Colors" }),
    /* @__PURE__ */ jsx8(AccordionContent2, { children: /* @__PURE__ */ jsx8(Controls, { children: controls.map(({ light, dark }) => /* @__PURE__ */ jsxs6(FieldSet, { children: [
      /* @__PURE__ */ jsx8(Label2, { htmlFor: light.path, children: light.label }),
      /* @__PURE__ */ jsx8(ColorTokenInput, { path: light.path, token: light.token }),
      dark && /* @__PURE__ */ jsx8(ColorTokenInput, { path: dark.path, token: dark.token })
    ] }, light.path)) }) })
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { useState as useState7 } from "react";
import { get as get5 } from "object-path-immutable";
import {
  AccordionItem as AccordionItem3,
  AccordionTrigger as AccordionTrigger3,
  AccordionContent as AccordionContent3
} from "@appcues/sonar-builder";

// src/components/RangeInput.tsx
import styled4 from "styled-components";
import { Label as Label3, Input as Input4 } from "@appcues/sonar-builder";
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var Container = styled4.div`
  flex: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: var(--spacing-small);
`;
var RangeInput = ({
  label,
  value,
  min,
  max,
  onValueChange
}) => {
  return /* @__PURE__ */ jsxs7(Container, { children: [
    /* @__PURE__ */ jsx9(Label3, { children: label }),
    /* @__PURE__ */ jsx9(
      Input4,
      {
        type: "number",
        size: "small",
        min,
        max,
        value,
        onChange: (event) => onValueChange(Number(event.target.value))
      }
    )
  ] });
};

// src/lib/basic-theme-tokens.ts
import { get as get4 } from "object-path-immutable";

// src/types.ts
var TOKEN_EXTENSIONS = {
  FONT: "com.appcues.theme.font",
  PRESET: "com.appcues.theme.preset"
};
var PRESET_SIZES = ["S", "M", "L"];

// src/lib/basic-theme-tokens.ts
var PRESET_FONT_SIZES = {
  S: [12, 14, 18, 14, 16, 18, 20, 24],
  M: [14, 16, 22, 16, 18, 20, 24, 32],
  L: [16, 18, 24, 18, 20, 22, 26, 34]
};
var PRESET_SPACING = {
  S: [0, 4, 6, 8, 10, 12],
  M: [0, 8, 12, 16, 20, 24],
  L: [0, 12, 18, 24, 30, 36]
};
var currentFontSize = (tokens) => {
  return get4(tokens, ["font", "size", "$extensions", TOKEN_EXTENSIONS.PRESET]);
};
var currentCornerRadius = (tokens) => Number.parseFloat(get4(tokens, "parts.container.corner-radius.$value"));
var currentSpacing = (tokens) => {
  return get4(tokens, [
    "dimensions",
    "unit",
    "$extensions",
    TOKEN_EXTENSIONS.PRESET
  ]);
};
var presetFontSizes = (size) => {
  const [small, regular, large, h5, h4, h3, h2, h1] = PRESET_FONT_SIZES[size];
  return {
    $type: "dimension",
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    small: { $value: `${small}px` },
    regular: { $value: `${regular}px` },
    large: { $value: `${large}px` },
    h5: { $value: `${h5}px` },
    h4: { $value: `${h4}px` },
    h3: { $value: `${h3}px` },
    h2: { $value: `${h2}px` },
    h1: { $value: `${h1}px` }
  };
};
var presetSpacing = (size) => ({
  $type: "dimension",
  unit: {
    $extensions: {
      [TOKEN_EXTENSIONS.PRESET]: size
    },
    ...Object.fromEntries(
      PRESET_SPACING[size].map((value, i) => [
        i.toString(),
        { $value: `${value}px` }
      ])
    )
  }
});

// src/components/FontFamilySelect.tsx
import { useState as useState6 } from "react";
import startCase3 from "lodash.startcase";
import {
  Label as Label4,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectPortal,
  SelectItem
} from "@appcues/sonar-builder";
import { Fragment as Fragment2, jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var SYSTEM_FONT_MAPPING = {
  "System Sans-serif": "System Default",
  "System Serif": "System Serif",
  "System Monospaced": "System Monospaced",
  "System Rounded": "System Rounded"
};
var systemFontMapping = (fontName) => ({
  ultralight: `${fontName} Ultralight`,
  thin: `${fontName} Thin`,
  light: `${fontName} Light`,
  regular: `${fontName} Regular`,
  medium: `${fontName} Medium`,
  semibold: `${fontName} Semibold`,
  bold: `${fontName} Bold`,
  heavy: `${fontName} Heavy`,
  black: `${fontName} Black`
});
var FontFamilySelect = ({
  path,
  label = startCase3(path.split(".").pop()),
  token
}) => {
  const { updateTheme, container } = useThemeEditor();
  const [fontFamily, setFontFamily] = useState6(token?.$value ?? "");
  const handleFontFamilyChange = (value) => {
    setFontFamily(value);
    const systemFontName = SYSTEM_FONT_MAPPING[value];
    updateTheme(path, {
      $value: value,
      $extensions: {
        [TOKEN_EXTENSIONS.FONT]: {
          mobile: systemFontMapping(systemFontName)
        }
      }
    });
  };
  return /* @__PURE__ */ jsxs8(Fragment2, { children: [
    /* @__PURE__ */ jsx10(Label4, { htmlFor: "font-family", children: label }),
    /* @__PURE__ */ jsxs8(
      Select,
      {
        name: "font-family",
        defaultValue: fontFamily,
        onValueChange: handleFontFamilyChange,
        children: [
          /* @__PURE__ */ jsx10(SelectTrigger, { id: "font-family", size: "small", children: /* @__PURE__ */ jsx10(SelectValue, { placeholder: "Select one" }) }),
          /* @__PURE__ */ jsx10(SelectPortal, { container, children: /* @__PURE__ */ jsxs8(SelectContent, { children: [
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Sans-serif", children: "System Sans-serif" }),
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Serif", children: "System Serif" }),
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Monospaced", children: "System Monospaced" }),
            /* @__PURE__ */ jsx10(SelectItem, { value: "System Rounded", children: "System Rounded" })
          ] }) })
        ]
      }
    )
  ] });
};

// src/components/PresetSizeControl.tsx
import {
  Label as Label5,
  SegmentedControlGroup as SegmentedControlGroup2,
  SegmentedControlGroupItem as SegmentedControlGroupItem2
} from "@appcues/sonar-builder";
import { Fragment as Fragment3, jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var PresetSizeControl = ({
  label,
  value,
  onChange
}) => {
  return /* @__PURE__ */ jsxs9(Fragment3, { children: [
    /* @__PURE__ */ jsx11(Label5, { children: label }),
    /* @__PURE__ */ jsx11(
      SegmentedControlGroup2,
      {
        size: "small",
        value,
        "aria-label": label,
        onValueChange: onChange,
        children: PRESET_SIZES.map((size) => /* @__PURE__ */ jsx11(SegmentedControlGroupItem2, { value: size, children: size }, size))
      }
    )
  ] });
};

// src/components/StyleSettings/InterfaceSection.tsx
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var InterfaceSection = ({ tokens }) => {
  const { updateTheme } = useThemeEditor();
  const [fontSize, setFontSize] = useState7(currentFontSize(tokens));
  const [cornerRadius, setCornerRadius] = useState7(currentCornerRadius(tokens));
  const [spacing, setSpacing] = useState7(currentSpacing(tokens));
  const handleFontSizeChange = (value) => {
    setFontSize(value);
    updateTheme("content.tokens.font.size", presetFontSizes(value));
  };
  const handleCornerRadiusChange = (value) => {
    setCornerRadius(value);
    updateTheme("content.tokens.parts.container.corner-radius", {
      $value: `${value}px`
    });
  };
  const handleSpacingChange = (value) => {
    setSpacing(value);
    updateTheme("content.tokens.dimensions", presetSpacing(value));
  };
  return /* @__PURE__ */ jsxs10(AccordionItem3, { value: "interface", children: [
    /* @__PURE__ */ jsx12(AccordionTrigger3, { children: "Interface" }),
    /* @__PURE__ */ jsx12(AccordionContent3, { children: /* @__PURE__ */ jsxs10(Controls, { children: [
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        FontFamilySelect,
        {
          path: "content.tokens.font.family.base",
          label: "Font family",
          token: get5(tokens, "font.family.base")
        }
      ) }),
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        PresetSizeControl,
        {
          label: "Font size",
          value: fontSize,
          onChange: handleFontSizeChange
        }
      ) }),
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        RangeInput,
        {
          label: "Corner radius",
          value: cornerRadius,
          min: 0,
          max: 100,
          onValueChange: handleCornerRadiusChange
        }
      ) }),
      /* @__PURE__ */ jsx12(FieldSet, { children: /* @__PURE__ */ jsx12(
        PresetSizeControl,
        {
          label: "Spacing",
          value: spacing,
          onChange: handleSpacingChange
        }
      ) })
    ] }) })
  ] });
};

// src/components/StyleSettings/StyleSettings.tsx
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var StyleSettings = ({ theme }) => {
  return /* @__PURE__ */ jsxs11(
    Accordion,
    {
      defaultValue: ["overview", "color", "interface"],
      type: "multiple",
      children: [
        /* @__PURE__ */ jsx13(OverviewSection, { theme }),
        /* @__PURE__ */ jsx13(
          ColorSection,
          {
            tokens: theme.content.tokens,
            showDarkMode: theme.content.meta?.darkMode ?? false
          }
        ),
        /* @__PURE__ */ jsx13(InterfaceSection, { tokens: theme.content.tokens })
      ]
    }
  );
};

// src/components/ThemeModal/ThemeModal.styled.ts
import styled5 from "styled-components";
var Wrapper = styled5.div`
  display: flex;
  gap: var(--spacing-small);
  padding: var(--spacing-regular);
  min-height: 500px;
`;
var Settings = styled5.div`
  width: 336px;
  overflow-y: auto;
`;
var Preview3 = styled5.div`
  min-width: 336px;
  flex: 1;
  border: 1px solid var(--border-default);
  border-radius: var(--border-radius-x-small);
  overflow: hidden;
`;

// src/components/ThemeModal/ThemeModal.tsx
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var ThemeModal = ({ platform, onSave }) => {
  const { theme, container, isEditorOpen, setIsEditorOpen } = useThemeEditor();
  const handleClose = () => setIsEditorOpen(false);
  if (!theme) return null;
  return /* @__PURE__ */ jsx14(
    Modal2,
    {
      open: isEditorOpen,
      onOpenChange: () => setIsEditorOpen(false),
      container,
      children: /* @__PURE__ */ jsxs12(ModalContent2, { size: "large", children: [
        /* @__PURE__ */ jsx14(ModalHeader2, { children: /* @__PURE__ */ jsxs12(ModalTitle2, { children: [
          /* @__PURE__ */ jsx14(Icon3, { icon: import_faSwatchbook.faSwatchbook }),
          "Edit Theme \u201C",
          theme.name,
          "\u201D"
        ] }) }),
        /* @__PURE__ */ jsxs12(Wrapper, { "data-theme": "light", children: [
          /* @__PURE__ */ jsx14(Settings, { children: /* @__PURE__ */ jsx14(StyleSettings, { theme }) }),
          /* @__PURE__ */ jsx14(Preview3, { children: /* @__PURE__ */ jsx14(PreviewPane, { platform, theme }) })
        ] }),
        /* @__PURE__ */ jsxs12(ModalFooter2, { "data-theme": "light", children: [
          /* @__PURE__ */ jsx14(Button2, { type: "button", variant: "outline", onClick: handleClose, children: "Cancel" }),
          /* @__PURE__ */ jsx14(Button2, { type: "button", variant: "primary", onClick: onSave, children: "Save" })
        ] })
      ] })
    }
  );
};

// src/components/ThemeEditor/ThemeEditor.tsx
import { Fragment as Fragment4, jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var ThemeEditor = ({
  id: id2,
  platform: targetPlatform,
  container,
  onPublish
}) => {
  const {
    theme,
    isEditorOpen,
    setIsEditorOpen,
    donatedComponent,
    setDonatedComponent,
    setContainer,
    fetchTheme,
    saveTheme,
    publishTheme
  } = useThemeEditor();
  useEffect4(() => {
    setContainer(container);
  }, [container, setContainer]);
  useEffect4(() => {
    if (isEditorOpen || donatedComponent !== null) {
      fetchTheme(id2);
    }
  }, [isEditorOpen, donatedComponent, fetchTheme, id2]);
  if (!theme) return null;
  const handleSave = async (metadata = {}) => {
    const delta = {
      id: theme.id,
      name: theme.name,
      content: theme.content
    };
    await saveTheme(delta);
    const updatedCompiledThemes = await publishTheme(theme.id);
    onPublish?.(
      updatedCompiledThemes.find(({ platform }) => platform === targetPlatform)
    );
    if (donatedComponent && metadata.donatedVariantName) {
      donatedComponent.onComplete?.(metadata.donatedVariantName);
    }
    setIsEditorOpen(false);
    setDonatedComponent(null);
  };
  return /* @__PURE__ */ jsxs13(Fragment4, { children: [
    /* @__PURE__ */ jsx15(DonateComponentModal, { platform: targetPlatform, onSave: handleSave }),
    /* @__PURE__ */ jsx15(ThemeModal, { platform: targetPlatform, onSave: handleSave })
  ] });
};

// src/components/Provider.tsx
import { useState as useState8, useMemo, useCallback as useCallback2 } from "react";
import { assign } from "object-path-immutable";
import { jsx as jsx16 } from "react/jsx-runtime";
var Provider = ({
  children,
  fetchTheme: fetchThemeApi,
  saveTheme: saveThemeApi,
  publishTheme: publishThemeApi
}) => {
  const [theme, setTheme] = useState8(null);
  const [isLoading, setIsLoading] = useState8(false);
  const [isEditorOpen, setIsEditorOpen] = useState8(false);
  const [donatedComponent, setDonatedComponent] = useState8(null);
  const [container, setContainer] = useState8(null);
  const updateTheme = useCallback2(
    (path, chunk) => {
      setTheme(assign(theme, path, chunk));
    },
    [theme]
  );
  const fetchTheme = useCallback2(
    async (id2) => {
      try {
        setIsLoading(true);
        const loadedTheme = await fetchThemeApi(id2);
        setTheme(loadedTheme);
      } catch (error) {
        console.error("Error fetching theme:", error);
      } finally {
        setIsLoading(false);
      }
    },
    [fetchThemeApi]
  );
  const saveTheme = useCallback2(
    async (model) => {
      try {
        if (!model.id) {
          throw new Error("Theme ID is required");
        }
        const result = await saveThemeApi(model.id, model);
        return result;
      } catch (error) {
        console.error("Theme save failed:", error);
        throw error;
      }
    },
    [saveThemeApi]
  );
  const publishTheme = useCallback2(
    async (id2) => {
      try {
        const publishedThemes = await publishThemeApi(id2);
        return publishedThemes;
      } catch (error) {
        console.error("Theme publish failed:", error);
        throw error;
      }
    },
    [publishThemeApi]
  );
  const value = useMemo(
    () => ({
      theme,
      setTheme,
      updateTheme,
      isLoading,
      setIsLoading,
      isEditorOpen,
      setIsEditorOpen,
      donatedComponent,
      setDonatedComponent,
      container,
      setContainer,
      fetchTheme,
      saveTheme,
      publishTheme
    }),
    [
      theme,
      updateTheme,
      isLoading,
      isEditorOpen,
      donatedComponent,
      container,
      fetchTheme,
      saveTheme,
      publishTheme
    ]
  );
  return /* @__PURE__ */ jsx16(Context_default.Provider, { value, children });
};

// src/model/base-theme.ts
var base_theme_default = {
  name: "Base Theme",
  content: {
    meta: {
      schemaVersion: 4,
      darkMode: false
    },
    tone: {},
    tokens: {
      colors: {
        $type: "color",
        foreground: { $value: "#000000" },
        background: { $value: "#ffffff" },
        primary: { $value: "#5c5cff" },
        "primary-contrast": { $value: "#ffffff" },
        utility: {
          backdrop: { $value: "#0000004d" },
          error: { $value: "#d6216b" },
          unselected: { $value: "#627293" }
        },
        dark: {
          foreground: { $value: "#ffffff" },
          background: { $value: "#000000" },
          primary: { $value: "#5c5cff" },
          "primary-contrast": { $value: "#ffffff" },
          utility: {
            backdrop: { $value: "#0000004d" },
            error: { $value: "#bf3c97" },
            unselected: { $value: "#627293" }
          }
        }
      },
      font: {
        family: {
          $type: "fontFamily",
          base: {
            $value: "System Sans-serif",
            $extensions: {
              "com.appcues.theme.font": {
                web: {},
                mobile: {
                  ultralight: "System Default Ultralight",
                  thin: "System Default Thin",
                  light: "System Default Light",
                  regular: "System Default Regular",
                  medium: "System Default Medium",
                  semibold: "System Default Semibold",
                  bold: "System Default Bold",
                  heavy: "System Default Heavy",
                  black: "System Default Black"
                }
              }
            }
          }
        },
        weight: {
          $type: "fontWeight",
          regular: { $value: "regular" },
          medium: { $value: "medium" },
          bold: { $value: "bold" }
        },
        size: {
          $type: "dimension",
          $extensions: {
            "com.appcues.theme.preset": "M"
          },
          small: { $value: "14px" },
          regular: { $value: "16px" },
          large: { $value: "22px" },
          h5: { $value: "16px" },
          h4: { $value: "18px" },
          h3: { $value: "20px" },
          h2: { $value: "24px" },
          h1: { $value: "32px" }
        }
      },
      dimensions: {
        $type: "dimension",
        unit: {
          $extensions: {
            "com.appcues.theme.preset": "M"
          },
          0: { $value: "0px" },
          1: { $value: "8px" },
          2: { $value: "12px" },
          3: { $value: "16px" },
          4: { $value: "20px" },
          5: { $value: "24px" }
        }
      },
      parts: {
        container: {
          "corner-radius": { $type: "dimension", $value: "8px" },
          padding: { $type: "dimension", $value: "{dimensions.unit.3}" },
          "shadow-radius": { $type: "dimension", $value: "6px" }
        }
      }
    },
    components: {
      container: {
        modal: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              cornerRadius: "{parts.container.corner-radius}",
              paddingBottom: "{parts.container.padding}",
              shadow: {
                color: { light: "#00000029" },
                radius: "{parts.container.shadow-radius}",
                x: "0px",
                y: "3px"
              }
            },
            backdrop: {
              $style: {
                backgroundColor: { light: "{colors.utility.backdrop}" }
              }
            }
          }
        },
        tooltip: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              cornerRadius: "{parts.container.corner-radius}",
              shadow: {
                color: { light: "#00000029" },
                radius: "{parts.container.shadow-radius}",
                x: "0px",
                y: "3px"
              },
              width: "300px"
            },
            backdrop: {
              $style: {
                backgroundColor: { light: "{colors.utility.backdrop}" }
              }
            },
            pointer: {
              $style: {
                pointerBase: "24px",
                pointerLength: "12px"
              }
            }
          }
        },
        embed: {
          default: {
            $style: {
              backgroundColor: { light: "{colors.background}" },
              paddingBottom: "{parts.container.padding}",
              cornerRadius: "{parts.container.corner-radius}"
            }
          }
        }
      },
      text: {
        default: {
          $style: {
            fontFamily: "{font.family.base}",
            fontWeight: "{font.weight.regular}",
            fontSize: "{font.size.regular}",
            textAlignment: "center",
            horizontalAlignment: "center",
            foregroundColor: { light: "{colors.foreground}" },
            marginTop: "{dimensions.unit.1}",
            marginBottom: "{dimensions.unit.1}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}"
          }
        }
      },
      button: {
        default: {
          $style: {
            backgroundColor: { light: "{colors.primary}" },
            cornerRadius: "{parts.container.corner-radius}",
            marginTop: "{dimensions.unit.1}",
            marginBottom: "{dimensions.unit.1}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}",
            paddingTop: "{dimensions.unit.2}",
            paddingBottom: "{dimensions.unit.2}",
            paddingLeading: "{dimensions.unit.5}",
            paddingTrailing: "{dimensions.unit.5}"
          },
          text: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.primary-contrast}" }
            }
          }
        }
      },
      hero: {
        default: {
          $style: {
            backgroundColor: { light: "{colors.primary}" }
          },
          title: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.bold}",
              fontSize: "{font.size.large}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              textAlignment: "center",
              marginTop: "{dimensions.unit.5}",
              marginBottom: "{dimensions.unit.3}",
              marginLeading: "{dimensions.unit.3}",
              marginTrailing: "{dimensions.unit.3}"
            }
          },
          subtitle: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.medium}",
              fontSize: "{font.size.large}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              textAlignment: "center",
              marginBottom: "{dimensions.unit.5}",
              marginLeading: "{dimensions.unit.3}",
              marginTrailing: "{dimensions.unit.3}"
            }
          }
        }
      },
      image: {
        default: {
          $style: {}
        }
      },
      imagewithtext: {
        default: {
          $style: {
            paddingTop: "{dimensions.unit.1}",
            paddingBottom: "{dimensions.unit.1}",
            paddingLeading: "{dimensions.unit.3}",
            paddingTrailing: "{dimensions.unit.3}"
          },
          image: {
            $style: {
              marginTrailing: "{dimensions.unit.1}",
              width: "56px"
            }
          },
          title: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.bold}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              horizontalAlignment: "leading"
            }
          },
          subtitle: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              horizontalAlignment: "leading"
            }
          }
        }
      },
      select: {
        default: {
          $style: {
            marginBottom: "{dimensions.unit.2}",
            marginLeading: "{dimensions.unit.2}",
            marginTop: "{dimensions.unit.2}",
            marginTrailing: "{dimensions.unit.2}"
          },
          colors: {
            $style: {
              accentColor: { light: "#ffffff" },
              selectedColor: { light: "{colors.foreground}" },
              unselectedColor: { light: "{colors.utility.unselected}" }
            }
          },
          label: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              marginBottom: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          errorLabel: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.small}",
              foregroundColor: { light: "{colors.utility.error}" },
              marginTop: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          optionContent: {
            $style: {
              foregroundColor: { light: "{colors.foreground}" },
              textAlignment: "leading",
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}"
            }
          },
          ratingNumberContent: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.primary}" },
              borderColor: { light: "{colors.primary}" }
            }
          },
          ratingNumberContentSelected: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.primary-contrast}" },
              backgroundColor: { light: "{colors.primary}" },
              borderColor: { light: "{colors.primary}" }
            }
          },
          ratingStarContent: {
            $style: {
              foregroundColor: { light: "{colors.primary}" }
            }
          },
          ratingStarContentSelected: {
            $style: {
              foregroundColor: { light: "{colors.primary}" }
            }
          },
          ratingEmojiContent: {
            $style: {
              foregroundColor: { light: "{colors.foreground}" }
            }
          },
          ratingEmojiContentSelected: {
            $style: {
              backgroundColor: { light: "{colors.foreground}" },
              foregroundColor: { light: "{colors.foreground}" }
            }
          }
        }
      },
      textinput: {
        default: {
          $style: {
            marginTop: "{dimensions.unit.2}",
            marginBottom: "{dimensions.unit.2}",
            marginLeading: "{dimensions.unit.3}",
            marginTrailing: "{dimensions.unit.3}"
          },
          label: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              foregroundColor: { light: "{colors.foreground}" },
              marginBottom: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          errorLabel: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.small}",
              foregroundColor: { light: "{colors.utility.error}" },
              marginTop: "{dimensions.unit.2}",
              horizontalAlignment: "leading",
              textAlignment: "leading"
            }
          },
          placeholder: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              foregroundColor: { light: "{colors.utility.unselected}" }
            }
          },
          textField: {
            $style: {
              fontFamily: "{font.family.base}",
              fontWeight: "{font.weight.regular}",
              fontSize: "{font.size.regular}",
              borderColor: { light: "{colors.utility.unselected}" },
              borderWidth: "0.5px",
              cornerRadius: "4px",
              foregroundColor: { light: "{colors.foreground}" }
            }
          }
        }
      },
      web: {
        embed: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              borderRadius: "{parts.container.corner-radius}",
              color: "{colors.foreground}",
              padding: "0px"
            }
          }
        },
        modal: {
          default: {
            $style: {
              backgroundColor: "{colors.background}",
              border: "none",
              borderRadius: "{parts.container.corner-radius}",
              boxShadow: "0px 6px 16px 0px rgba(0, 0, 0, 0.2)",
              color: "{colors.foreground}",
              height: "360px",
              padding: "0px",
              width: "720px"
            }
          }
        },
        button: {
          default: {
            $style: {
              backgroundColor: "{colors.primary}",
              borderStyle: "none",
              borderWidth: "0px",
              borderColor: "unset",
              borderRadius: "{parts.container.corner-radius}",
              color: "{colors.primary-contrast}",
              cursor: "pointer",
              flexGrow: "0",
              // TODO: figure out fonts
              // fontFamily: '{font.family.base}',
              // fontWeight: '{font.weight.regular}',
              fontSize: "{font.size.small}",
              height: "fit-content",
              marginTop: "0px",
              marginBottom: "0px",
              marginInlineStart: "{dimensions.unit.3}",
              marginInlineEnd: "{dimensions.unit.3}",
              paddingTop: "{dimensions.unit.2}",
              paddingBottom: "{dimensions.unit.2}",
              paddingInlineStart: "{dimensions.unit.3}",
              paddingInlineEnd: "{dimensions.unit.3}",
              textAlign: "center",
              textDecoration: "none",
              transition: "background-color 0.15s ease-out 0s, box-shadow 0.15s ease-out 0s, outline-color 0.15s ease-out 0s",
              width: "fit-content",
              state: {
                hover: {
                  backgroundColor: "{colors.primary}"
                }
              }
            }
          }
        },
        img: {
          default: {
            $style: {
              height: "100%",
              width: "100%"
            }
          }
        },
        p: {
          default: {
            $style: {
              fontFamily: "Arial, sans-serif",
              fontWeight: "unset",
              textAlign: "center",
              margin: "0px",
              color: "{colors.foreground}",
              fontSize: "{font.size.regular}"
            }
          }
        },
        h1: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "Arial, sans-serif",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h1}",
              color: "{colors.foreground}"
            }
          }
        },
        h2: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "Arial, sans-serif",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h2}",
              color: "{colors.foreground}"
            }
          }
        },
        h3: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "Arial, sans-serif",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h3}",
              color: "{colors.foreground}"
            }
          }
        },
        h4: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "Arial, sans-serif",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h4}",
              color: "{colors.foreground}"
            }
          }
        },
        h5: {
          default: {
            $style: {
              margin: "0px",
              fontFamily: "Arial, sans-serif",
              fontWeight: "bold",
              textAlign: "center",
              fontSize: "{font.size.h5}",
              color: "{colors.foreground}"
            }
          }
        }
      }
    }
  }
};

// src/model/migrations/index.ts
import { set as set2 } from "object-path-immutable";

// src/model/migrations/migrations.ts
import { get as get7 } from "object-path-immutable";

// src/model/migrations/utils.ts
import { get as get6, set } from "object-path-immutable";
var setIfMissing = (theme, path, value) => {
  const existing = get6(theme, path);
  if (existing !== void 0) {
    return theme;
  }
  return set(theme, path, value);
};
var addVariantIfMissing = (theme, variant, variantDefinition) => {
  const path = `content.components.${variant}`;
  return setIfMissing(theme, path, variantDefinition);
};

// src/model/migrations/migrations.ts
var migrations = [
  {
    // Version 1: Baseline - Establishes the initial schema version
    version: 1,
    migrate: (theme) => theme
  },
  {
    // Version 2: 2026-01 - Initial experience-builder components
    version: 2,
    migrate: (theme) => {
      const addedVariants = [
        ["web.modal.default", base_theme_default.content.components.web.modal.default],
        ["web.button.default", base_theme_default.content.components.web.button.default],
        ["web.img.default", base_theme_default.content.components.web.img.default]
      ];
      return addedVariants.reduce(
        (migratedTheme, [variant, definition]) => addVariantIfMissing(migratedTheme, variant, definition),
        theme
      );
    }
  },
  {
    // Version 3: 2026-01 - Rich text components (p, h1-h5) and heading font size tokens
    version: 3,
    migrate: (theme) => {
      const addedVariants = [
        ["web.p.default", base_theme_default.content.components.web.p.default],
        ["web.h1.default", base_theme_default.content.components.web.h1.default],
        ["web.h2.default", base_theme_default.content.components.web.h2.default],
        ["web.h3.default", base_theme_default.content.components.web.h3.default],
        ["web.h4.default", base_theme_default.content.components.web.h4.default],
        ["web.h5.default", base_theme_default.content.components.web.h5.default]
      ];
      let migratedTheme = addedVariants.reduce(
        (acc, [variant, definition]) => addVariantIfMissing(acc, variant, definition),
        theme
      );
      const rawPreset = get7(theme, [
        "content",
        "tokens",
        "font",
        "size",
        "$extensions",
        TOKEN_EXTENSIONS.PRESET
      ]);
      const currentPreset = PRESET_SIZES.includes(rawPreset) ? rawPreset : "M";
      const fontSizeTokens = presetFontSizes(currentPreset);
      const headingFontSizeTokens = ["h1", "h2", "h3", "h4", "h5"];
      migratedTheme = headingFontSizeTokens.reduce(
        (acc, token) => setIfMissing(
          acc,
          `content.tokens.font.size.${token}`,
          fontSizeTokens[token]
        ),
        migratedTheme
      );
      return migratedTheme;
    }
  },
  {
    // Version 4: 2026-02 - Embed web component variant
    version: 4,
    migrate: (theme) => {
      return addVariantIfMissing(
        theme,
        "web.embed.default",
        base_theme_default.content.components.web.embed.default
      );
    }
  }
];

// src/model/migrations/index.ts
var CURRENT_SCHEMA_VERSION = migrations.length > 0 ? Math.max(...migrations.map((m) => m.version)) : 0;
var getSchemaVersion = (theme) => {
  const meta = theme.content?.meta;
  return meta?.schemaVersion ?? 0;
};
var isThemeCurrent = (theme) => {
  return getSchemaVersion(theme) >= CURRENT_SCHEMA_VERSION;
};
var migrateTheme = (theme) => {
  const currentVersion = getSchemaVersion(theme);
  if (currentVersion >= CURRENT_SCHEMA_VERSION) {
    return theme;
  }
  const pendingMigrations = migrations.filter((m) => m.version > currentVersion).sort((a, b) => a.version - b.version);
  const migratedTheme = pendingMigrations.reduce(
    (currentTheme, migration) => migration.migrate(currentTheme),
    theme
  );
  return set2(
    migratedTheme,
    "content.meta.schemaVersion",
    CURRENT_SCHEMA_VERSION
  );
};
export {
  Context_default as Context,
  ThemeEditor,
  Provider as ThemeEditorProvider,
  base_theme_default as baseTheme,
  isThemeCurrent,
  migrateTheme,
  useThemeEditor
};
//# sourceMappingURL=index.mjs.map